import { FieldsManager, PropTypes as PropTypes$1 } from '@micromag/core';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { v1, v4 } from 'uuid';
import React, { useMemo, useCallback, useState, useRef, useEffect, useId } from 'react';
import PropTypes from 'prop-types';
import { useFieldsManager, useFieldComponent, useFieldContext, FieldsValueContextProvider, useGetColors, FieldContextProvider, useFonts, useGoogleMapsClient, useFieldsValue, useScreenDefinition, ComponentsProvider, FIELDS_NAMESPACE, FieldsProvider as FieldsProvider$1 } from '@micromag/core/contexts';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import { Label, Button, Empty, ClearButton, Modal, ModalDialog, PlaceholderImage, PlaceholderText, PlaceholderTitle, ScreenPlaceholder, LinkStyle, HighlightStyle } from '@micromag/core/components';
import isObject from 'lodash/isObject';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faDotCircle } from '@fortawesome/free-solid-svg-icons/faDotCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { createNullableOnChange, isMessage, getFileName, getStyleFromBox, getStyleFromColor, getFontFamilyFromFont, getGridLayoutName, getShadowCoords, getColorAsString, getStyleFromLink, getStyleFromHighlight, getStyleFromText } from '@micromag/core/utils';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons/faSlidersH';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import isFunction from 'lodash/isFunction';
import { ReactSortable } from 'react-sortablejs';
import get from 'lodash/get';
import MediaGallery from '@micromag/media-gallery';
import isString from 'lodash/isString';
import Fuse from 'fuse.js';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import Slider from 'rc-slider';
import tinycolor from 'tinycolor2';
import { SketchPicker } from 'react-color';
import { useLoadedFonts } from '@micromag/core/hooks';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faBold } from '@fortawesome/free-solid-svg-icons/faBold';
import { faItalic } from '@fortawesome/free-solid-svg-icons/faItalic';
import { faUnderline } from '@fortawesome/free-solid-svg-icons/faUnderline';
import { faAlignCenter } from '@fortawesome/free-solid-svg-icons/faAlignCenter';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons/faAlignLeft';
import { faAlignRight } from '@fortawesome/free-solid-svg-icons/faAlignRight';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import Map, { Pin } from '@micromag/element-map';
import Grid from '@micromag/element-grid';
import Keypad from '@micromag/element-keypad';
import _typeof from '@babel/runtime/helpers/typeof';
import isEqual from 'lodash/isEqual';
import Select from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { getCSRFHeaders } from '@folklore/fetch';
import { useUppyConfig } from '@panneau/uppy';
import Switch from 'rc-switch';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

var audio = {
  id: 'audio',
  component: 'media-modal',
  media: true,
  type: 'audio'
};

var audioElement = {
  id: 'audio-element',
  fields: [{
    name: 'media',
    type: 'audio'
  }],
  settings: [{
    name: 'autoPlay',
    type: 'toggle',
    label: defineMessage({
      id: "pJgYyE",
      defaultMessage: [{
        "type": 0,
        "value": "AutoPlay"
      }]
    })
  }, {
    name: 'loop',
    type: 'toggle',
    label: defineMessage({
      id: "F2SD/0",
      defaultMessage: [{
        "type": 0,
        "value": "Loop"
      }]
    })
  }, {
    name: 'withWave',
    type: 'toggle',
    label: defineMessage({
      id: "c7rrcG",
      defaultMessage: [{
        "type": 0,
        "value": "With animated wave"
      }]
    })
  }, {
    name: 'withControls',
    type: 'toggle',
    label: defineMessage({
      id: "BwYZbB",
      defaultMessage: [{
        "type": 0,
        "value": "With controls button"
      }]
    })
  }, {
    name: 'withSeekBar',
    type: 'toggle',
    label: defineMessage({
      id: "T0pi1u",
      defaultMessage: [{
        "type": 0,
        "value": "With seek bar"
      }]
    })
  }, {
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "Rl7C1A",
      defaultMessage: [{
        "type": 0,
        "value": "Controls color"
      }]
    })
  }, {
    name: 'progressColor',
    type: 'color',
    label: defineMessage({
      id: "v1r3AA",
      defaultMessage: [{
        "type": 0,
        "value": "Progress bar color"
      }]
    })
  }, {
    name: 'captions',
    type: 'captions',
    label: defineMessage({
      id: "4H2n5r",
      defaultMessage: [{
        "type": 0,
        "value": "Closed captions"
      }]
    })
  }]
};

var alignHorizontal = {
  id: 'align-horizontal',
  component: 'align-horizontal'
};

var alignVertical = {
  id: 'align-vertical',
  component: 'align-vertical'
};

var alignment = {
  id: 'alignment',
  component: 'alignment',
  fields: [alignHorizontal, alignVertical]
};

var answer = {
  id: 'answer',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'result',
    type: 'text-element',
    label: defineMessage({
      id: "Lz2+Ws",
      defaultMessage: [{
        "type": 0,
        "value": "Answer feedback"
      }]
    })
  }, {
    type: 'fields',
    isList: true,
    fields: [
    // Removed cause redundant with text-element styles
    // {
    //     name: 'textStyle',
    //     type: 'text-style-form',
    //     label: defineMessage({
    //         defaultMessage: 'Button text style',
    //         description: 'Field label',
    //     }),
    // },
    {
      type: 'box-style-form',
      name: 'buttonStyle',
      label: defineMessage({
        id: "nno1Pq",
        defaultMessage: [{
          "type": 0,
          "value": "Button style"
        }]
      })
    }, {
      name: 'resultStyle',
      type: 'graph-bar-style',
      isList: true,
      label: defineMessage({
        id: "6Q4tcn",
        defaultMessage: [{
          "type": 0,
          "value": "Result style"
        }]
      })
    }]
  }]
};

var answers = {
  id: 'answers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "A+a0kL",
    defaultMessage: [{
      "type": 0,
      "value": "No answer..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "lGh/NP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an answer"
    }]
  }),
  itemsField: {
    type: 'answer',
    breadcrumbLabel: defineMessage({
      id: "XJ2Xc+",
      defaultMessage: [{
        "type": 0,
        "value": "Answer"
      }]
    })
  }
};

var authorElement = {
  id: 'author-element',
  component: 'field-with-form',
  labelPath: 'name.body',
  fields: [{
    name: 'name',
    type: 'text-element',
    label: defineMessage({
      id: "UUv8FR",
      defaultMessage: [{
        "type": 0,
        "value": "Name"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'url',
    type: 'url',
    label: defineMessage({
      id: "ACSasN",
      defaultMessage: [{
        "type": 0,
        "value": "URL"
      }]
    })
  }, {
    name: 'collaborator',
    type: 'text-element',
    label: defineMessage({
      id: "iL9RLu",
      defaultMessage: [{
        "type": 0,
        "value": "Collaborator"
      }]
    })
  }]
};

var background = {
  id: 'background',
  isList: true,
  fields: [{
    name: 'color',
    type: 'color',
    withoutCaret: true,
    label: defineMessage({
      id: "aarOkd",
      defaultMessage: [{
        "type": 0,
        "value": "Color"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "KuzZbb",
      defaultMessage: [{
        "type": 0,
        "value": "Background color"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "vxEtY1",
      defaultMessage: [{
        "type": 0,
        "value": "Background image"
      }]
    })
  }, {
    name: 'video',
    type: 'video',
    label: defineMessage({
      id: "vERejo",
      defaultMessage: [{
        "type": 0,
        "value": "Video"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "dCG1T1",
      defaultMessage: [{
        "type": 0,
        "value": "Background video"
      }]
    })
  }],
  settings: [{
    type: 'fields',
    isList: true,
    fields: [{
      name: 'fit',
      type: 'fit',
      label: defineMessage({
        id: "amEvH1",
        defaultMessage: [{
          "type": 0,
          "value": "Fit"
        }]
      })
    }, {
      name: 'repeat',
      type: 'toggle',
      label: defineMessage({
        id: "WlNxMj",
        defaultMessage: [{
          "type": 0,
          "value": "Repeat"
        }]
      })
    }, {
      name: 'forceMuted',
      type: 'toggle',
      label: defineMessage({
        id: "hUUIQt",
        defaultMessage: [{
          "type": 0,
          "value": "Mute audio of background video"
        }]
      })
    }]
  }]
};

var backgroundRecommendation = {
  id: 'background-recommendation',
  isList: true,
  fields: [{
    name: 'color',
    type: 'color',
    withoutCaret: true,
    label: defineMessage({
      id: "aarOkd",
      defaultMessage: [{
        "type": 0,
        "value": "Color"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "KuzZbb",
      defaultMessage: [{
        "type": 0,
        "value": "Background color"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "vxEtY1",
      defaultMessage: [{
        "type": 0,
        "value": "Background image"
      }]
    })
  }, {
    name: 'video',
    type: 'video',
    label: defineMessage({
      id: "vERejo",
      defaultMessage: [{
        "type": 0,
        "value": "Video"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "dCG1T1",
      defaultMessage: [{
        "type": 0,
        "value": "Background video"
      }]
    })
  }, {
    name: 'forceMuted',
    type: 'toggle',
    label: defineMessage({
      id: "hUUIQt",
      defaultMessage: [{
        "type": 0,
        "value": "Mute audio of background video"
      }]
    })
  }, {
    name: 'text',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "KvBdrU",
      defaultMessage: [{
        "type": 0,
        "value": "Background text"
      }]
    })
  }]
};

var badge = {
  id: 'badge',
  component: 'badge',
  fields: [{
    name: 'active',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "B5C18D",
      defaultMessage: [{
        "type": 0,
        "value": "Badge"
      }]
    })
  }, {
    name: 'label',
    type: 'text-element',
    withoutLink: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "6MxaVf",
      defaultMessage: [{
        "type": 0,
        "value": "Style"
      }]
    })
  }]
};

var borderRadius = {
  id: 'border-radius',
  component: 'border-radius'
};

var borderStyle = {
  id: 'border-style',
  component: 'border-style'
};

var borderWidth = {
  id: 'border-width',
  component: 'border-width'
};

var def$5 = {
  id: 'box-style',
  canClear: true,
  fields: [{
    type: 'fields',
    isList: true,
    label: defineMessage({
      id: "f5Yipd",
      defaultMessage: [{
        "type": 0,
        "value": "Box"
      }]
    }),
    fields: [{
      name: 'backgroundColor',
      label: defineMessage({
        id: "JDPMlG",
        defaultMessage: [{
          "type": 0,
          "value": "Background color"
        }]
      }),
      type: 'color'
    }, {
      name: 'borderRadius',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 2, 4, 6, 8, 10, 16, 20, 24, 30],
      label: defineMessage({
        id: "xKG76H",
        defaultMessage: [{
          "type": 0,
          "value": "Rounded corners"
        }]
      })
    }, {
      name: 'padding',
      type: 'padding',
      isHorizontal: true,
      label: defineMessage({
        id: "qhjeuO",
        defaultMessage: [{
          "type": 0,
          "value": "Padding"
        }]
      })
    }]
  }, {
    type: 'fields',
    label: defineMessage({
      id: "862eE3",
      defaultMessage: [{
        "type": 0,
        "value": "Border"
      }]
    }),
    isList: true,
    fields: [{
      name: 'borderWidth',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 1, 2, 3, 4, 5],
      label: defineMessage({
        id: "g2CRt5",
        defaultMessage: [{
          "type": 0,
          "value": "Size"
        }]
      })
    }, {
      name: 'borderColor',
      type: 'color',
      disableAlpha: true,
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'borderStyle',
      type: 'border-style',
      label: defineMessage({
        id: "6MxaVf",
        defaultMessage: [{
          "type": 0,
          "value": "Style"
        }]
      })
    }]
  }, {
    type: 'fields',
    label: defineMessage({
      id: "udLCuY",
      defaultMessage: [{
        "type": 0,
        "value": "Shadow"
      }]
    }),
    isList: true,
    fields: [{
      name: 'shadowDistance',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 1, 2, 3, 4, 5],
      label: defineMessage({
        id: "irG6mX",
        defaultMessage: [{
          "type": 0,
          "value": "Distance"
        }]
      })
    }, {
      name: 'shadowBlur',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 1, 2, 3, 4, 5],
      label: defineMessage({
        id: "TZUu3s",
        defaultMessage: [{
          "type": 0,
          "value": "Blur"
        }]
      })
    }, {
      name: 'shadowColor',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      }),
      type: 'color'
    }, {
      name: 'shadowAngle',
      type: 'shadow-angle',
      label: defineMessage({
        id: "3LEBIA",
        defaultMessage: [{
          "type": 0,
          "value": "Angle"
        }]
      })
    }]
  }]
};

var fields$6 = def$5.fields;
var boxStyleForm = {
  id: 'box-style-form',
  component: 'box-style-form',
  canClear: true,
  fields: fields$6
};

var button = {
  id: 'button',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    }),
    withSettings: false
  }, {
    name: 'visual',
    type: 'visual',
    label: defineMessage({
      id: "HwqzVR",
      defaultMessage: [{
        "type": 0,
        "value": "Visual"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "nno1Pq",
      defaultMessage: [{
        "type": 0,
        "value": "Button style"
      }]
    })
  },
  // If necessary some day
  // {
  //     name: 'alignment',
  //     type: 'alignment',
  //     label: defineMessage({
  //         defaultMessage: 'Button alignment',
  //         description: 'Field label',
  //     }),
  // },
  {
    name: 'url',
    type: 'url',
    label: defineMessage({
      id: "mXeSkg",
      defaultMessage: [{
        "type": 0,
        "value": "Link"
      }]
    })
  }, {
    name: 'inWebView',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "/W31TQ",
      defaultMessage: [{
        "type": 0,
        "value": "Embedded browser"
      }]
    })
  }]
};

var buttonLayout = {
  id: 'button-layout',
  component: 'button-layout'
};

var buttons = {
  id: 'buttons',
  component: 'items',
  noItemLabel: defineMessage({
    id: "CWnXWp",
    defaultMessage: [{
      "type": 0,
      "value": "No button yet"
    }]
  }),
  addItemLabel: defineMessage({
    id: "LrRW+9",
    defaultMessage: [{
      "type": 0,
      "value": "Add a button"
    }]
  }),
  itemsField: {
    type: 'button',
    breadcrumbLabel: defineMessage({
      id: "f1XHNG",
      defaultMessage: [{
        "type": 0,
        "value": "Button"
      }]
    })
  }
};

var buttonElement = {
  id: 'button-element',
  component: 'text-element',
  inline: true,
  withoutLink: true,
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }, {
    name: 'buttonStyle',
    type: 'box-style',
    className: 'mt-4'
  }]
};

var buttonLink = {
  id: 'button-link',
  isList: true,
  component: 'fields',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'url',
    type: 'url',
    // isHorizontal: true,
    label: defineMessage({
      id: "mXeSkg",
      defaultMessage: [{
        "type": 0,
        "value": "Link"
      }]
    })
  }, {
    name: 'inWebView',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "/W31TQ",
      defaultMessage: [{
        "type": 0,
        "value": "Embedded browser"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "i6bmbD",
      defaultMessage: [{
        "type": 0,
        "value": "Button"
      }]
    })
  }]
};

var captions = {
  id: 'captions',
  isList: true,
  fields: [{
    name: 'media',
    type: 'closed-captions',
    label: defineMessage({
      id: "ivs8GN",
      defaultMessage: [{
        "type": 0,
        "value": "Closed captions file"
      }]
    })
  }, {
    name: 'textStyle',
    type: 'text-style-form',
    excludedFields: ['link', 'highlight'],
    label: defineMessage({
      id: "OEckOD",
      defaultMessage: [{
        "type": 0,
        "value": "Text style"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "p1pghO",
      defaultMessage: [{
        "type": 0,
        "value": "Box style"
      }]
    })
  }]
};

var def$4 = {
  id: 'call-to-action',
  component: 'call-to-action',
  fields: [{
    name: 'active',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "eBFxNl",
      defaultMessage: [{
        "type": 0,
        "value": "Call to Action"
      }]
    })
  }, {
    name: 'type',
    type: 'radios',
    options: [{
      value: 'swipe-up',
      label: defineMessage({
        id: "OSl7A6",
        defaultMessage: [{
          "type": 0,
          "value": "Swipe up"
        }]
      })
    }, {
      value: 'button',
      label: defineMessage({
        id: "i6bmbD",
        defaultMessage: [{
          "type": 0,
          "value": "Button"
        }]
      })
    }],
    firstOptionAsDefault: true,
    isHorizontal: true,
    label: defineMessage({
      id: "iipV5Q",
      defaultMessage: [{
        "type": 0,
        "value": "Type"
      }]
    })
  }, {
    name: 'inWebView',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "/W31TQ",
      defaultMessage: [{
        "type": 0,
        "value": "Embedded browser"
      }]
    })
  }, {
    name: 'url',
    type: 'url',
    // isHorizontal: true,
    label: defineMessage({
      id: "mXeSkg",
      defaultMessage: [{
        "type": 0,
        "value": "Link"
      }]
    })
  }, {
    name: 'label',
    type: 'text-element',
    withoutLink: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "i6bmbD",
      defaultMessage: [{
        "type": 0,
        "value": "Button"
      }]
    })
  }]
};

var fields$5 = def$4.fields;
var callToActionForm = {
  id: 'call-to-action-form',
  component: 'call-to-action-form',
  fields: fields$5
};

var customAnswer = {
  id: 'custom-answer',
  component: 'custom-answer',
  fields: [{
    name: 'active',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "yGd82s",
      defaultMessage: [{
        "type": 0,
        "value": "Custom answer"
      }]
    })
  }, {
    name: 'multiline',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "K7AvPE",
      defaultMessage: [{
        "type": 0,
        "value": "Multiline input"
      }]
    })
  }, {
    name: 'placeholder',
    type: 'text-element',
    withoutLink: true,
    textOnly: true,
    inline: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['link', 'highlight']
      }
    },
    label: defineMessage({
      id: "trSRbk",
      defaultMessage: [{
        "type": 0,
        "value": "Placeholder"
      }]
    })
  }, {
    name: 'submit',
    type: 'button-element',
    withoutLink: true,
    textOnly: true,
    label: defineMessage({
      id: "JMmYwg",
      defaultMessage: [{
        "type": 0,
        "value": "Submit button"
      }]
    })
  }, {
    name: 'textStyle',
    type: 'text-style-form',
    excludedFields: ['link', 'highlight'],
    label: defineMessage({
      id: "OEckOD",
      defaultMessage: [{
        "type": 0,
        "value": "Text style"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "p1pghO",
      defaultMessage: [{
        "type": 0,
        "value": "Box style"
      }]
    })
  }]
};

var dateElement = {
  id: 'date-element',
  component: 'date-element',
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }]
};

var date = {
  id: 'date',
  component: 'date',
  withTime: false
};

var datetime = {
  id: 'datetime',
  component: 'date',
  withTime: true
};

var def$3 = {
  id: 'share-incentive',
  component: 'share-incentive',
  fields: [{
    name: 'active',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "uaL28k",
      defaultMessage: [{
        "type": 0,
        "value": "Share Incentive"
      }]
    })
  }, {
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "p1pghO",
      defaultMessage: [{
        "type": 0,
        "value": "Box style"
      }]
    })
  }]
};

var fields$4 = def$3.fields;
var shareIncentiveForm = {
  id: 'share-incentive-form',
  component: 'share-incentive-form',
  fields: fields$4
};

var cardLayout = {
  id: 'card-layout',
  component: 'card-layout'
};

var checkboxes = {
  id: 'checkboxes',
  component: 'checkboxes'
};

var closedCaptions = {
  id: 'closed-captions',
  component: 'closed-captions'
};

var color = {
  id: 'color',
  component: 'color',
  canClear: true
};

var conversation = {
  id: 'conversation',
  component: 'conversation',
  fields: [{
    name: 'speakers',
    type: 'speakers',
    label: defineMessage({
      id: "JC9Qlf",
      defaultMessage: [{
        "type": 0,
        "value": "Speakers"
      }]
    })
  }, {
    name: 'messages',
    type: 'messages',
    label: defineMessage({
      id: "f68O+0",
      defaultMessage: [{
        "type": 0,
        "value": "Messages"
      }]
    })
  }],
  settings: [{
    name: 'messageStyle',
    type: 'text-style',
    label: defineMessage({
      id: "k81FRn",
      defaultMessage: [{
        "type": 0,
        "value": "Message style"
      }]
    })
  }, {
    name: 'speakerStyle',
    type: 'text-style',
    className: 'mt-4',
    label: defineMessage({
      id: "9PfjeE",
      defaultMessage: [{
        "type": 0,
        "value": "Speaker style"
      }]
    })
  }]
};

var email = {
  id: 'email',
  component: 'text',
  type: 'email'
};

var entries = {
  id: 'entries',
  component: 'items',
  noItemLabel: defineMessage({
    id: "iHV3W3",
    defaultMessage: [{
      "type": 0,
      "value": "No entry..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "l/Y6or",
    defaultMessage: [{
      "type": 0,
      "value": "Add an entry"
    }]
  }),
  itemsField: {
    type: 'entry',
    breadcrumbLabel: defineMessage({
      id: "X97njD",
      defaultMessage: [{
        "type": 0,
        "value": "Entry"
      }]
    })
  }
};

var entriesWithImage = _objectSpread(_objectSpread({}, entries), {}, {
  id: 'entries-with-image',
  itemsField: {
    type: 'entry-with-image',
    breadcrumbLabel: defineMessage({
      id: "X97njD",
      defaultMessage: [{
        "type": 0,
        "value": "Entry"
      }]
    })
  }
});

var entriesWithVisual = _objectSpread(_objectSpread({}, entries), {}, {
  id: 'entries-with-visual',
  itemsField: {
    type: 'entry-with-visual',
    breadcrumbLabel: defineMessage({
      id: "X97njD",
      defaultMessage: [{
        "type": 0,
        "value": "Entry"
      }]
    })
  }
});

var entry = {
  id: 'entry',
  component: 'field-with-form',
  labelPath: 'title.body',
  fields: [{
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text-element',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }]
};

var entryWithImage = _objectSpread(_objectSpread({}, entry), {}, {
  id: 'entry-with-image',
  fields: [].concat(_toConsumableArray(entry.fields), [{
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }])
});

var entryWithVisual = _objectSpread(_objectSpread({}, entry), {}, {
  id: 'entry-with-visual',
  fields: [].concat(_toConsumableArray(entry.fields), [{
    name: 'image',
    type: 'visual',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }])
});

var fieldWithForm = {
  id: 'field-with-form',
  component: 'field-with-form'
};

var fields$3 = {
  id: 'fields',
  component: 'fields'
};

var fit = {
  id: 'fit',
  component: 'fit'
};

var font = {
  id: 'font',
  component: 'font',
  media: true
};

var fonts = {
  id: 'fonts',
  component: 'fonts',
  itemsField: {
    type: 'font'
  }
};

var fontFamily = {
  id: 'font-family',
  component: 'font-family',
  canClear: true
};

var fontSize = {
  id: 'font-size',
  component: 'font-size'
};

var fontWeight = {
  id: 'font-weight',
  // component: 'font-weight',
  component: 'number-with-icon',
  icon: {
    icon: [48, 48, [], 'f067', 'M12 14h5l-7-7-7 7h5v20h-5l7 7 7-7h-5v-20zm8-4v4h24v-4h-24zm0 28h24v-4h-24v4zm0-12h24v-4h-24v4z'],
    iconName: 'font',
    prefix: 'fas'
  },
  dataList: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  "float": true
};

var footer = {
  id: 'footer',
  isList: true,
  fields: [{
    name: 'callToAction',
    type: 'call-to-action'
  }]
  // settings: [],
};

var gameSortItem = {
  id: 'game-sort-item',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    }),
    withSettings: false
  }, {
    name: 'visual',
    type: 'visual',
    label: defineMessage({
      id: "HwqzVR",
      defaultMessage: [{
        "type": 0,
        "value": "Visual"
      }]
    })
  }, {
    name: 'results',
    type: 'text-element',
    label: defineMessage({
      id: "e4UTx9",
      defaultMessage: [{
        "type": 0,
        "value": "Results"
      }]
    }),
    withSettings: false
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "nno1Pq",
      defaultMessage: [{
        "type": 0,
        "value": "Button style"
      }]
    })
  }]
};

var gameSortItems = {
  id: 'game-sort-items',
  component: 'items',
  noItemLabel: defineMessage({
    id: "PAQRf4",
    defaultMessage: [{
      "type": 0,
      "value": "No item yet"
    }]
  }),
  addItemLabel: defineMessage({
    id: "k4gTZl",
    defaultMessage: [{
      "type": 0,
      "value": "Add an item"
    }]
  }),
  itemsField: {
    type: 'game-sort-item',
    breadcrumbLabel: defineMessage({
      id: "8ySjDc",
      defaultMessage: [{
        "type": 0,
        "value": "Item"
      }]
    })
  }
};

var geoPosition = {
  id: 'geo-position',
  component: 'geo-position'
};

var def$2 = {
  id: 'graph-bar-style',
  isList: true,
  fields: [{
    name: 'barColor',
    type: 'color',
    label: defineMessage({
      id: "qjL/eA",
      defaultMessage: [{
        "type": 0,
        "value": "Bar"
      }]
    })
  },
  // {
  //     name: 'textColor',
  //     type: 'color',
  //     label: defineMessage({
  //         defaultMessage: 'Text',
  //         description: 'Field label',
  //     }),
  // },
  {
    name: 'percentageTextStyle',
    type: 'text-style-form',
    label: defineMessage({
      id: "S+WiGT",
      defaultMessage: [{
        "type": 0,
        "value": "Percentage Text"
      }]
    })
  }]
};

var fields$2 = def$2.fields;
var graphBarStyleForm = {
  id: 'graph-bar-style-form',
  component: 'field-with-form',
  isList: true,
  fields: fields$2
};

var textElement = {
  id: 'text-element',
  component: 'text-element',
  // inline: true,
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }]
};

var headingElement = _objectSpread(_objectSpread({}, textElement), {}, {
  id: 'heading-element',
  size: 'lg',
  inline: true
});

var header = {
  id: 'header',
  isList: true,
  theme: true,
  fields: [{
    name: 'badge',
    type: 'badge'
  }, {
    name: 'shareIncentive',
    type: 'share-incentive'
  }]
  // settings: [],
};

var imageWithCaption = {
  id: 'image-with-caption',
  component: 'field-with-form',
  labelPath: 'caption.body',
  thumbnailPath: 'media.thumbnail_url',
  fields: [{
    name: 'media',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'caption',
    type: 'text-element',
    label: defineMessage({
      id: "p85qJD",
      defaultMessage: [{
        "type": 0,
        "value": "Caption"
      }]
    })
  }]
};

var image = {
  id: 'image',
  component: 'media-modal',
  media: true,
  type: 'image'
};

var imagesWithCaption = {
  id: 'images-with-caption',
  component: 'items',
  noItemLabel: defineMessage({
    id: "dFMzBu",
    defaultMessage: [{
      "type": 0,
      "value": "No image..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "QSmRdP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an image"
    }]
  }),
  itemsField: {
    type: 'image-with-caption',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var images = {
  id: 'images',
  component: 'images',
  itemsField: {
    type: 'image',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var inputElement = {
  id: 'input-element',
  component: 'input-element',
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }, {
    name: 'buttonStyle',
    type: 'box-style',
    className: 'mt-4'
  }]
};

var items = {
  id: 'items',
  component: 'items'
};

var itemTextStyle = {
  id: 'item-text-style',
  component: 'text-style-form',
  fields: [{
    name: 'style',
    type: 'text-style'
  }]
};

var letterSpacing = {
  id: 'letter-spacing',
  component: 'number-with-icon',
  icon: {
    icon: [48, 48, [], 'f067', 'M12 14h5l-7-7-7 7h5v20h-5l7 7 7-7h-5v-20zm8-4v4h24v-4h-24zm0 28h24v-4h-24v4zm0-12h24v-4h-24v4z'],
    iconName: 'letter-spacing',
    prefix: 'fas'
  },
  iconRotation: -90,
  dataList: [-2, -1.5, -1, -0.5, 0, 0.5, 1, 1.5, 2],
  "float": true
};

var lineHeight = {
  id: 'line-height',
  component: 'number-with-icon',
  icon: {
    icon: [48, 48, [], 'f067', 'M12 14h5l-7-7-7 7h5v20h-5l7 7 7-7h-5v-20zm8-4v4h24v-4h-24zm0 28h24v-4h-24v4zm0-12h24v-4h-24v4z'],
    iconName: 'line-height',
    prefix: 'fas'
  },
  dataList: [1, 1.1, 1.2, 1.3, 1.4, 1.5, 2],
  "float": true
};

var def$1 = {
  id: 'keypad-layout',
  fields: [{
    name: 'columnAlign',
    type: 'align-horizontal',
    defaultValue: 'middle',
    label: defineMessage({
      id: "fOYYk7",
      defaultMessage: [{
        "type": 0,
        "value": "Align items"
      }]
    })
  }, {
    name: 'columns',
    type: 'radios',
    options: [{
      value: 1,
      label: 1
    }, {
      value: 2,
      label: 2
    }, {
      value: 3,
      label: 3
    }, {
      value: 4,
      label: 4
    }],
    label: defineMessage({
      id: "S1F/re",
      defaultMessage: [{
        "type": 0,
        "value": "Columns"
      }]
    })
  }, {
    name: 'spacing',
    type: 'number',
    isHorizontal: true,
    label: defineMessage({
      id: "xmp9nw",
      defaultMessage: [{
        "type": 0,
        "value": "Spacing"
      }]
    })
  }, {
    name: 'withSquareItems',
    type: 'toggle',
    label: defineMessage({
      id: "TTPc+y",
      defaultMessage: [{
        "type": 0,
        "value": "Use square keys"
      }]
    })
  }]
};

var fields$1 = def$1.fields;
var keypadLayoutForm = {
  id: 'keypad-layout-form',
  component: 'keypad-layout-form',
  fields: fields$1
};

var marker = {
  id: 'marker',
  component: 'field-with-form',
  labelPath: 'title.body',
  fields: [{
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text-element',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }, {
    name: 'geoPosition',
    type: 'geo-position',
    label: defineMessage({
      id: "u3ok54",
      defaultMessage: [{
        "type": 0,
        "value": "Position"
      }]
    })
  }]
};

var markerWithImage = {
  id: 'marker-with-image',
  component: 'field-with-form',
  labelPath: 'title.body',
  fields: [{
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text-element',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'geoPosition',
    type: 'geo-position',
    label: defineMessage({
      id: "u3ok54",
      defaultMessage: [{
        "type": 0,
        "value": "Position"
      }]
    })
  }]
};

var markers = {
  id: 'markers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "rdFCsN",
    defaultMessage: [{
      "type": 0,
      "value": "No marker..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "8oczXQ",
    defaultMessage: [{
      "type": 0,
      "value": "Add a marker"
    }]
  }),
  itemsField: {
    type: 'marker',
    breadcrumbLabel: defineMessage({
      id: "qroLmS",
      defaultMessage: [{
        "type": 0,
        "value": "Marker"
      }]
    })
  }
};

var markersWithImage = {
  id: 'markers-with-image',
  component: 'items',
  noItemLabel: defineMessage({
    id: "rdFCsN",
    defaultMessage: [{
      "type": 0,
      "value": "No marker..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "8oczXQ",
    defaultMessage: [{
      "type": 0,
      "value": "Add a marker"
    }]
  }),
  itemsField: {
    type: 'marker-with-image',
    breadcrumbLabel: defineMessage({
      id: "qroLmS",
      defaultMessage: [{
        "type": 0,
        "value": "Marker"
      }]
    })
  }
};

var mapZoom = {
  id: 'map-zoom',
  component: 'number',
  min: 0,
  max: 20
};

var mediaThumbnail = {
  id: 'media-thumbnail',
  component: 'media-thumbnail',
  media: true
};

var message = {
  id: 'message',
  component: 'message',
  labelPath: 'message',
  thumbnailPath: 'avatar.thumbnail_url',
  fields: [{
    name: 'speaker',
    type: 'select',
    label: defineMessage({
      id: "muPX/j",
      defaultMessage: [{
        "type": 0,
        "value": "Speaker"
      }]
    })
  }, {
    name: 'message',
    type: 'text',
    label: defineMessage({
      id: "4R/bdr",
      defaultMessage: [{
        "type": 0,
        "value": "Message"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'audio',
    type: 'audio',
    label: defineMessage({
      id: "zueWSA",
      defaultMessage: [{
        "type": 0,
        "value": "Audio attachment"
      }]
    })
  }, {
    name: 'putAudioBeforeText',
    type: 'toggle',
    label: defineMessage({
      id: "trQFlb",
      defaultMessage: [{
        "type": 0,
        "value": "Put audio before text"
      }]
    })
  }, {
    name: 'timingOverrides',
    component: 'toggle-section',
    isList: true,
    fields: [{
      name: 'enabled',
      type: 'toggle',
      isHorizontal: true,
      label: defineMessage({
        id: "2uFkwE",
        defaultMessage: [{
          "type": 0,
          "value": "Override default timing"
        }]
      })
    }, {
      name: 'appearDelay',
      type: 'number',
      defaultValue: 2,
      label: defineMessage({
        id: "eNdbJF",
        defaultMessage: [{
          "type": 0,
          "value": "Appear delay (seconds)"
        }]
      })
    }, {
      name: 'writingDuration',
      type: 'number',
      defaultValue: 5,
      label: defineMessage({
        id: "iJ61ZT",
        defaultMessage: [{
          "type": 0,
          "value": "Writing state duration (seconds)"
        }]
      })
    }]
  }]
};

var messages = {
  id: 'messages',
  component: 'items',
  noItemLabel: defineMessage({
    id: "HTd98/",
    defaultMessage: [{
      "type": 0,
      "value": "No message..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "xCj1gI",
    defaultMessage: [{
      "type": 0,
      "value": "Add a message"
    }]
  }),
  itemsField: {
    type: 'message',
    breadcrumbLabel: defineMessage({
      id: "0GzLBc",
      defaultMessage: [{
        "type": 0,
        "value": "Message"
      }]
    })
  }
};

var metadata = {
  id: 'metadata',
  component: 'field-with-form',
  labelPath: 'title',
  noValueLabel: defineMessage({
    id: "K1BxIr",
    defaultMessage: [{
      "type": 0,
      "value": "Edit metadata..."
    }]
  }),
  fields: [{
    name: 'title',
    type: 'text',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }]
};

var number = {
  id: 'number',
  component: 'number'
};

var padding = {
  id: 'padding',
  component: 'padding'
};

var password = {
  id: 'password',
  component: 'text',
  type: 'password'
};

var parameters = {
  id: 'parameters',
  isList: true,
  fields: [{
    name: 'metadata',
    type: 'metadata',
    label: defineMessage({
      id: "nc8LF0",
      defaultMessage: [{
        "type": 0,
        "value": "Metadata"
      }]
    })
  }]
};

var quizAnswer = {
  id: 'quiz-answer',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'good',
    type: 'true-false',
    label: defineMessage({
      id: "I1hyZY",
      defaultMessage: [{
        "type": 0,
        "value": "Answer icon value"
      }]
    })
  }, {
    name: 'result',
    type: 'text-element',
    // textOnly: true,
    label: defineMessage({
      id: "Lz2+Ws",
      defaultMessage: [{
        "type": 0,
        "value": "Answer feedback"
      }]
    })
  }, {
    name: 'answerImage',
    type: 'visual',
    label: defineMessage({
      id: "57hjHa",
      defaultMessage: [{
        "type": 0,
        "value": "Answer feedback image"
      }]
    })
  }, {
    type: 'fields',
    isList: true,
    fields: [{
      name: 'textStyle',
      type: 'text-style-form',
      label: defineMessage({
        id: "p5RHzq",
        defaultMessage: [{
          "type": 0,
          "value": "Button text style"
        }]
      })
    }, {
      name: 'buttonStyle',
      type: 'box-style-form',
      label: defineMessage({
        id: "nno1Pq",
        defaultMessage: [{
          "type": 0,
          "value": "Button style"
        }]
      })
    }]
  }]
};

var quizAnswers = {
  id: 'quiz-answers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "A+a0kL",
    defaultMessage: [{
      "type": 0,
      "value": "No answer..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "lGh/NP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an answer"
    }]
  }),
  itemsField: {
    type: 'quiz-answer',
    breadcrumbLabel: defineMessage({
      id: "XJ2Xc+",
      defaultMessage: [{
        "type": 0,
        "value": "Answer"
      }]
    })
  }
};

var quizPointsAnswer = {
  id: 'quiz-points-answer',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'good',
    type: 'true-false',
    label: defineMessage({
      id: "I1hyZY",
      defaultMessage: [{
        "type": 0,
        "value": "Answer icon value"
      }]
    })
  }, {
    name: 'points',
    type: 'number',
    isHorizontal: true,
    label: defineMessage({
      id: "jWAJW4",
      defaultMessage: [{
        "type": 0,
        "value": "Points"
      }]
    })
  },
  // {
  //     name: 'result',
  //     type: 'text-element',
  //     // textOnly: true,
  //     fieldsProps: {
  //         // textStyle: {
  //         //     excludedFields: ['highlight', 'link'],
  //         // },
  //     },
  //     label: defineMessage({
  //         defaultMessage: 'Answer feedback',
  //         description: 'Field label',
  //     }),
  // },
  {
    type: 'fields',
    isList: true,
    fields: [{
      type: 'box-style-form',
      name: 'buttonStyle',
      label: defineMessage({
        id: "nno1Pq",
        defaultMessage: [{
          "type": 0,
          "value": "Button style"
        }]
      })
    }]
  }]
};

var quizPointsAnswers = {
  id: 'quiz-points-answers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "A+a0kL",
    defaultMessage: [{
      "type": 0,
      "value": "No answer..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "lGh/NP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an answer"
    }]
  }),
  itemsField: {
    type: 'quiz-points-answer',
    breadcrumbLabel: defineMessage({
      id: "XJ2Xc+",
      defaultMessage: [{
        "type": 0,
        "value": "Answer"
      }]
    })
  }
};

var radios = {
  id: 'radios',
  component: 'radios'
};

var screenLayout = {
  id: 'screen-layout',
  component: 'screen-layout'
};

var select = {
  id: 'select',
  component: 'select-advanced'
};

var shadowAngle = {
  id: 'shadow-angle',
  component: 'shadow-angle'
};

var slider = {
  id: 'slider',
  component: 'slider'
};

var speaker = {
  id: 'speaker',
  component: 'field-with-form',
  labelPath: 'name',
  thumbnailPath: 'avatar.thumbnail_url',
  fields: [{
    name: 'name',
    type: 'text',
    label: defineMessage({
      id: "UUv8FR",
      defaultMessage: [{
        "type": 0,
        "value": "Name"
      }]
    })
  }, {
    name: 'avatar',
    type: 'image',
    label: defineMessage({
      id: "hqOIl4",
      defaultMessage: [{
        "type": 0,
        "value": "Avatar"
      }]
    })
  }, {
    name: 'side',
    type: 'radios',
    options: [{
      value: 'left',
      label: defineMessage({
        id: "O2JVA+",
        defaultMessage: [{
          "type": 0,
          "value": "Left"
        }]
      })
    }, {
      value: 'right',
      label: defineMessage({
        id: "ptJkUl",
        defaultMessage: [{
          "type": 0,
          "value": "Right"
        }]
      })
    }],
    label: defineMessage({
      id: "6ak5YN",
      defaultMessage: [{
        "type": 0,
        "value": "Side"
      }]
    })
  }, {
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "aarOkd",
      defaultMessage: [{
        "type": 0,
        "value": "Color"
      }]
    })
  }]
};

var speakers = {
  id: 'speakers',
  component: 'items',
  getDefaultValue: function getDefaultValue() {
    return {
      id: v1(),
      side: 'left'
    };
  },
  noItemLabel: defineMessage({
    id: "+nhSvj",
    defaultMessage: [{
      "type": 0,
      "value": "No speaker..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "opcGwP",
    defaultMessage: [{
      "type": 0,
      "value": "Add a speaker"
    }]
  }),
  itemsField: {
    type: 'speaker',
    breadcrumbLabel: defineMessage({
      id: "rzdds2",
      defaultMessage: [{
        "type": 0,
        "value": "Speaker"
      }]
    })
  }
};

var textModal = {
  id: 'text-modal',
  component: 'text-modal',
  media: true,
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }]
};

var def = {
  id: 'text-style',
  canClear: true,
  fields: [{
    key: 'typography',
    type: 'fields',
    label: defineMessage({
      id: "Wr9olU",
      defaultMessage: [{
        "type": 0,
        "value": "Typography"
      }]
    }),
    isList: true,
    fields: [{
      name: 'fontFamily',
      type: 'font-family',
      label: defineMessage({
        id: "ET527E",
        defaultMessage: [{
          "type": 0,
          "value": "Font family"
        }]
      })
    }, {
      name: 'color',
      type: 'color',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'fontSize',
      type: 'font-size',
      label: defineMessage({
        id: "tYGev7",
        defaultMessage: [{
          "type": 0,
          "value": "Font size"
        }]
      })
    }, {
      component: 'font-style-with-align',
      fontStyleName: 'fontStyle',
      alignName: 'align'
    }]
  }, {
    type: 'fields',
    name: 'highlight',
    label: defineMessage({
      id: "HWpflq",
      defaultMessage: [{
        "type": 0,
        "value": "Highlight"
      }]
    }),
    isList: true,
    fields: [{
      name: 'color',
      type: 'color',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'textColor',
      type: 'color',
      label: defineMessage({
        id: "DU1qdc",
        defaultMessage: [{
          "type": 0,
          "value": "Text color"
        }]
      })
    }]
  }, {
    type: 'fields',
    name: 'link',
    label: defineMessage({
      id: "ICXTfR",
      defaultMessage: [{
        "type": 0,
        "value": "Links"
      }]
    }),
    isList: true,
    fields: [{
      name: 'color',
      type: 'color',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'fontStyle',
      component: 'font-style',
      isHorizontal: true,
      label: defineMessage({
        id: "6MxaVf",
        defaultMessage: [{
          "type": 0,
          "value": "Style"
        }]
      })
    }]
  }, {
    type: 'fields',
    label: defineMessage({
      id: "y7xsPe",
      defaultMessage: [{
        "type": 0,
        "value": "Advanced settings"
      }]
    }),
    isList: true,
    fields: [{
      name: 'fontWeight',
      type: 'font-weight',
      label: defineMessage({
        id: "eDMxHS",
        defaultMessage: [{
          "type": 0,
          "value": "Font weight"
        }]
      })
    }, {
      name: 'lineHeight',
      type: 'line-height',
      label: defineMessage({
        id: "31zuCS",
        defaultMessage: [{
          "type": 0,
          "value": "Line height"
        }]
      })
    }, {
      name: 'letterSpacing',
      type: 'letter-spacing',
      label: defineMessage({
        id: "Z5jrDS",
        defaultMessage: [{
          "type": 0,
          "value": "Letter spacing"
        }]
      })
    }, {
      component: 'font-style-transform',
      name: 'fontStyle',
      transformName: 'transform',
      label: defineMessage({
        id: "GMCLhn",
        defaultMessage: [{
          "type": 0,
          "value": "Case"
        }]
      })
    }]
  }]
};

var fields = def.fields;
var textStyleForm = {
  id: 'text-style-form',
  component: 'text-style-form',
  canClear: true,
  fields: fields
};

var text = {
  id: 'text',
  component: 'text'
};

var toggle = {
  id: 'toggle',
  component: 'toggle'
};

var tokens = {
  id: 'tokens',
  component: 'tokens'
};

var trueFalse = {
  id: 'true-false',
  component: 'trueFalse'
};

var url = {
  id: 'url',
  component: 'url'
};

var video = {
  id: 'video',
  component: 'media-modal',
  media: true,
  type: 'video'
};

var videoElement = {
  id: 'video-element',
  fields: [{
    name: 'media',
    type: 'video'
  }],
  settings: [{
    name: 'autoPlay',
    type: 'toggle',
    label: defineMessage({
      id: "pJgYyE",
      defaultMessage: [{
        "type": 0,
        "value": "AutoPlay"
      }]
    })
  }, {
    name: 'loop',
    type: 'toggle',
    label: defineMessage({
      id: "F2SD/0",
      defaultMessage: [{
        "type": 0,
        "value": "Loop"
      }]
    })
  }, {
    name: 'withControls',
    type: 'toggle',
    label: defineMessage({
      id: "BwYZbB",
      defaultMessage: [{
        "type": 0,
        "value": "With controls button"
      }]
    })
  }, {
    name: 'withSeekBar',
    type: 'toggle',
    label: defineMessage({
      id: "T0pi1u",
      defaultMessage: [{
        "type": 0,
        "value": "With seek bar"
      }]
    })
  }, {
    name: 'thumbnail',
    type: 'media-thumbnail',
    label: defineMessage({
      id: "4kSwvn",
      defaultMessage: [{
        "type": 0,
        "value": "Thumbnail"
      }]
    })
  }, {
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "Rl7C1A",
      defaultMessage: [{
        "type": 0,
        "value": "Controls color"
      }]
    })
  }, {
    name: 'progressColor',
    type: 'color',
    label: defineMessage({
      id: "v1r3AA",
      defaultMessage: [{
        "type": 0,
        "value": "Progress bar color"
      }]
    })
  }, {
    name: 'captions',
    type: 'captions',
    label: defineMessage({
      id: "4H2n5r",
      defaultMessage: [{
        "type": 0,
        "value": "Closed captions"
      }]
    })
  }]
};

var visual = {
  id: 'visual',
  component: 'media-modal',
  media: true,
  type: ['image', 'video']
};

var visualWithCaption = {
  id: 'visual-with-caption',
  component: 'field-with-form',
  labelPath: 'caption.body',
  thumbnailPath: 'media.thumbnail_url',
  fields: [{
    name: 'media',
    type: 'visual',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'caption',
    type: 'text-element',
    label: defineMessage({
      id: "p85qJD",
      defaultMessage: [{
        "type": 0,
        "value": "Caption"
      }]
    })
  }]
};

var visualsWithCaption = {
  id: 'visuals-with-caption',
  component: 'items',
  noItemLabel: defineMessage({
    id: "dFMzBu",
    defaultMessage: [{
      "type": 0,
      "value": "No image..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "QSmRdP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an image"
    }]
  }),
  itemsField: {
    type: 'visual-with-caption',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var visuals = {
  id: 'visuals',
  component: 'visuals',
  itemsField: {
    type: 'visual',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var allFields = /*#__PURE__*/Object.freeze({
    __proto__: null,
    alignHorizontal: alignHorizontal,
    alignVertical: alignVertical,
    alignment: alignment,
    answer: answer,
    answers: answers,
    audio: audio,
    audioElement: audioElement,
    authorElement: authorElement,
    background: background,
    backgroundRecommendation: backgroundRecommendation,
    badge: badge,
    borderRadius: borderRadius,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    boxStyle: def$5,
    boxStyleForm: boxStyleForm,
    button: button,
    buttonElement: buttonElement,
    buttonLayout: buttonLayout,
    buttonLink: buttonLink,
    buttons: buttons,
    callToAction: def$4,
    callToActionForm: callToActionForm,
    captions: captions,
    cardLayout: cardLayout,
    checkboxes: checkboxes,
    closedCaptions: closedCaptions,
    color: color,
    conversation: conversation,
    customAnswer: customAnswer,
    date: date,
    dateElement: dateElement,
    datetime: datetime,
    email: email,
    entries: entries,
    entriesWithImage: entriesWithImage,
    entriesWithVisual: entriesWithVisual,
    entry: entry,
    entryWithImage: entryWithImage,
    entryWithVisual: entryWithVisual,
    fieldWithForm: fieldWithForm,
    fields: fields$3,
    fit: fit,
    font: font,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: fontWeight,
    fonts: fonts,
    footer: footer,
    gameSortItem: gameSortItem,
    gameSortItems: gameSortItems,
    geoPosition: geoPosition,
    graphBarStyle: def$2,
    graphBarStyleForm: graphBarStyleForm,
    header: header,
    headingElement: headingElement,
    image: image,
    imageWithCaption: imageWithCaption,
    images: images,
    imagesWithCaption: imagesWithCaption,
    inputElement: inputElement,
    itemTextStyle: itemTextStyle,
    items: items,
    keypadLayout: def$1,
    keypadLayoutForm: keypadLayoutForm,
    letterSpacing: letterSpacing,
    lineHeight: lineHeight,
    mapZoom: mapZoom,
    marker: marker,
    markerWithImage: markerWithImage,
    markers: markers,
    markersWithImage: markersWithImage,
    mediaThumbnail: mediaThumbnail,
    message: message,
    messages: messages,
    metadata: metadata,
    number: number,
    padding: padding,
    parameters: parameters,
    password: password,
    quizAnswer: quizAnswer,
    quizAnswers: quizAnswers,
    quizPointsAnswer: quizPointsAnswer,
    quizPointsAnswers: quizPointsAnswers,
    radios: radios,
    screenLayout: screenLayout,
    select: select,
    shadowAngle: shadowAngle,
    shareIncentive: def$3,
    shareIncentiveForm: shareIncentiveForm,
    slider: slider,
    speaker: speaker,
    speakers: speakers,
    text: text,
    textElement: textElement,
    textModal: textModal,
    textStyle: def,
    textStyleForm: textStyleForm,
    toggle: toggle,
    tokens: tokens,
    trueFalse: trueFalse,
    url: url,
    video: video,
    videoElement: videoElement,
    visual: visual,
    visualWithCaption: visualWithCaption,
    visuals: visuals,
    visualsWithCaption: visualsWithCaption
});

var manager = new FieldsManager(Object.keys(allFields).map(function (key) {
  return allFields[key];
}));

var getSelectOptions = function getSelectOptions(options) {
  return options.map(function (it) {
    return isObject(it) ? it : {
      value: it,
      label: it
    };
  });
};

var styles$J = {"container":"micromag-fields-radios-container","item":"micromag-fields-radios-item"};

var propTypes$1A = {
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes$1.selectOptions,
  withBackground: PropTypes.bool,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  activeClassName: PropTypes.string,
  onChange: PropTypes.func,
  uncheckable: PropTypes.bool
};
var defaultProps$1A = {
  name: null,
  value: null,
  options: [],
  withBackground: false,
  className: null,
  buttonClassName: null,
  activeClassName: null,
  onChange: null,
  uncheckable: false
};
var Radios = function Radios(_ref) {
  var name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    withBackground = _ref.withBackground,
    className = _ref.className,
    buttonClassName = _ref.buttonClassName,
    activeClassName = _ref.activeClassName,
    onChange = _ref.onChange,
    uncheckable = _ref.uncheckable;
  var finalOptions = useMemo(function () {
    return getSelectOptions(options);
  }, [options]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['btn-group', 'btn-group-toggle', styles$J.container, _defineProperty({}, className, className !== null)]),
    "data-toggle": "buttons"
  }, finalOptions.map(function (_ref3, index) {
    var optionValue = _ref3.value,
      label = _ref3.label;
    return /*#__PURE__*/React.createElement("label", {
      key: "radio-".concat(optionValue, "-").concat(index + 1),
      className: classNames(['btn', styles$J.item, withBackground ? 'btn-secondary' : 'btn-outline-secondary', _defineProperty(_defineProperty({
        active: optionValue === value
      }, activeClassName, activeClassName !== null && optionValue === value), buttonClassName, buttonClassName !== null)])
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: name,
      autoComplete: "off",
      value: optionValue || '',
      className: "btn-check",
      onClick: function onClick(e) {
        if (onChange !== null) {
          if (uncheckable && optionValue === value) {
            onChange(null);
          } else {
            onChange(e.currentTarget.checked ? optionValue : null);
          }
        }
      },
      onChange: function onChange() {},
      checked: optionValue === value
    }), ' ', /*#__PURE__*/React.createElement(Label, null, label));
  }));
};
Radios.propTypes = propTypes$1A;
Radios.defaultProps = defaultProps$1A;

var styles$I = {"container":"micromag-fields-border-style-container","button":"micromag-fields-border-style-button","type":"micromag-fields-border-style-type","borders":"micromag-fields-border-style-borders"};

var propTypes$1z = {
  types: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1z = {
  types: [{
    name: '300x200',
    width: 300,
    height: 200
  }, {
    name: '300x100',
    width: 300,
    height: 100
  }, {
    name: '250x250',
    width: 250,
    height: 250
  }],
  value: null,
  className: null,
  onChange: null
};
var AdFormatField = function AdFormatField(_ref) {
  var types = _ref.types,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Radios, {
    options: types.map(function (type) {
      return {
        value: type,
        label: /*#__PURE__*/React.createElement("div", {
          className: styles$I.type
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: type.width / 10,
            height: type.height / 10,
            border: "2px solid #ccc"
          }
        }))
      };
    }),
    value: value || (types ? types[0] : null),
    className: classNames([styles$I.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$I.button,
    onChange: onChange
  });
};
AdFormatField.propTypes = propTypes$1z;
AdFormatField.defaultProps = defaultProps$1z;

var styles$H = {"icon":"micromag-fields-align-horizontal-icon","left":"micromag-fields-align-horizontal-left","middle":"micromag-fields-align-horizontal-middle","right":"micromag-fields-align-horizontal-right"};

var propTypes$1y = {
  value: PropTypes.oneOf(['left', 'middle', 'right']),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1y = {
  value: null,
  className: null,
  onChange: null
};
var AlignHorizontal = function AlignHorizontal(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$H.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', 'align-items-center'])
  }, /*#__PURE__*/React.createElement(Radios, {
    options: ['left', 'middle', 'right'].map(function (type) {
      return {
        value: type,
        label: /*#__PURE__*/React.createElement("div", {
          className: classNames([styles$H.icon, styles$H[type]])
        }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null))
      };
    }),
    value: value !== null ? value : null,
    className: classNames([styles$H.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$H.button,
    onChange: onChange
  })));
};
AlignHorizontal.propTypes = propTypes$1y;
AlignHorizontal.defaultProps = defaultProps$1y;

var styles$G = {};

var icons$1 = {
  top: function top(props) {
    return /*#__PURE__*/React.createElement("div", props, "top");
  },
  middle: function middle(props) {
    return /*#__PURE__*/React.createElement("div", props, "middle");
  },
  bottom: function bottom(props) {
    return /*#__PURE__*/React.createElement("div", props, "bottom");
  }
};
var propTypes$1x = {
  value: PropTypes.oneOf(['top', 'bottom', 'middle']),
  defaultValue: PropTypes.oneOf(['top', 'bottom', 'middle']),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1x = {
  value: null,
  defaultValue: null,
  className: null,
  onChange: null
};
var AlignVertical = function AlignVertical(_ref) {
  var value = _ref.value,
    defaultValue = _ref.defaultValue,
    className = _ref.className,
    onChange = _ref.onChange;
  var finalValue = value === null && defaultValue !== null ? defaultValue : value;
  var onAlignChange = useCallback(function (newVal) {
    onChange(newVal);
  }, [finalValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$G.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', 'align-items-center', 'mb-2'])
  }, /*#__PURE__*/React.createElement(Radios, {
    options: ['top', 'middle', 'bottom'].map(function (type) {
      var Icon = icons$1[type];
      return {
        value: type,
        label: /*#__PURE__*/React.createElement("div", {
          className: styles$G.type
        }, /*#__PURE__*/React.createElement(Icon, {
          className: styles$G.icon
        }))
      };
    }),
    value: finalValue !== null ? finalValue : null,
    className: classNames([styles$G.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$G.button,
    onChange: onAlignChange
  })));
};
AlignVertical.propTypes = propTypes$1x;
AlignVertical.defaultProps = defaultProps$1x;

var styles$F = {"label":"micromag-fields-alignment-label"};

var icons = {
  horizontal: {
    left: function left(props) {
      return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowLeft,
        className: styles$F.icon
      }));
    },
    middle: function middle(props) {
      return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faDotCircle,
        className: styles$F.icon
      }));
    },
    right: function right(props) {
      return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowRight,
        className: styles$F.icon
      }));
    }
  },
  vertical: {
    top: function top(props) {
      return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowUp,
        className: styles$F.icon
      }));
    },
    middle: function middle(props) {
      return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faDotCircle,
        className: styles$F.icon
      }));
    },
    bottom: function bottom(props) {
      return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowDown,
        className: styles$F.icon
      }));
    }
  }
};
var propTypes$1w = {
  alignment: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'right', 'middle']),
    vertical: PropTypes.oneOf(['top', 'bottom', 'middle'])
  }),
  value: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'right', 'middle']),
    vertical: PropTypes.oneOf(['top', 'bottom', 'middle'])
  }),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1w = {
  alignment: {
    horizontal: 'middle',
    vertical: 'middle'
  },
  value: null,
  className: null,
  onChange: null
};
var Alignment = function Alignment(_ref) {
  var alignment = _ref.alignment,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  var onVerticalAlignChange = useCallback(function (newVal) {
    var _ref2 = value || {},
      _ref2$vertical = _ref2.vertical,
      vertical = _ref2$vertical === void 0 ? null : _ref2$vertical,
      _ref2$horizontal = _ref2.horizontal,
      horizontal = _ref2$horizontal === void 0 ? null : _ref2$horizontal;
    var v = newVal === vertical ? null : newVal;
    var nextValue = v === null && horizontal === null ? null : _objectSpread(_objectSpread({}, value || null), {}, {
      vertical: v
    });
    onChange(nextValue);
  }, [value, onChange]);
  var onHorizontalAlignChange = useCallback(function (newVal) {
    var _ref3 = value || {},
      _ref3$horizontal = _ref3.horizontal,
      horizontal = _ref3$horizontal === void 0 ? null : _ref3$horizontal,
      _ref3$vertical = _ref3.vertical,
      vertical = _ref3$vertical === void 0 ? null : _ref3$vertical;
    var h = newVal === horizontal ? null : newVal;
    var nextValue = h === null && vertical === null ? null : _objectSpread(_objectSpread({}, value || null), {}, {
      horizontal: h
    });
    onChange(nextValue);
  }, [value, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$F.container, _defineProperty({}, className, className !== null)])
  }, Object.keys(alignment).map(function (axis) {
    return /*#__PURE__*/React.createElement("div", {
      key: axis,
      className: classNames(['d-flex', 'align-items-center', 'mb-2'])
    }, /*#__PURE__*/React.createElement("small", {
      className: styles$F.label
    }, axis === 'horizontal' ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "xTJlyi",
      defaultMessage: [{
        "type": 0,
        "value": "Horizontal"
      }]
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "YwySSO",
      defaultMessage: [{
        "type": 0,
        "value": "Vertical"
      }]
    })), /*#__PURE__*/React.createElement(Radios, {
      options: (axis === 'horizontal' ? ['left', 'middle', 'right'] : ['top', 'middle', 'bottom']).map(function (type) {
        var Icon = icons[axis][type];
        return {
          value: type,
          label: /*#__PURE__*/React.createElement("div", {
            className: styles$F.type
          }, /*#__PURE__*/React.createElement(Icon, {
            className: styles$F.icon
          }))
        };
      }),
      value: value !== null ? value[axis] : null,
      className: classNames([styles$F.container, _defineProperty({}, className, className !== null)]),
      buttonClassName: styles$F.button,
      onChange: axis === 'horizontal' ? onHorizontalAlignChange : onVerticalAlignChange
    }));
  }));
};
Alignment.propTypes = propTypes$1w;
Alignment.defaultProps = defaultProps$1w;

var styles$E = {"container":"micromag-fields-field-errors-container","error":"micromag-fields-field-errors-error"};

var propTypes$1v = {
  errors: PropTypes$1.errors,
  className: PropTypes.string
};
var defaultProps$1v = {
  errors: null,
  className: null
};
var FieldErrors$1 = function FieldErrors(_ref) {
  var errors = _ref.errors,
    className = _ref.className;
  return errors !== null && errors.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$E.container, _defineProperty({}, className, className !== null)])
  }, errors.map(function (error) {
    return /*#__PURE__*/React.createElement("div", {
      key: "error-".concat(error),
      className: classNames(['invalid-feedback', styles$E.error])
    }, error);
  })) : null;
};
FieldErrors$1.propTypes = propTypes$1v;
FieldErrors$1.defaultProps = defaultProps$1v;

var propTypes$1u = {
  children: PropTypes$1.label,
  muted: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps$1u = {
  children: null,
  muted: true,
  className: null
};
var FieldErrors = function FieldErrors(_ref) {
  var children = _ref.children,
    muted = _ref.muted,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("small", {
    id: "passwordHelpBlock",
    className: classNames(['form-text', _defineProperty({
      'text-body-secondary': muted
    }, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Label, null, children));
};
FieldErrors.propTypes = propTypes$1u;
FieldErrors.defaultProps = defaultProps$1u;

var styles$D = {"resetButton":"micromag-fields-field-row-resetButton","colLabel":"micromag-fields-field-row-colLabel","colValue":"micromag-fields-field-row-colValue","colButtonWidth":"micromag-fields-field-row-colButtonWidth","colMinWidth":"micromag-fields-field-row-colMinWidth","settingsButton":"micromag-fields-field-row-settingsButton"};

var propTypes$1t = {
  label: PropTypes$1.label,
  errors: PropTypes$1.errors,
  help: PropTypes$1.label,
  children: PropTypes.node,
  isSection: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  isListItem: PropTypes.bool,
  withoutLabel: PropTypes.bool,
  withoutCaret: PropTypes.bool,
  withSettings: PropTypes.bool,
  withForm: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  withValue: PropTypes.bool,
  buttonTheme: PropTypes$1.buttonTheme,
  buttonOutline: PropTypes.bool,
  gotoSettings: PropTypes.func,
  gotoForm: PropTypes.func,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  buttonClassName: PropTypes.string
};
var defaultProps$1t = {
  label: null,
  errors: null,
  help: null,
  children: null,
  isSection: false,
  isHorizontal: false,
  isListItem: false,
  withoutLabel: false,
  withoutCaret: false,
  withSettings: false,
  withForm: false,
  withValue: false,
  buttonTheme: null,
  buttonOutline: false,
  gotoSettings: null,
  gotoForm: null,
  className: null,
  labelClassName: null,
  buttonClassName: null
};
var FieldRow = function FieldRow(_ref) {
  var _classNames;
  var label = _ref.label,
    errors = _ref.errors,
    help = _ref.help,
    children = _ref.children,
    isSection = _ref.isSection,
    isHorizontal = _ref.isHorizontal,
    isListItem = _ref.isListItem,
    withoutLabel = _ref.withoutLabel,
    withoutCaret = _ref.withoutCaret,
    withSettings = _ref.withSettings,
    withForm = _ref.withForm,
    withValue = _ref.withValue,
    buttonTheme = _ref.buttonTheme,
    buttonOutline = _ref.buttonOutline,
    gotoForm = _ref.gotoForm,
    gotoSettings = _ref.gotoSettings,
    className = _ref.className,
    labelClassName = _ref.labelClassName,
    buttonClassName = _ref.buttonClassName;
  var withLabel = !withoutLabel && label !== null;
  var isClickable = withForm;
  var onClickRow = useCallback(function () {
    if (typeof withForm === 'string') {
      gotoForm(withForm);
    } else if (withForm) {
      gotoForm();
    }
  }, [withForm, gotoForm]);
  var containerClassName = classNames(['form-group', _defineProperty({
    'list-group-item': isListItem,
    'mb-0': isListItem,
    'py-2': isListItem,
    'px-2': isListItem,
    'text-light': isListItem
  }, className, className !== null)]);
  var helpElement = help !== null ? /*#__PURE__*/React.createElement(FieldErrors, null, help) : null;
  var errorsElement = errors !== null && errors.length > 0 ? /*#__PURE__*/React.createElement(FieldErrors$1, {
    errors: errors
  }) : null;
  var hasIndicationsUnder = helpElement !== null || errorsElement !== null;
  var labelElement = label !== null ? /*#__PURE__*/React.createElement("label", {
    className: classNames((_classNames = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, styles$D.colLabel, isHorizontal), 'col-form-label', isHorizontal || withSettings), 'form-label', !isHorizontal && !withSettings), 'col-auto', isHorizontal), "col", !isHorizontal && withSettings), 'py-0', isHorizontal), 'pt-2', isHorizontal && hasIndicationsUnder), 'me-1', isHorizontal), 'align-self-center', isHorizontal && !hasIndicationsUnder), 'fw-normal', !isSection), _defineProperty(_defineProperty(_classNames, 'fw-bold', isSection), labelClassName, labelClassName !== null)))
  }, /*#__PURE__*/React.createElement(Label, null, label)) : null;
  var arrowElement = isClickable && !withValue && !withoutCaret ? /*#__PURE__*/React.createElement("span", {
    className: "col-auto align-self-center d-flex align-items-center mw-25"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faAngleRight
  })) : null;
  if (isHorizontal) {
    var rowInner = /*#__PURE__*/React.createElement("span", {
      className: classNames(['row', 'flex-nowrap', 'gx-1'])
    }, labelElement, /*#__PURE__*/React.createElement("span", {
      className: classNames(['col', styles$D.colValue, 'align-self-center', _defineProperty(_defineProperty({}, styles$D.colMinWidth, isListItem), styles$D.colButtonWidth, isClickable && buttonTheme !== null)])
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames(['d-flex', 'justify-content-end', 'me-1'])
    }, children), helpElement !== null || errorsElement !== null ? /*#__PURE__*/React.createElement("span", {
      className: classNames(['d-flex', 'mt-1',
      // 'w-100',
      'justify-content-end'])
    }, helpElement, errorsElement) : null), arrowElement);
    return isClickable ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: classNames([containerClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$D.resetButton, !isListItem), 'd-block', !isListItem), 'w-100', isListItem), 'p-2', !isListItem)]),
      onClick: onClickRow
    }, rowInner) : /*#__PURE__*/React.createElement("div", {
      className: containerClassName
    }, rowInner);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassName
  }, withLabel ? withSettings ? /*#__PURE__*/React.createElement("div", {
    className: classNames(['row', 'align-items-center', 'gx-1'])
  }, labelElement, /*#__PURE__*/React.createElement("div", {
    className: classNames(['col-auto'])
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles$D.settingsButton,
    withoutStyle: true,
    onClick: gotoSettings,
    disabled: !withValue
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSlidersH
  })))) : labelElement : null, isClickable ? /*#__PURE__*/React.createElement(Button, {
    className: classNames([styles$D.arrow, 'd-block', 'w-100', 'px-2', _defineProperty({
      'bg-dark': buttonTheme === null
    }, buttonClassName, buttonClassName !== null)]),
    theme: buttonTheme,
    outline: buttonOutline,
    onClick: onClickRow
  }, /*#__PURE__*/React.createElement("span", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(['col', 'text-truncate', styles$D.colValue])
  }, children), arrowElement)) : children, helpElement, errorsElement);
};
FieldRow.propTypes = propTypes$1t;
FieldRow.defaultProps = defaultProps$1t;

var _excluded$B = ["name", "type", "component", "label", "help", "errors", "fields", "isHorizontal", "isSection", "isListItem", "withForm", "withModal", "value", "onChange", "gotoFieldForm", "closeFieldForm", "className", "labelClassName", "fieldClassName"],
  _excluded2$3 = ["component", "fields", "settings", "withoutLabel", "withoutFieldRow", "withForm", "withModal", "isList", "canClear"];
var propTypes$1s = {
  name: PropTypes.string,
  // .isRequired,
  type: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  label: PropTypes$1.label,
  help: PropTypes$1.label,
  errors: PropTypes$1.errors,
  value: PropTypes.any,
  // eslint-disable-line react/forbid-prop-types
  fields: PropTypes$1.formFields,
  isHorizontal: PropTypes.bool,
  isSection: PropTypes.bool,
  isListItem: PropTypes.bool,
  withForm: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  withModal: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  gotoFieldForm: PropTypes.func,
  closeFieldForm: PropTypes.func,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  fieldClassName: PropTypes.string
};
var defaultProps$1s = {
  name: null,
  type: null,
  component: null,
  label: null,
  help: null,
  value: null,
  errors: null,
  fields: undefined,
  isHorizontal: null,
  isSection: false,
  isListItem: false,
  withForm: null,
  withModal: null,
  onChange: null,
  gotoFieldForm: null,
  closeFieldForm: null,
  className: null,
  labelClassName: null,
  fieldClassName: null
};
var Field = function Field(_ref) {
  var name = _ref.name,
    type = _ref.type,
    providedComponent = _ref.component,
    label = _ref.label,
    help = _ref.help,
    errors = _ref.errors,
    providedFields = _ref.fields,
    isHorizontal = _ref.isHorizontal,
    isSection = _ref.isSection,
    isListItem = _ref.isListItem,
    providedWithForm = _ref.withForm,
    providedWithModal = _ref.withModal,
    value = _ref.value,
    onChange = _ref.onChange,
    gotoFieldForm = _ref.gotoFieldForm,
    closeFieldForm = _ref.closeFieldForm,
    className = _ref.className,
    labelClassName = _ref.labelClassName,
    fieldClassName = _ref.fieldClassName,
    props = _objectWithoutProperties(_ref, _excluded$B);
  var fieldsManager = useFieldsManager();
  var FieldsComponent = fieldsManager.getComponent('fields');
  var _ref2 = (type !== null ? fieldsManager.getDefinition(type) || null : null) || {
      component: providedComponent
    },
    _ref2$component = _ref2.component,
    fieldComponent = _ref2$component === void 0 ? FieldsComponent : _ref2$component,
    _ref2$fields = _ref2.fields,
    fields = _ref2$fields === void 0 ? providedFields : _ref2$fields,
    _ref2$settings = _ref2.settings,
    settings = _ref2$settings === void 0 ? null : _ref2$settings,
    _ref2$withoutLabel = _ref2.withoutLabel,
    withoutLabel = _ref2$withoutLabel === void 0 ? false : _ref2$withoutLabel,
    _ref2$withoutFieldRow = _ref2.withoutFieldRow,
    withoutFieldRow = _ref2$withoutFieldRow === void 0 ? false : _ref2$withoutFieldRow,
    _ref2$withForm = _ref2.withForm,
    withForm = _ref2$withForm === void 0 ? providedWithForm : _ref2$withForm,
    _ref2$withModal = _ref2.withModal,
    withModal = _ref2$withModal === void 0 ? providedWithModal : _ref2$withModal,
    _ref2$isList = _ref2.isList,
    isList = _ref2$isList === void 0 ? false : _ref2$isList,
    _ref2$canClear = _ref2.canClear,
    canClear = _ref2$canClear === void 0 ? false : _ref2$canClear,
    fieldProps = _objectWithoutProperties(_ref2, _excluded2$3);
  var FieldComponent = useFieldComponent(fieldComponent);
  var isFields = FieldComponent === FieldsComponent;
  var context = useFieldContext();
  var gotoForm = useCallback(function (form) {
    return gotoFieldForm(name, form, context);
  }, [name, context, gotoFieldForm]);
  var closeForm = useCallback(function (form) {
    return closeFieldForm(name, form);
  }, [name, closeFieldForm]);
  var gotoSettings = useCallback(function () {
    return gotoForm('settings');
  }, [gotoForm]);
  if (FieldComponent === null) {
    return null;
  }
  var finalWithForm = withForm || FieldComponent.withForm || false;
  var finalWithModal = withModal || FieldComponent.withModal || false;
  var finalIsHorizontal = isHorizontal !== null ? isHorizontal : FieldComponent.isHorizontal || finalWithForm !== false && isListItem || finalWithModal !== false && isListItem || null;
  var finalWithoutLabel = withoutLabel || FieldComponent.withoutLabel || false;
  var finalWithSettings = settings !== null || typeof FieldComponent.withSettings !== 'undefined' && FieldComponent.withSettings || typeof FieldComponent.settingsComponent !== 'undefined' || false;
  var fieldElement = /*#__PURE__*/React.createElement(FieldComponent, Object.assign({
    isHorizontal: finalIsHorizontal && !isFields,
    isList: isList,
    canClear: canClear,
    labelClassName: classNames(_defineProperty({
      'col-sm-3': isHorizontal && isFields
    }, labelClassName, labelClassName !== null)),
    className: fieldClassName
  }, props, fieldProps, {
    errors: errors,
    fields: fields,
    name: name,
    value: value,
    onChange: onChange,
    gotoFieldForm: gotoFieldForm,
    gotoForm: gotoForm
  }));
  return !withoutFieldRow ? /*#__PURE__*/React.createElement(FieldRow, Object.assign({}, props, fieldProps, {
    label: label,
    errors: errors,
    help: help,
    isHorizontal: finalIsHorizontal || false,
    isSection: isSection,
    isListItem: isListItem,
    withoutLabel: finalWithoutLabel,
    withSettings: finalWithSettings,
    withForm: finalWithForm,
    withValue: value !== null,
    gotoSettings: gotoSettings,
    gotoForm: gotoForm,
    closeForm: closeForm,
    className: className,
    labelClassName: labelClassName
  }), fieldElement) : fieldElement;
};
Field.propTypes = propTypes$1s;
Field.defaultProps = defaultProps$1s;

var styles$C = {"container":"micromag-fields-container","field":"micromag-fields-field","isSection":"micromag-fields-isSection","advanced":"micromag-fields-advanced","withBorders":"micromag-fields-withBorders","fields":"micromag-fields-fields","fieldRow":"micromag-fields-fieldRow"};

var propTypes$1r = {
  name: PropTypes.string,
  fields: PropTypes$1.formFields,
  excludedFields: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  errors: PropTypes$1.formErrors,
  withBorders: PropTypes.bool,
  gotoFieldForm: PropTypes.func,
  closeFieldForm: PropTypes.func,
  nullEmptyObject: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  isList: PropTypes.bool,
  isFlushList: PropTypes.bool,
  canClear: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  fieldClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  components: PropTypes$1.components,
  fieldsProps: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  fieldProps: PropTypes.object // eslint-disable-line react/forbid-prop-types
};
var defaultProps$1r = {
  name: null,
  fields: [],
  excludedFields: null,
  value: null,
  errors: null,
  withBorders: false,
  gotoFieldForm: null,
  closeFieldForm: null,
  nullEmptyObject: false,
  isHorizontal: null,
  isList: false,
  isFlushList: false,
  canClear: false,
  onChange: null,
  className: null,
  fieldClassName: null,
  labelClassName: null,
  components: null,
  fieldsProps: null,
  fieldProps: null
};
var Fields = function Fields(_ref) {
  var namespace = _ref.name,
    fields = _ref.fields,
    excludedFields = _ref.excludedFields,
    value = _ref.value,
    errors = _ref.errors,
    withBorders = _ref.withBorders,
    gotoFieldForm = _ref.gotoFieldForm,
    closeFieldForm = _ref.closeFieldForm,
    nullEmptyObject = _ref.nullEmptyObject,
    globalIsHorizontal = _ref.isHorizontal,
    isList = _ref.isList,
    isFlushList = _ref.isFlushList,
    canClear = _ref.canClear,
    onChange = _ref.onChange,
    className = _ref.className,
    fieldClassName = _ref.fieldClassName,
    labelClassName = _ref.labelClassName,
    components = _ref.components,
    fieldsProps = _ref.fieldsProps,
    fieldProps = _ref.fieldProps;
  var nullableOnChange = useCallback(nullEmptyObject ? createNullableOnChange(onChange) : onChange, [nullEmptyObject, onChange]);
  var onFieldChange = useCallback(function (key, newFieldValue) {
    var newValue = key !== null ? _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, newFieldValue)) : _objectSpread(_objectSpread({}, value), newFieldValue);
    if (nullableOnChange !== null) {
      nullableOnChange(newValue);
    }
  }, [value, nullableOnChange]);
  var onClearField = useCallback(function () {
    nullableOnChange(null);
  }, [nullableOnChange]);
  var includedFields = fields.filter(function (_ref2) {
    var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? null : _ref2$name,
      _ref2$key = _ref2.key,
      key = _ref2$key === void 0 ? null : _ref2$key;
    return name === null && key === null || excludedFields === null || excludedFields.indexOf(name || key) === -1;
  });
  var visibleFields = includedFields.filter(function (_ref3) {
    var _ref3$hidden = _ref3.hidden,
      hidden = _ref3$hidden === void 0 ? false : _ref3$hidden;
    return !hidden;
  });
  var fieldsAdvanced = visibleFields.map(function (_ref4) {
    var _ref4$advanced = _ref4.advanced,
      advanced = _ref4$advanced === void 0 ? false : _ref4$advanced;
    return advanced;
  });
  var normalFieldsIndex = useMemo(function () {
    return fieldsAdvanced.map(function (advanced, index) {
      return !advanced ? index : null;
    }).filter(function (it) {
      return it !== null;
    });
  }, [fieldsAdvanced.join(',')]);
  var advancedFieldsIndex = useMemo(function () {
    return fieldsAdvanced.map(function (advanced, index) {
      return advanced ? index : null;
    }).filter(function (it) {
      return it !== null;
    });
  }, [fieldsAdvanced.join(',')]);
  var fieldsElements = useMemo(function () {
    return visibleFields.map(function (field, i) {
      var _field$name = field.name,
        name = _field$name === void 0 ? null : _field$name,
        customValue = field.value,
        customErrors = field.errors,
        _field$onChange = field.onChange,
        customOnChange = _field$onChange === void 0 ? null : _field$onChange,
        _field$isHorizontal = field.isHorizontal,
        isHorizontal = _field$isHorizontal === void 0 ? globalIsHorizontal : _field$isHorizontal,
        _field$isSection = field.isSection,
        isSection = _field$isSection === void 0 ? false : _field$isSection,
        _field$className = field.className,
        customClassName = _field$className === void 0 ? null : _field$className,
        _field$fieldsProps = field.fieldsProps,
        customFieldsProps = _field$fieldsProps === void 0 ? null : _field$fieldsProps;
      var fieldExcludedFields = excludedFields !== null ? excludedFields.filter(function (key) {
        return name === null || key.match(new RegExp("^".concat(name, ".")));
      }).map(function (key) {
        return name !== null ? key.replace(new RegExp("^".concat(name, ".")), '') : key;
      }) : null;
      var customFieldProps = name !== null ? (customFieldsProps || fieldsProps || {})[name] || null : null;
      var singleFieldValue = name !== null && typeof (value || {})[name] !== 'undefined' ? (value || {})[name] : null;
      var singleFieldErrors = name !== null && typeof (errors || {})[name] !== 'undefined' ? (errors || {})[name] : null;
      var fieldValue = name !== null ? singleFieldValue : value;
      var fieldErrors = name !== null ? singleFieldErrors : errors;
      var fieldOnChange = function fieldOnChange(newFieldValue) {
        return onFieldChange(name, newFieldValue);
      };
      return /*#__PURE__*/React.createElement(Field, Object.assign({
        excludedFields: fieldExcludedFields
      }, field, fieldProps, customFieldProps, {
        key: "field-".concat(name, "-").concat(i + 1),
        name: namespace !== null ? "".concat(namespace).concat(name !== null ? ".".concat(name) : '') : name,
        value: typeof customValue !== 'undefined' ? customValue : fieldValue,
        errors: typeof customErrors !== 'undefined' ? customErrors : fieldErrors,
        onChange: customOnChange || fieldOnChange,
        gotoFieldForm: gotoFieldForm,
        closeFieldForm: closeFieldForm,
        components: components,
        isHorizontal: isHorizontal,
        isSection: isSection,
        isListItem: isList || isFlushList,
        className: classNames([styles$C.field, _defineProperty(_defineProperty({}, styles$C.isSection, isSection), fieldClassName, fieldClassName !== null)]),
        fieldClassName: customClassName,
        labelClassName: labelClassName,
        fieldRowClassName: styles$C.fieldRow
      }));
    });
  }, [visibleFields, globalIsHorizontal, isList, isFlushList, value, errors, onFieldChange, gotoFieldForm, closeFieldForm, fieldProps, fieldsProps]);
  if (fieldsElements.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$C.container, _defineProperty(_defineProperty({}, styles$C.withBorders, withBorders), className, className !== null)])
  }, /*#__PURE__*/React.createElement(FieldsValueContextProvider, {
    value: value
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$C.fields, {
      'list-group': isList,
      'list-group-flush': isFlushList
    }])
  }, normalFieldsIndex.map(function (index) {
    return fieldsElements[index];
  })), advancedFieldsIndex.length > 0 ? /*#__PURE__*/React.createElement(FieldRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "enFs4g",
      defaultMessage: [{
        "type": 0,
        "value": "Advanced"
      }]
    }),
    isSection: true,
    className: styles$C.advanced
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$C.fields, {
      'list-group': isList,
      'list-group-flush': isFlushList
    }])
  }, advancedFieldsIndex.map(function (index) {
    return fieldsElements[index];
  }))) : null), canClear ? /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "light",
    outline: true,
    size: "md",
    onClick: onClearField
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "ufac8e",
    defaultMessage: [{
      "type": 0,
      "value": "Clear all"
    }]
  }))) : null);
};
Fields.propTypes = propTypes$1r;
Fields.defaultProps = defaultProps$1r;

var styles$B = {"container":"micromag-fields-slide-container","noValue":"micromag-fields-slide-noValue","value":"micromag-fields-slide-value","panel":"micromag-fields-slide-panel"};

var _excluded$A = ["value", "isForm", "className"];
var propTypes$1q = {
  value: PropTypes.shape({
    text: PropTypes.string,
    image: PropTypes$1.imageMedia
  }),
  isForm: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps$1q = {
  value: null,
  isForm: false,
  className: null
};
var AnswerField = function AnswerField(_ref) {
  var value = _ref.value,
    isForm = _ref.isForm,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$A);
  var _ref2 = value || {},
    _ref2$text = _ref2.text,
    text = _ref2$text === void 0 ? null : _ref2$text;
  return isForm ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$B.panel, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Fields, Object.assign({
    className: classNames([{
      'p-2': isForm,
      className: className !== null
    }])
  }, props, {
    value: value
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$B.container, _defineProperty({}, className, className !== null)])
  }, text !== null ? /*#__PURE__*/React.createElement("span", {
    className: styles$B.value
  }, text) : /*#__PURE__*/React.createElement("span", {
    className: styles$B.noValue
  }, "Entrez une question..."));
};
AnswerField.propTypes = propTypes$1q;
AnswerField.defaultProps = defaultProps$1q;

var _excluded$z = ["name", "value", "getDefaultValue", "noItemLabel", "addItemLabel", "itemFieldLabel", "itemComponent", "itemsField", "itemsProps", "className", "withoutSort", "withoutAddItem", "withoutDeleteItem", "onChange", "isFieldForm", "gotoFieldForm", "closeFieldForm"];
var propTypes$1p = {
  name: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-line
  getDefaultValue: PropTypes.func,
  noItemLabel: PropTypes$1.label,
  addItemLabel: PropTypes$1.label,
  itemFieldLabel: PropTypes.oneOfType([PropTypes.func, PropTypes$1.label]),
  itemComponent: PropTypes.elementType,
  itemsField: PropTypes$1.formField,
  itemsProps: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  withoutSort: PropTypes.bool,
  withoutAddItem: PropTypes.bool,
  withoutDeleteItem: PropTypes.bool,
  isFieldForm: PropTypes.bool,
  gotoFieldForm: PropTypes.func,
  closeFieldForm: PropTypes.func,
  onChange: PropTypes.func
};
var defaultProps$1p = {
  name: null,
  value: null,
  getDefaultValue: null,
  noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "PKCv5M",
    defaultMessage: [{
      "type": 0,
      "value": "No item..."
    }]
  }),
  addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "ZxgNge",
    defaultMessage: [{
      "type": 0,
      "value": "Add an item"
    }]
  }),
  // eslint-disable-next-line react/prop-types
  itemFieldLabel: function itemFieldLabel(_ref) {
    var index = _ref.index;
    return /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "2/F1Q7",
      defaultMessage: [{
        "type": 0,
        "value": "#"
      }, {
        "type": 1,
        "value": "index"
      }],
      values: {
        index: index
      }
    });
  },
  itemComponent: null,
  itemsField: null,
  itemsProps: null,
  className: null,
  withoutSort: false,
  withoutAddItem: false,
  withoutDeleteItem: false,
  isFieldForm: false,
  gotoFieldForm: null,
  closeFieldForm: null,
  onChange: null
};
var ItemsField = function ItemsField(_ref2) {
  var name = _ref2.name,
    value = _ref2.value,
    getDefaultValue = _ref2.getDefaultValue,
    noItemLabel = _ref2.noItemLabel,
    addItemLabel = _ref2.addItemLabel,
    itemFieldLabel = _ref2.itemFieldLabel,
    itemComponent = _ref2.itemComponent,
    itemsField = _ref2.itemsField,
    itemsProps = _ref2.itemsProps,
    className = _ref2.className,
    withoutSort = _ref2.withoutSort,
    withoutAddItem = _ref2.withoutAddItem,
    withoutDeleteItem = _ref2.withoutDeleteItem,
    onChange = _ref2.onChange;
    _ref2.isFieldForm;
    var gotoFieldForm = _ref2.gotoFieldForm,
    closeFieldForm = _ref2.closeFieldForm,
    props = _objectWithoutProperties(_ref2, _excluded$z);
  // const finalIsFieldForm =
  //     isFieldForm || (itemComponent !== null ? itemComponent.withForm || false : false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var idMap = useRef((value || []).map(function () {
    return v4();
  }));
  var onClickAdd = useCallback(function () {
    var newDefaultValue = getDefaultValue !== null ? getDefaultValue() : null;
    var newValue = [].concat(_toConsumableArray(value || []), [newDefaultValue]);
    idMap.current = [].concat(_toConsumableArray(idMap.current), [v4()]);
    if (onChange !== null) {
      onChange(newValue);
    }
    if (gotoFieldForm !== null) {
      gotoFieldForm("".concat(name, ".").concat(newValue.length - 1));
    }
  }, [value, onChange, getDefaultValue, gotoFieldForm, name]);
  var onClickEdit = useCallback(function () {
    setEditing(function (old) {
      return !old;
    });
  }, [setEditing]);
  var onClickDelete = useCallback(function (index) {
    if (onChange !== null) {
      var newValues = _toConsumableArray(value);
      newValues.splice(index, 1);
      idMap.current = idMap.current.filter(function (_, idIndex) {
        return idIndex !== index;
      });
      onChange(newValues);
      if (newValues.length === 0) {
        setEditing(false);
      }
    }
  }, [value, onChange, setEditing]);
  var onItemChange = useCallback(function (index, newValue) {
    if (onChange !== null) {
      var newValues = _toConsumableArray(value);
      newValues[index] = newValue;
      onChange(newValues);
    }
  }, [value, onChange]);
  var onOrderChange = useCallback(function (newItems) {
    var orderChanged = newItems.reduce(function (changed, _ref3, prevIndex) {
      var newIndex = _ref3.index;
      return changed || prevIndex !== newIndex;
    }, false);
    if (orderChanged && onChange !== null) {
      var newIdMap = newItems.map(function (_ref4) {
        var index = _ref4.index;
        return idMap.current[index];
      });
      idMap.current = newIdMap;
      onChange(newItems.map(function (_ref5) {
        var it = _ref5.it;
        return it;
      }));
    }
  }, [onChange]);
  var gotoForms = useMemo(function () {
    return value !== null ? value.map(function (val, index) {
      return function () {
        return gotoFieldForm("".concat(name, ".").concat(index));
      };
    }) : null;
  }, [value, gotoFieldForm]);
  var closeForms = useMemo(function () {
    return value !== null ? value.map(function (val, index) {
      return function () {
        return closeFieldForm("".concat(name, ".").concat(index));
      };
    }) : null;
  }, [value, closeFieldForm]);
  var items = value || [];
  var _items$length = items.length,
    itemsLength = _items$length === void 0 ? 0 : _items$length;
  var hasItems = itemsLength > 0;
  var sortableItems = items.map(function (it, index) {
    return {
      id: idMap.current[index],
      it: it,
      index: index
    };
  });
  var finalWithoutSort = withoutSort || !editing;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, hasItems ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactSortable, {
    className: "list-group",
    list: sortableItems,
    setList: onOrderChange,
    disabled: finalWithoutSort,
    key: finalWithoutSort
  }, items.map(function (itemValue, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-0 d-flex"
    }, !finalWithoutSort ? /*#__PURE__*/React.createElement("div", {
      className: classNames(['btn', 'px-2', 'border', 'border-dark', 'border-right-0', 'rounded-0', {
        'border-top-0': index > 0
      }])
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faBars
    })) : null, /*#__PURE__*/React.createElement(Field, Object.assign({
      className: classNames(['flex-grow-1', 'overflow-hidden', {
        'border-top-0': index > 0,
        'border-left-0': editing && !finalWithoutSort
      }]),
      component: itemComponent
    }, itemsField, props, itemsProps, {
      key: "item-".concat(index),
      label: isFunction(itemFieldLabel) ? itemFieldLabel({
        item: itemValue,
        index: index + 1
      }) : /*#__PURE__*/React.createElement(Label, {
        values: {
          index: index + 1
        }
      }, itemFieldLabel),
      isListItem: true,
      name: "".concat(name, ".").concat(index),
      value: itemValue,
      onChange: function onChange(newValue) {
        return onItemChange(index, newValue);
      },
      closeForm: closeForms[index],
      gotoForm: gotoForms[index],
      gotoFieldForm: gotoFieldForm,
      closeFieldForm: closeFieldForm
    })), editing ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn ps-2 pe-2 py-0 text-danger",
      onClick: function onClick() {
        onClickDelete(index);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTrash
    })) : null);
  }))) : /*#__PURE__*/React.createElement(Empty, {
    className: "p-4"
  }, /*#__PURE__*/React.createElement(Label, null, noItemLabel)), /*#__PURE__*/React.createElement("div", {
    className: "d-flex mt-1"
  }, !withoutAddItem ? /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    size: "sm",
    disabled: editing,
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faPlus
    }),
    onClick: onClickAdd
  }, /*#__PURE__*/React.createElement(Label, null, addItemLabel)) : null, hasItems && !withoutDeleteItem ? /*#__PURE__*/React.createElement(Button, {
    className: classNames(['ms-auto', {
      'pe-0': !editing,
      'text-reset': !editing
    }]),
    theme: editing ? 'primary' : 'link',
    size: "sm",
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: editing ? faCheck : faList
    }),
    onClick: onClickEdit
  }, !editing ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "xuEZXD",
    defaultMessage: [{
      "type": 0,
      "value": "Edit"
    }]
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "UlZIP8",
    defaultMessage: [{
      "type": 0,
      "value": "OK"
    }]
  })) : null));
};
ItemsField.propTypes = propTypes$1p;
ItemsField.defaultProps = defaultProps$1p;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$1o = {
  value: PropTypes$1.answers
};
var defaultProps$1o = {
  value: null
};
var AnswersField = function AnswersField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "p6n6vY",
      defaultMessage: [{
        "type": 0,
        "value": "No answer..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "n2teag",
      defaultMessage: [{
        "type": 0,
        "value": "Add an answer"
      }]
    }),
    itemComponent: AnswerField
  }, props));
};
AnswersField.propTypes = propTypes$1o;
AnswersField.defaultProps = defaultProps$1o;

var styles$A = {"thumbnail":"micromag-fields-field-with-form-thumbnail","label":"micromag-fields-field-with-form-label","clearButton":"micromag-fields-field-with-form-clearButton"};

var _excluded$y = ["value", "isForm", "canClear", "noValueLabel", "label", "labelPath", "withTitleLabel", "thumbnail", "thumbnailPath", "isHorizontal", "className", "onChange", "closeForm", "children", "field"];
var propTypes$1n = {
  value: PropTypes.any,
  // eslint-disable-line
  isForm: PropTypes.bool,
  canClear: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes$1.message]),
  thumbnail: PropTypes.node,
  labelPath: PropTypes.string,
  withTitleLabel: PropTypes.bool,
  thumbnailPath: PropTypes.string,
  noValueLabel: PropTypes$1.label,
  isHorizontal: PropTypes.bool,
  children: PropTypes.node,
  field: PropTypes$1.formField,
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$1n = {
  value: null,
  isForm: false,
  canClear: false,
  label: null,
  thumbnail: null,
  labelPath: 'label',
  withTitleLabel: false,
  thumbnailPath: 'thumbnail',
  noValueLabel: null,
  isHorizontal: false,
  children: null,
  field: null,
  className: null,
  onChange: null,
  closeForm: null
};
var FieldWithForm = function FieldWithForm(_ref) {
  var value = _ref.value,
    isForm = _ref.isForm,
    canClear = _ref.canClear,
    noValueLabel = _ref.noValueLabel,
    label = _ref.label,
    labelPath = _ref.labelPath,
    withTitleLabel = _ref.withTitleLabel,
    thumbnail = _ref.thumbnail,
    thumbnailPath = _ref.thumbnailPath,
    isHorizontal = _ref.isHorizontal,
    className = _ref.className,
    onChange = _ref.onChange;
    _ref.closeForm;
    var children = _ref.children,
    field = _ref.field,
    props = _objectWithoutProperties(_ref, _excluded$y);
  if (isForm) {
    if (children !== null) {
      return children;
    }
    return field !== null ? /*#__PURE__*/React.createElement(Field, Object.assign({
      className: "p-2"
    }, field, props, {
      value: value,
      onChange: onChange,
      buttonTheme: "primary",
      canClear: canClear
    })) : /*#__PURE__*/React.createElement(Fields, Object.assign({
      className: "p-2"
    }, props, {
      canClear: canClear,
      value: value,
      onChange: onChange
    }));
  }
  var labelValue = label !== null ? label : get(value, labelPath, null);
  var labelElement = null;
  var labelString = null;
  if (labelValue !== null && isMessage(labelValue)) {
    labelElement = /*#__PURE__*/React.createElement(FormattedMessage, labelValue);
  } else {
    labelString = labelValue !== null && isObject(labelValue) ? labelValue.name || labelValue.id || '' : labelValue;

    // Strip html
    labelElement = labelString !== null && isString(labelString) ? labelString.replace(/(<([^>]+)>)/gi, '') : null;
    labelElement = /*#__PURE__*/React.isValidElement(labelValue) ? labelValue : labelElement;
  }
  var thumbnailElement = useMemo(function () {
    var thumbElement = null;
    var thumbnailSrc = get(value, thumbnailPath, null);
    if (thumbnail !== null) {
      thumbElement = thumbnail;
    } else if (thumbnailSrc !== null) {
      thumbElement = /*#__PURE__*/React.createElement("img", {
        src: thumbnailSrc,
        className: styles$A.thumbnail,
        alt: label
      });
    }
    return thumbElement;
  }, [value, thumbnailPath, thumbnail, label]);
  var onClear = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (onChange !== null) {
      onChange(null);
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(['align-items-center', 'flex-nowrap', 'mw-100', 'w-100', _defineProperty({
      row: thumbnailElement === null && labelElement === null
    }, className, className !== null)])
  }, thumbnailElement !== null || labelElement !== null ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "row px-1",
    title: withTitleLabel && (isString(labelString) || isString(label)) ? labelString || label || '' : null
  }, !isHorizontal && thumbnailElement !== null ? /*#__PURE__*/React.createElement("span", {
    className: "col-auto"
  }, thumbnailElement) : null, /*#__PURE__*/React.createElement("span", {
    className: classNames([styles$A.label, 'col', 'text-monospace', 'text-start', 'text-truncate', 'fw-bold', {
      'text-start': !isHorizontal,
      'text-end': isHorizontal
    }])
  }, labelElement), isHorizontal && thumbnailElement !== null ? /*#__PURE__*/React.createElement("span", {
    className: "col-auto ps-0"
  }, thumbnailElement) : null, value !== null && canClear ? /*#__PURE__*/React.createElement(ClearButton, {
    className: styles$A.clearButton,
    onClick: onClear
  }) : null)) : /*#__PURE__*/React.createElement("span", {
    className: classNames(['col', 'text-body-secondary', {
      'text-start': !isHorizontal,
      'text-end': isHorizontal,
      'text-truncate': isHorizontal
    }])
  }, /*#__PURE__*/React.createElement(Label, null, noValueLabel || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "EoVdMy",
    defaultMessage: [{
      "type": 0,
      "value": "Edit content..."
    }]
  }))));
};
FieldWithForm.propTypes = propTypes$1n;
FieldWithForm.defaultProps = defaultProps$1n;
FieldWithForm.withForm = true;

var styles$z = {"clearButton":"micromag-fields-media-modal-clearButton","previewButton":"micromag-fields-media-modal-previewButton","dialog":"micromag-fields-media-modal-dialog","thumbnail":"micromag-fields-media-modal-thumbnail","dialogBody":"micromag-fields-media-modal-dialogBody","shaded":"micromag-fields-media-modal-shaded","small":"micromag-fields-media-modal-small"};

var _excluded$x = ["title", "value", "type", "noValueLabel", "isHorizontal", "onChange", "onRequestClose", "multiple", "thumbnail", "thumbnailPath", "className", "buttonsClassName"];
var propTypes$1m = {
  title: PropTypes.string,
  value: PropTypes$1.media,
  type: PropTypes.string,
  noValueLabel: PropTypes$1.label,
  isHorizontal: PropTypes.bool,
  onChange: PropTypes.func,
  onRequestClose: PropTypes.func,
  multiple: PropTypes.bool,
  thumbnail: PropTypes.node,
  thumbnailPath: PropTypes.string,
  className: PropTypes.string,
  buttonsClassName: PropTypes.string
};
var defaultProps$1m = {
  title: null,
  value: null,
  type: null,
  noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "e6+aGf",
    defaultMessage: [{
      "type": 0,
      "value": "Select a media..."
    }]
  }),
  isHorizontal: false,
  onChange: null,
  onRequestClose: null,
  multiple: false,
  thumbnail: null,
  thumbnailPath: 'thumbnail_url',
  className: null,
  buttonsClassName: null
};
var MediaModal = function MediaModal(_ref) {
  var title = _ref.title,
    value = _ref.value,
    type = _ref.type,
    noValueLabel = _ref.noValueLabel,
    isHorizontal = _ref.isHorizontal,
    onChange = _ref.onChange,
    onRequestClose = _ref.onRequestClose,
    multiple = _ref.multiple,
    thumbnail = _ref.thumbnail,
    thumbnailPath = _ref.thumbnailPath,
    className = _ref.className;
    _ref.buttonsClassName;
    var props = _objectWithoutProperties(_ref, _excluded$x);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mediaFormOpen = _useState4[0],
    setMediaFormOpen = _useState4[1];
  var onMediaFormOpen = useCallback(function () {
    setMediaFormOpen(true);
  }, [setMediaFormOpen]);
  var onMediaFormClose = useCallback(function () {
    setMediaFormOpen(false);
  }, [setMediaFormOpen]);
  var label = value !== null ? value.name || getFileName(value.url) || null : null;
  var thumbnailElement = null;
  var thumbnailSrc = get(value, thumbnailPath, null);
  if (thumbnail !== null) {
    thumbnailElement = thumbnail;
  } else if (thumbnailSrc !== null) {
    thumbnailElement = /*#__PURE__*/React.createElement("img", {
      src: thumbnailSrc,
      className: styles$z.thumbnail,
      alt: label
    });
  }

  // Temporary value
  var _useState5 = useState(value),
    _useState6 = _slicedToArray(_useState5, 2),
    media = _useState6[0],
    setMedia = _useState6[1];
  useEffect(function () {
    setMedia(value);
  }, [value, setMedia]);
  var dialogTitle = useMemo(function () {
    if (title) {
      return title;
    }
    switch (type) {
      case 'video':
        return /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "cej3hp",
          defaultMessage: [{
            "type": 0,
            "value": "Select Video"
          }]
        });
      case 'image':
        return /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "kxsaD3",
          defaultMessage: [{
            "type": 0,
            "value": "Select Image"
          }]
        });
      case 'audio':
        return /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "0hMiRN",
          defaultMessage: [{
            "type": 0,
            "value": "Select Audio File"
          }]
        });
      case 'font':
        return /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "B5Qrmw",
          defaultMessage: [{
            "type": 0,
            "value": "Select Font File"
          }]
        });
      case 'document':
        return /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "P6ZtIq",
          defaultMessage: [{
            "type": 0,
            "value": "Select Document"
          }]
        });
      case 'subtitle':
        return /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "790Q9C",
          defaultMessage: [{
            "type": 0,
            "value": "Select Subtitles File"
          }]
        });
      default:
        return /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "/2i9do",
          defaultMessage: [{
            "type": 0,
            "value": "Choose media"
          }]
        });
    }
  }, [title, type]);
  var onOpen = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setModalOpen(true);
    setMedia(value);
  }, [setModalOpen, setMedia, value]);
  var onClose = useCallback(function (e) {
    setModalOpen(false);
    setMedia(null);
    if (onRequestClose !== null) {
      onRequestClose(e);
    }
  }, [setModalOpen, onRequestClose, setMedia]);
  var onConfirmSelection = useCallback(function () {
    if (onChange !== null) {
      onChange(media);
    }
    onClose();
  }, [media, onClose]);
  var onChangeMedia = useCallback(function () {
    var newMedia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    setMedia(newMedia);
  }, [value, onChange, onClose]);
  var onClearMedia = useCallback(function () {
    if (onChange !== null) {
      onChange(null);
      setMedia(null);
    }
  }, [value, onChange, onClose, setMedia]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    value: value,
    noValueLabel: noValueLabel,
    label: label,
    withTitleLabel: label !== null,
    thumbnailPath: "thumbnail_url",
    isForm: true,
    isHorizontal: isHorizontal
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 align-items-center justify-content-between mw-100 overflow-hidden"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames([styles$z.previewButton, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$z.shaded, !isHorizontal), styles$z.small, isHorizontal), 'p-2', !isHorizontal), 'mx-auto', !isHorizontal), 'bg-dark', !isHorizontal), 'flex-grow-1', true)]),
    onClick: onOpen
  }, /*#__PURE__*/React.createElement("span", {
    className: "row"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames([styles$z.label, 'col', 'w-75', 'text-monospace', 'text-truncate', {
      'fw-bold': value !== null,
      'text-start': !isHorizontal,
      'text-end': isHorizontal
    }]),
    style: {
      maxWidth: 270
    }
  }, label || /*#__PURE__*/React.createElement("span", {
    className: "text-body-secondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "gJTVcQ",
    defaultMessage: [{
      "type": 0,
      "value": "Select media..."
    }]
  }))), thumbnailElement !== null ? /*#__PURE__*/React.createElement("span", {
    className: "col-auto ps-0"
  }, thumbnailElement) : null)), value !== null ? /*#__PURE__*/React.createElement(ClearButton, {
    className: classNames([styles$z.clearButton]),
    onClick: onClearMedia
  }) : null)), modalOpen ? /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement(ModalDialog, {
    title: dialogTitle,
    className: classNames([styles$z.dialog, _defineProperty({}, className, className)]),
    bodyClassName: styles$z.dialogBody,
    size: "xl",
    onClose: onClose,
    buttons: !mediaFormOpen ? [{
      id: 'cancel',
      name: 'cancel',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "PyxZY2",
        defaultMessage: [{
          "type": 0,
          "value": "Cancel"
        }]
      }),
      theme: 'secondary',
      onClick: onClose
    }, {
      id: 'confirm',
      name: 'confirm',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "rvOVCV",
        defaultMessage: [{
          "type": 0,
          "value": "Confirm selection"
        }]
      }),
      theme: 'primary',
      onClick: onConfirmSelection
    }] : null
  }, /*#__PURE__*/React.createElement(MediaGallery, {
    value: media,
    types: type,
    isPicker: true,
    multiple: multiple,
    onChange: onChangeMedia,
    onClose: onClose,
    onClear: onClearMedia,
    onMediaFormOpen: onMediaFormOpen,
    onMediaFormClose: onMediaFormClose
  }))) : null);
};
MediaModal.propTypes = propTypes$1m;
MediaModal.defaultProps = defaultProps$1m;
MediaModal.withModal = true;

var _excluded$w = ["closeForm", "onChange"];
var propTypes$1l = {
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$1l = {
  onChange: null,
  closeForm: null
};
var MediaField = function MediaField(_ref) {
  var closeForm = _ref.closeForm,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$w);
  var closeOnChange = useCallback(function (newValue) {
    if (onChange !== null) {
      onChange(newValue);
    }
    if (closeForm !== null) {
      // console.log('close');
      closeForm();
    }
  }, [onChange, closeForm]);
  return /*#__PURE__*/React.createElement(MediaModal, Object.assign({
    onChange: closeOnChange
  }, props));
};
MediaField.propTypes = propTypes$1l;
MediaField.defaultProps = defaultProps$1l;
MediaField.withForm = true;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$1k = {
  value: PropTypes$1.audioMedia
};
var defaultProps$1k = {
  value: null
};
var AudioField = function AudioField(props) {
  return /*#__PURE__*/React.createElement(MediaField, Object.assign({
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "wt1+dM",
      defaultMessage: [{
        "type": 0,
        "value": "Select an audio file..."
      }]
    })
  }, props, {
    type: "audio"
  }));
};
AudioField.propTypes = propTypes$1k;
AudioField.defaultProps = defaultProps$1k;
AudioField.withForm = true;

var propTypes$1j = {
  // eslint-disable-next-line react/forbid-prop-types
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.object
  })]),
  type: PropTypes.oneOf(['text', 'email', 'number', 'password']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errors: PropTypes$1.errors,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  prefix: PropTypes.string,
  autofocus: PropTypes.bool,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string
};
var defaultProps$1j = {
  inputRef: null,
  type: 'text',
  value: null,
  errors: null,
  required: false,
  disabled: false,
  placeholder: null,
  prefix: null,
  autofocus: false,
  onChange: null,
  onFocus: null,
  className: null
};
var TextField = function TextField(_ref) {
  var inputRef = _ref.inputRef,
    type = _ref.type,
    value = _ref.value,
    errors = _ref.errors,
    required = _ref.required,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    prefix = _ref.prefix,
    autofocus = _ref.autofocus,
    _onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    className = _ref.className;
  var input = /*#__PURE__*/React.createElement("input", Object.assign({
    ref: inputRef,
    type: type,
    className: classNames(['form-control', _defineProperty({
      'is-invalid': errors !== null && errors.length > 0,
      disabled: disabled
    }, className, className !== null)]),
    value: value || '',
    onChange: function onChange(_ref3) {
      var _ref3$currentTarget$v = _ref3.currentTarget.value,
        newValue = _ref3$currentTarget$v === void 0 ? '' : _ref3$currentTarget$v;
      return _onChange !== null ? _onChange(!isEmpty(newValue) ? newValue : null) : null;
    },
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    autoFocus: autofocus
  }, onFocus !== null ? {
    onFocus: onFocus
  } : null));
  return prefix !== null ? /*#__PURE__*/React.createElement("span", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-text"
  }, prefix), input) : input;
};
TextField.propTypes = propTypes$1j;
TextField.defaultProps = defaultProps$1j;
var TextField$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TextField, Object.assign({}, props, {
    inputRef: ref
  }));
});

var styles$y = {"container":"micromag-fields-autocomplete-container","list":"micromag-fields-autocomplete-list","item":"micromag-fields-autocomplete-item"};

var propTypes$1i = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })),
  value: PropTypes.string,
  searchOptions: PropTypes.shape({
    isCaseSensitive: PropTypes.bool,
    includeScore: PropTypes.bool,
    includeMatches: PropTypes.bool,
    minMatchCharLength: PropTypes.number,
    shouldSort: PropTypes.bool,
    threshold: PropTypes.number,
    distance: PropTypes.number
  }),
  maxResults: PropTypes.number,
  showEmpty: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node
};
var defaultProps$1i = {
  items: [],
  value: null,
  searchOptions: {
    // Search in `label` and in `value` items in an object array
    keys: ['label', 'value']
  },
  maxResults: 10,
  showEmpty: false,
  placeholder: null,
  className: null,
  onChange: null,
  children: null
};
var AutocompleteField = function AutocompleteField(_ref) {
  var items = _ref.items,
    value = _ref.value,
    searchOptions = _ref.searchOptions,
    maxResults = _ref.maxResults,
    showEmpty = _ref.showEmpty,
    placeholder = _ref.placeholder,
    className = _ref.className,
    onChange = _ref.onChange,
    children = _ref.children;
  var fuse = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  useEffect(function () {
    var options = _objectSpread({
      isCaseSensitive: false,
      includeScore: true,
      includeMatches: true,
      minMatchCharLength: 2,
      shouldSort: true
    }, searchOptions);
    fuse.current = new Fuse(items, options);
  }, [items, searchOptions]);
  var list = value && fuse.current !== null ? fuse.current.search(value) : items.map(function (item) {
    return {
      item: item
    };
  });
  var maxedList = maxResults > 0 ? list.slice(0, maxResults) : list;
  var onClick = useCallback(function (e) {
    if (e.target.dataset.value) {
      onChange(e.target.dataset.value);
      setOpen(false);
    }
  }, [onChange]);
  var onInputChange = useCallback(function (val) {
    onChange(val);
    if (val) {
      setOpen(true);
    } else {
      setOpen(showEmpty);
    }
  }, [onChange, showEmpty]);
  var listItems = children !== null ? /*#__PURE__*/React.createElement("div", {
    className: styles$y.list
  }, children) : /*#__PURE__*/React.createElement("div", {
    className: styles$y.list
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-group bg-light"
  }, maxedList.map(function (_ref2) {
    var item = _ref2.item;
    return /*#__PURE__*/React.createElement("li", {
      className: classNames(['list-group-item', styles$y.item]),
      key: "auto-".concat(item.label)
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn btn-link",
      "data-value": item.label,
      onClick: onClick
    }, item.label));
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$y.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(TextField$1, {
    value: value,
    buttonClassName: styles$y.button,
    placeholder: placeholder,
    onChange: onInputChange
  }), open ? listItems : null);
};
AutocompleteField.propTypes = propTypes$1i;
AutocompleteField.defaultProps = defaultProps$1i;

var styles$x = {"container":"micromag-fields-badge-container","field":"micromag-fields-badge-field","active":"micromag-fields-badge-active"};

var _excluded$v = ["value", "className", "onChange"];
var propTypes$1h = {
  value: PropTypes$1.badge,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1h = {
  value: null,
  className: null,
  onChange: null
};
var Badge = function Badge(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$v);
  var _ref2 = value || {},
    _ref2$active = _ref2.active,
    active = _ref2$active === void 0 ? false : _ref2$active;
  var intl = useIntl();
  var onUpdateValue = useCallback(function (newValue) {
    var _ref3 = value || {},
      _ref3$active = _ref3.active,
      wasActive = _ref3$active === void 0 ? false : _ref3$active;
    var _ref4 = newValue || {},
      _ref4$active = _ref4.active,
      nowActive = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? null : _ref4$label;
    var finalValue = _objectSpread({}, newValue);
    if (!wasActive && nowActive) {
      if (label === null) {
        finalValue.label = {
          body: intl.formatMessage(defineMessage({
            id: "4b5gym",
            defaultMessage: [{
              "type": 0,
              "value": "Screen title"
            }]
          }))
        };
      }
    }
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    className: classNames([styles$x.container, _defineProperty(_defineProperty({}, className, className !== null), styles$x.active, active)]),
    fieldClassName: styles$x.field
  }, props, {
    value: value,
    onChange: onUpdateValue
  }));
};
Badge.propTypes = propTypes$1h;
Badge.defaultProps = defaultProps$1h;

var styles$w = {"container":"micromag-fields-slider-container","slider":"micromag-fields-slider-slider","input":"micromag-fields-slider-input","unit":"micromag-fields-slider-unit"};

// const roundEven = value => 2 * Math.round(value / 2);

var rangeFromMinMax = function rangeFromMinMax(min, max, count, step) {
  return _toConsumableArray(Array(count).keys()).reduce(function (values, key) {
    var lastValue = values[values.length - 1];
    return [].concat(_toConsumableArray(values), [key === count - 1 ? max : lastValue + step]);
  }, [min]);
};
var rangeFromStep = function rangeFromStep(min, max, step) {
  var count = Math.round(Math.abs(max - min) / step) + 1;
  return rangeFromMinMax(min, max, count, step);
};
var rangeFromCount = function rangeFromCount(min, max, count) {
  var finalCount = count;
  var step = Math.abs(max - min) / finalCount;
  return rangeFromMinMax(min, max, finalCount, step);
};
var generateSteps = function generateSteps(steps, style) {
  return steps.reduce(function (map, step) {
    return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, step, {
      style: style,
      label: "".concat(step)
    }));
  }, {});
};
var propTypes$1g = {
  value: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  marks: PropTypes.objectOf(PropTypes.object),
  // eslint-disable-line
  marksStep: PropTypes.number,
  marksCount: PropTypes.number,
  marksStyle: PropTypes.object,
  // eslint-disable-line
  unit: PropTypes.string,
  withInput: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1g = {
  value: null,
  min: 0,
  max: 100,
  marks: undefined,
  marksStep: null,
  marksCount: null,
  marksStyle: {
    fontSize: 8
  },
  unit: null,
  withInput: false,
  className: null,
  onChange: null
};
var SliderField = function SliderField(_ref) {
  var value = _ref.value,
    min = _ref.min,
    max = _ref.max,
    marks = _ref.marks,
    marksStep = _ref.marksStep,
    marksCount = _ref.marksCount,
    marksStyle = _ref.marksStyle,
    unit = _ref.unit,
    withInput = _ref.withInput,
    className = _ref.className,
    onChange = _ref.onChange;
  var customOnChange = useCallback(function (val) {
    if (onChange !== null) {
      onChange(val);
      // onChange(parseInt(val, 10));
    }
  }, [onChange]);
  var finalMarks = useMemo(function () {
    return (isArray(marks) ? generateSteps(marks, marksStyle) : marks) || (marksStep !== null ? generateSteps(rangeFromStep(min, max, marksStep), marksStyle) : null) || (marksCount !== null ? generateSteps(rangeFromCount(min, max, marksCount), marksStyle) : null) || undefined;
  }, [min, max, marks, marksStep, marksCount, marksStyle]);
  var slider = /*#__PURE__*/React.createElement("div", {
    className: styles$w.slider
  }, /*#__PURE__*/React.createElement(Slider, {
    value: value !== null ? value : 0,
    min: min,
    max: max,
    marks: finalMarks,
    onChange: customOnChange
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$w.container, _defineProperty(_defineProperty({}, styles$w.withInput, withInput), className, className !== null)])
  }, withInput ? /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center no-gutters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, slider), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement(TextField$1, {
    type: "number",
    value: value,
    onChange: customOnChange,
    className: styles$w.input
  })), unit !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames(['col-auto', styles$w.unit])
  }, unit) : null) : slider);
};
SliderField.propTypes = propTypes$1g;
SliderField.defaultProps = defaultProps$1g;

var styles$v = {"container":"micromag-fields-border-width-container"};

var propTypes$1f = {
  value: PropTypes.string,
  sizes: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1f = {
  value: null,
  sizes: [0, 2, 6, 10, 20, 30],
  className: null,
  onChange: null
};
var BorderRadius = function BorderRadius(_ref) {
  var value = _ref.value,
    sizes = _ref.sizes,
    className = _ref.className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(SliderField, {
    value: value,
    min: sizes[0],
    max: sizes[sizes.length - 1],
    marks: sizes,
    withInput: true,
    className: classNames([styles$v.container, _defineProperty({}, className, className !== null)]),
    onChange: onChange
  });
};
BorderRadius.propTypes = propTypes$1f;
BorderRadius.defaultProps = defaultProps$1f;

var propTypes$1e = {
  types: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1e = {
  types: ['solid', 'dotted', 'dashed'],
  value: null,
  className: null,
  onChange: null
};
var BorderStyle = function BorderStyle(_ref) {
  var types = _ref.types,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  var onBorderStyleChange = function onBorderStyleChange(newVal) {
    var v = newVal === value ? null : newVal;
    onChange(v);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-inline-flex', 'ms-auto', 'me-auto'])
  }, /*#__PURE__*/React.createElement(Radios, {
    options: types.map(function (type) {
      return {
        value: type,
        label: /*#__PURE__*/React.createElement("div", {
          className: styles$I.type
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$I.borders,
          style: {
            border: "2px ".concat(type, " currentColor")
          }
        }))
      };
    }),
    value: value || null,
    className: classNames([styles$I.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$I.button,
    onChange: onBorderStyleChange
  })));
};
BorderStyle.propTypes = propTypes$1e;
BorderStyle.defaultProps = defaultProps$1e;

var propTypes$1d = {
  value: PropTypes.string,
  sizes: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1d = {
  value: null,
  sizes: [1, 2, 4, 8, 10, 14, 20],
  className: null,
  onChange: null
};
var BorderWidth = function BorderWidth(_ref) {
  var value = _ref.value,
    sizes = _ref.sizes,
    className = _ref.className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(SliderField, {
    value: value,
    min: sizes[0],
    max: sizes[sizes.length - 1],
    marks: sizes,
    withInput: true,
    className: classNames([styles$v.container, _defineProperty({}, className, className !== null)]),
    onChange: onChange
  });
};
BorderWidth.propTypes = propTypes$1d;
BorderWidth.defaultProps = defaultProps$1d;

var styles$u = {"preview":"micromag-fields-box-style-preview","box":"micromag-fields-box-style-box"};

var _excluded$u = ["value", "fields", "onChange", "closeForm", "withAlignment"];
var propTypes$1c = {
  value: PropTypes$1.boxStyle,
  fields: PropTypes.arrayOf(PropTypes$1.formField),
  isForm: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  withAlignment: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$1c = {
  value: null,
  fields: null,
  isForm: false,
  isHorizontal: false,
  withAlignment: false,
  className: null,
  onChange: null,
  closeForm: null
};
var BoxStyleForm = function BoxStyleForm(_ref) {
  var value = _ref.value,
    fields = _ref.fields,
    onChange = _ref.onChange;
    _ref.closeForm;
    _ref.withAlignment;
    var props = _objectWithoutProperties(_ref, _excluded$u);
  var previewElement = value !== null ? /*#__PURE__*/React.createElement("span", {
    className: styles$u.preview
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$u.box,
    style: _objectSpread(_objectSpread({}, getStyleFromBox(value)), {}, {
      padding: 0
    })
  })) : null;
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    isForm: true,
    value: value,
    fields: fields,
    onChange: onChange,
    thumbnail: previewElement,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "wChc+A",
      defaultMessage: [{
        "type": 0,
        "value": "Edit style..."
      }]
    })
  }, props));
};
BoxStyleForm.propTypes = propTypes$1c;
BoxStyleForm.defaultProps = defaultProps$1c;
BoxStyleForm.withForm = true;

var styles$t = {"container":"micromag-fields-button-layout-container","button":"micromag-fields-button-layout-button","placeholderText":"micromag-fields-button-layout-placeholderText","placeholderTextOver":"micromag-fields-button-layout-placeholderTextOver","active":"micromag-fields-button-layout-active"};

var propTypes$1b = {
  types: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1b = {
  types: ['label-bottom', 'label-top', 'no-label', 'label-over'],
  value: null,
  defaultValue: null,
  className: null,
  onChange: null
};
var ButtonLayout = function ButtonLayout(_ref) {
  var types = _ref.types,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    className = _ref.className,
    onChange = _ref.onChange;
  var finalValue = value === null && defaultValue !== null ? defaultValue : value;
  var onButtonLayoutChange = useCallback(function (newVal) {
    // const v = newVal === finalValue ? null : newVal;

    onChange(newVal);
  }, [finalValue]);
  var getLayoutPreviewByType = useCallback(function (type) {
    switch (type) {
      case 'label-bottom':
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlaceholderImage, {
          width: "1.25em",
          height: "1em"
        }), /*#__PURE__*/React.createElement(PlaceholderText, {
          className: styles$t.placeholderText,
          lines: 1,
          lineMargin: 1
        }));
      case 'label-top':
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlaceholderText, {
          className: styles$t.placeholderText,
          lines: 1,
          lineMargin: 1
        }), /*#__PURE__*/React.createElement(PlaceholderImage, {
          width: "1.25em",
          height: "1em"
        }));
      case 'no-label':
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlaceholderImage, {
          width: "1.5em",
          height: "1.5em"
        }));
      case 'label-over':
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlaceholderImage, {
          width: "1.5em",
          height: "1.5em"
        }), /*#__PURE__*/React.createElement(PlaceholderText, {
          className: classNames([styles$t.placeholderText, styles$t.placeholderTextOver]),
          lines: 1,
          withInvertedColors: false
        }));
      default:
        return /*#__PURE__*/React.createElement("div", null);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-inline-flex', 'me-auto'])
  }, /*#__PURE__*/React.createElement(Radios, {
    options: types.map(function (type) {
      return {
        value: type,
        label: getLayoutPreviewByType(type)
      };
    }),
    value: finalValue || null,
    className: classNames([styles$t.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$t.button,
    activeClassName: styles$t.active,
    onChange: onButtonLayoutChange,
    uncheckable: true
  })));
};
ButtonLayout.propTypes = propTypes$1b;
ButtonLayout.defaultProps = defaultProps$1b;

var styles$s = {"container":"micromag-fields-call-to-action-container","field":"micromag-fields-call-to-action-field","active":"micromag-fields-call-to-action-active"};

var _excluded$t = ["value", "className", "onChange"];
var propTypes$1a = {
  value: PropTypes$1.callToAction,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$1a = {
  value: null,
  className: null,
  onChange: null
};
var CallToAction = function CallToAction(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$t);
  var _ref2 = value || {},
    _ref2$active = _ref2.active,
    active = _ref2$active === void 0 ? false : _ref2$active;
  var intl = useIntl();

  // set default type and label
  var onUpdateValue = useCallback(function (newValue) {
    var _ref3 = value || {},
      _ref3$active = _ref3.active,
      wasActive = _ref3$active === void 0 ? false : _ref3$active;
    var _ref4 = newValue || {},
      _ref4$active = _ref4.active,
      nowActive = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? null : _ref4$type,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? null : _ref4$label;
    var finalValue = _objectSpread({}, newValue);
    if (!wasActive && nowActive) {
      if (type === null) {
        finalValue.type = 'swipe-up';
      }
      if (label === null) {
        finalValue.label = {
          body: intl.formatMessage(defineMessage({
            id: "z/VBX0",
            defaultMessage: [{
              "type": 0,
              "value": "Learn more"
            }]
          }))
        };
      }
    }
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    className: classNames([styles$s.container, _defineProperty(_defineProperty({}, className, className !== null), styles$s.active, active)]),
    fieldClassName: styles$s.field
  }, props, {
    value: value,
    onChange: onUpdateValue
  }));
};
CallToAction.propTypes = propTypes$1a;
CallToAction.defaultProps = defaultProps$1a;

var _excluded$s = ["value", "className", "onChange"],
  _excluded2$2 = ["paddingRight", "paddingBottom"];
var propTypes$19 = {
  value: PropTypes$1.activeForm,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$19 = {
  value: null,
  className: null,
  onChange: null
};
var CallToActionForm = function CallToActionForm(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$s);
  // const { active = false } = value || {};
  var intl = useIntl();

  // set default type and label
  var onUpdateValue = useCallback(function (newValue) {
    var _ref2 = value || {},
      _ref2$active = _ref2.active,
      wasActive = _ref2$active === void 0 ? false : _ref2$active;
    var _ref3 = newValue || {},
      _ref3$active = _ref3.active,
      nowActive = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? null : _ref3$type,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? null : _ref3$label;
    var finalValue = _objectSpread({}, newValue);
    if (!wasActive && nowActive) {
      if (type === null) {
        finalValue.type = 'swipe-up';
      }
      if (label === null) {
        finalValue.label = {
          body: intl.formatMessage(defineMessage({
            id: "z/VBX0",
            defaultMessage: [{
              "type": 0,
              "value": "Learn more"
            }]
          }))
        };
      }
    }
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [onChange, value]);
  var _getStyleFromBox = getStyleFromBox(value);
    _getStyleFromBox.paddingRight;
    _getStyleFromBox.paddingBottom;
    var stylesWithoutPadding = _objectWithoutProperties(_getStyleFromBox, _excluded2$2);
  var previewElement = value !== null ? /*#__PURE__*/React.createElement("span", {
    className: styles$u.preview
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$u.box,
    style: _objectSpread(_objectSpread({}, stylesWithoutPadding), {}, {
      padding: 0
    })
  })) : null;
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    isForm: true,
    className: className,
    value: value,
    label: "My default label",
    onChange: onUpdateValue,
    thumbnail: previewElement,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "AV6gfh",
      defaultMessage: [{
        "type": 0,
        "value": "Edit call to action..."
      }]
    })
  }, props));
};
CallToActionForm.propTypes = propTypes$19;
CallToActionForm.defaultProps = defaultProps$19;

var styles$r = {"container":"micromag-fields-toggle-section-container","field":"micromag-fields-toggle-section-field","enabled":"micromag-fields-toggle-section-enabled"};

var _excluded$r = ["value", "toggleField", "className", "onChange"];
var propTypes$18 = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.object,
  toggleField: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$18 = {
  value: null,
  toggleField: null,
  className: null,
  onChange: null
};
var ToggleSection = function ToggleSection(_ref) {
  var value = _ref.value,
    toggleField = _ref.toggleField,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$r);
  var _ref2 = value || {},
    _ref2$enabled = _ref2.enabled,
    enabled = _ref2$enabled === void 0 ? false : _ref2$enabled;
  var valueEnabled = toggleField !== null ? (value === null || value === void 0 ? void 0 : value[toggleField]) || false : enabled;
  var onUpdateValue = useCallback(function (newValue) {
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    className: classNames([styles$r.container, _defineProperty(_defineProperty({}, className, className !== null), styles$r.enabled, valueEnabled)]),
    fieldClassName: styles$r.field
  }, props, {
    value: value,
    onChange: onUpdateValue
  }));
};
ToggleSection.propTypes = propTypes$18;
ToggleSection.defaultProps = defaultProps$18;

var styles$q = {"container":"micromag-fields-date-container","input":"micromag-fields-date-input"};

var propTypes$17 = {
  name: PropTypes.string,
  value: PropTypes.number,
  withTime: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$17 = {
  name: null,
  value: null,
  withTime: false,
  placeholder: null,
  className: null,
  onChange: null
};
var DateField = function DateField(_ref) {
  var name = _ref.name,
    value = _ref.value,
    placeholder = _ref.placeholder,
    className = _ref.className,
    withTime = _ref.withTime,
    onChange = _ref.onChange;
  var onInputChange = useCallback(function (e) {
    if (onChange !== null) {
      var val = e.currentTarget.value || null;
      onChange(val);
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$q.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("input", {
    type: withTime ? 'datetime-local' : 'date',
    className: classNames([styles$q.input, 'form-control', 'ms-auto']),
    name: name,
    value: value !== null ? value : '',
    autoComplete: "off",
    onChange: onInputChange,
    placeholder: placeholder
  }));
};
DateField.propTypes = propTypes$17;
DateField.defaultProps = defaultProps$17;

var propTypes$16 = {
  name: PropTypes.string,
  value: PropTypes$1.textElement,
  withTime: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$16 = {
  name: null,
  value: null,
  withTime: false,
  placeholder: null,
  onChange: null
};
var DateElement = function DateElement(_ref) {
  var name = _ref.name,
    value = _ref.value,
    withTime = _ref.withTime,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder;
  var bodyValue = value !== null ? value.body || null : null;
  var onBodyChange = useCallback(function (e) {
    var val = e.currentTarget.value || null;
    var newValue = _objectSpread(_objectSpread({}, value), {}, {
      body: val
    });
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, onChange]);
  return /*#__PURE__*/React.createElement("input", {
    type: withTime ? 'datetime-local' : 'date',
    className: classNames([styles$q.input, 'form-control', 'ms-auto']),
    name: name,
    value: bodyValue !== null ? bodyValue : '',
    autoComplete: "off",
    onChange: onBodyChange,
    placeholder: placeholder
  });
};
DateElement.propTypes = propTypes$16;
DateElement.defaultProps = defaultProps$16;

var _excluded$q = ["value", "className", "onChange"];
var propTypes$15 = {
  value: PropTypes$1.callToAction,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$15 = {
  value: null,
  className: null,
  onChange: null
};
var ShareIncentive = function ShareIncentive(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$q);
  var _ref2 = value || {},
    _ref2$active = _ref2.active,
    active = _ref2$active === void 0 ? false : _ref2$active;
  var intl = useIntl();

  // set default type and label
  var onUpdateValue = useCallback(function (newValue) {
    var _ref3 = value || {},
      _ref3$active = _ref3.active,
      wasActive = _ref3$active === void 0 ? false : _ref3$active;
    var _ref4 = newValue || {},
      _ref4$active = _ref4.active,
      nowActive = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? null : _ref4$label;
    var finalValue = _objectSpread({}, newValue);
    if (!wasActive && nowActive) {
      if (label === null) {
        finalValue.label = {
          body: intl.formatMessage(defineMessage({
            id: "d/01YO",
            defaultMessage: [{
              "type": 0,
              "value": "Share this Micromag!"
            }]
          }))
        };
      }
    }
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    className: classNames([styles$s.container, _defineProperty(_defineProperty({}, className, className !== null), styles$s.active, active)]),
    fieldClassName: styles$s.field
  }, props, {
    value: value,
    onChange: onUpdateValue
  }));
};
ShareIncentive.propTypes = propTypes$15;
ShareIncentive.defaultProps = defaultProps$15;

var _excluded$p = ["value", "className", "onChange"];
var propTypes$14 = {
  value: PropTypes$1.activeForm,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$14 = {
  value: null,
  className: null,
  onChange: null
};
var ShareIncentiveForm = function ShareIncentiveForm(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$p);
  var intl = useIntl();
  var onUpdateValue = useCallback(function (newValue) {
    var _ref2 = value || {},
      _ref2$active = _ref2.active,
      wasActive = _ref2$active === void 0 ? false : _ref2$active;
    var _ref3 = newValue || {},
      _ref3$active = _ref3.active,
      nowActive = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? null : _ref3$label;
    var finalValue = _objectSpread({}, newValue);
    if (!wasActive && nowActive) {
      if (label === null) {
        finalValue.label = {
          body: intl.formatMessage(defineMessage({
            id: "d/01YO",
            defaultMessage: [{
              "type": 0,
              "value": "Share this Micromag!"
            }]
          }))
        };
      }
    }
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    isForm: true,
    className: className,
    value: value,
    onChange: onUpdateValue,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "AV6gfh",
      defaultMessage: [{
        "type": 0,
        "value": "Edit call to action..."
      }]
    })
  }, props));
};
ShareIncentiveForm.propTypes = propTypes$14;
ShareIncentiveForm.defaultProps = defaultProps$14;

var styles$p = {"container":"micromag-fields-card-layout-container","button":"micromag-fields-card-layout-button","layout":"micromag-fields-card-layout-layout"};

var propTypes$13 = {
  types: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$13 = {
  types: ['content-top', 'content-bottom', 'content-split'],
  value: null,
  className: null,
  onChange: null
};
var CardLayout = function CardLayout(_ref) {
  var types = _ref.types,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  var onButtonLayoutChange = function onButtonLayoutChange(newVal) {
    var v = newVal === value ? null : newVal;
    onChange(v);
  };
  var getLayoutPreviewByType = useCallback(function (type) {
    switch (type) {
      case 'content-top':
        return /*#__PURE__*/React.createElement("div", {
          className: styles$p.layout
        }, /*#__PURE__*/React.createElement(PlaceholderTitle, {
          lines: 1,
          lineMargin: 1
        }), /*#__PURE__*/React.createElement(PlaceholderText, {
          lines: 2,
          lineMargin: 1
        }), /*#__PURE__*/React.createElement(PlaceholderImage, {
          width: "100%",
          height: "1.25em"
        }));
      case 'content-bottom':
        return /*#__PURE__*/React.createElement("div", {
          className: styles$p.layout
        }, /*#__PURE__*/React.createElement(PlaceholderImage, {
          width: "100%",
          height: "1.25em"
        }), /*#__PURE__*/React.createElement(PlaceholderTitle, {
          lines: 1,
          lineMargin: 1
        }), /*#__PURE__*/React.createElement(PlaceholderText, {
          lines: 2,
          lineMargin: 1
        }));
      case 'content-split':
        return /*#__PURE__*/React.createElement("div", {
          className: styles$p.layout
        }, /*#__PURE__*/React.createElement(PlaceholderTitle, {
          lines: 1,
          lineMargin: 1
        }), /*#__PURE__*/React.createElement(PlaceholderImage, {
          width: "100%",
          height: "1.25em"
        }), /*#__PURE__*/React.createElement(PlaceholderText, {
          lines: 2,
          lineMargin: 1
        }));
      default:
        return /*#__PURE__*/React.createElement("div", null);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-inline-flex', 'me-auto'])
  }, /*#__PURE__*/React.createElement(Radios, {
    options: types.map(function (type) {
      return {
        value: type,
        label: getLayoutPreviewByType(type)
      };
    }),
    value: value || null,
    className: classNames([styles$p.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$p.button,
    onChange: onButtonLayoutChange,
    uncheckable: true
  })));
};
CardLayout.propTypes = propTypes$13;
CardLayout.defaultProps = defaultProps$13;

var styles$o = {"item":"micromag-fields-checkboxes-item"};

var propTypes$12 = {
  name: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  singleChoice: PropTypes.bool,
  options: PropTypes$1.selectOptions,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$12 = {
  name: null,
  value: null,
  singleChoice: false,
  options: [],
  className: null,
  buttonClassName: null,
  onChange: null
};
var Checkboxes = function Checkboxes(_ref) {
  var name = _ref.name,
    value = _ref.value,
    singleChoice = _ref.singleChoice,
    options = _ref.options,
    className = _ref.className,
    buttonClassName = _ref.buttonClassName,
    _onChange = _ref.onChange;
  var finalOptions = useMemo(function () {
    return getSelectOptions(options);
  }, [options]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['btn-group', 'btn-group-toggle', styles$o.container, _defineProperty({}, className, className !== null)]),
    "data-toggle": "buttons"
  }, finalOptions.map(function (_ref3) {
    var optionValue = _ref3.value,
      label = _ref3.label;
    var active = value !== null && isArray(value) && value.indexOf(optionValue) !== -1 || !isArray(value) && value === optionValue;
    return /*#__PURE__*/React.createElement("label", {
      key: "radio-".concat(optionValue),
      className: classNames(['btn', 'btn-outline-secondary', styles$o.item, _defineProperty(_defineProperty({}, buttonClassName, buttonClassName !== null), "active", active)])
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      name: "".concat(name, "[]"),
      autoComplete: "off",
      value: optionValue,
      className: "btn-check",
      onChange: function onChange(e) {
        var newValue = null;
        if (!singleChoice) {
          newValue = value || [];
          if (e.currentTarget.checked) {
            newValue.push(optionValue);
          } else {
            newValue = value !== null ? value.filter(function (it) {
              return it !== optionValue;
            }) : null;
          }
          if (newValue.length === 0) {
            newValue = null;
          }
        } else if (e.currentTarget.checked) {
          newValue = optionValue;
        } else {
          newValue = null;
        }
        if (_onChange !== null) {
          _onChange(newValue);
        }
      },
      checked: active
    }), ' ', label);
  }));
};
Checkboxes.propTypes = propTypes$12;
Checkboxes.defaultProps = defaultProps$12;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$11 = {
  value: PropTypes$1.closedCaptionsMedia
};
var defaultProps$11 = {
  value: null
};
var ClosedCaptionField = function ClosedCaptionField(props) {
  return /*#__PURE__*/React.createElement(MediaField, Object.assign({
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "o3R+FM",
      defaultMessage: [{
        "type": 0,
        "value": "Select a closed captions file..."
      }]
    })
  }, props, {
    type: "subtitle"
  }));
};
ClosedCaptionField.propTypes = propTypes$11;
ClosedCaptionField.defaultProps = defaultProps$11;
ClosedCaptionField.withForm = true;

var propTypes$10 = {
  value: PropTypes.shape({
    color: PropTypes.string,
    alpha: PropTypes.number
  }),
  disableAlpha: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$10 = {
  value: null,
  disableAlpha: false,
  className: null,
  onChange: null
};
var ColorPickerField = function ColorPickerField(_ref) {
  var value = _ref.value,
    disableAlpha = _ref.disableAlpha,
    className = _ref.className,
    onChange = _ref.onChange;
  var getColors = useGetColors();
  var colors = useMemo(function () {
    return (getColors() || []).map(function (c) {
      return {
        color: c.color,
        title: v4()
      };
    });
  }, [getColors]);
  var _ref2 = value || {},
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? null : _ref2$color,
    _ref2$alpha = _ref2.alpha,
    alpha = _ref2$alpha === void 0 ? null : _ref2$alpha;
  var finalColor = useMemo(function () {
    var newColor = null;
    if (color !== null) {
      newColor = !isEmpty(color) ? tinycolor(color) : null;
    }
    if (alpha !== null) {
      if (newColor === null) {
        newColor = tinycolor('#000');
      }
      newColor.setAlpha(alpha);
    }
    return newColor !== null ? newColor.toRgb() : '';
  }, [color, alpha]);
  var onPickerChange = useCallback(function (newValue) {
    if (onChange !== null && newValue !== null) {
      // console.log('new color', newValue); // eslint-disable-line
      onChange({
        color: newValue.hex,
        alpha: newValue.rgb.a
      });
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['text-light', _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(SketchPicker, {
    color: finalColor,
    presetColors: colors,
    styles: {
      picker: {
        boxShadow: 'none'
      },
      label: {
        color: '#FFF'
      }
    },
    onChange: onPickerChange,
    disableAlpha: disableAlpha
  }));
};
ColorPickerField.propTypes = propTypes$10;
ColorPickerField.defaultProps = defaultProps$10;

var styles$n = {"preview":"micromag-fields-color-preview","color":"micromag-fields-color-color","picker":"micromag-fields-color-picker"};

var _excluded$o = ["value", "onChange", "closeForm", "disableAlpha", "canClear"];
var propTypes$$ = {
  value: PropTypes.shape({
    color: PropTypes.string,
    alpha: PropTypes.number
  }),
  isForm: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  canClear: PropTypes.bool,
  disableAlpha: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$$ = {
  value: null,
  isForm: false,
  isHorizontal: false,
  canClear: true,
  disableAlpha: false,
  className: null,
  onChange: null,
  closeForm: null
};
var ColorField = function ColorField(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    closeForm = _ref.closeForm,
    disableAlpha = _ref.disableAlpha,
    canClear = _ref.canClear,
    props = _objectWithoutProperties(_ref, _excluded$o);
  var _ref2 = value || {},
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? null : _ref2$color;
  var hexColor = useMemo(function () {
    return color !== null ? tinycolor(color).toHexString() : null;
  }, [color]);
  var previewElement = value !== null && color !== null ? /*#__PURE__*/React.createElement("span", {
    className: styles$n.preview
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$n.color,
    style: _objectSpread({}, getStyleFromColor(value))
  })) : null;
  var onClickReset = useCallback(function () {
    if (onChange !== null) {
      onChange(null);
    }
    if (closeForm !== null) {
      closeForm();
    }
  }, [onChange, closeForm]);
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    value: value,
    onChange: onChange,
    label: hexColor,
    thumbnail: previewElement,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "4YiKNK",
      defaultMessage: [{
        "type": 0,
        "value": "Select a color..."
      }]
    }),
    canClear: canClear
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, /*#__PURE__*/React.createElement(ColorPickerField, {
    className: styles$n.picker,
    value: value,
    onChange: onChange,
    disableAlpha: disableAlpha
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex mt-4"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "light",
    size: "md",
    onClick: closeForm
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "dj/p/q",
    defaultMessage: [{
      "type": 0,
      "value": "Close"
    }]
  })), value !== null ? /*#__PURE__*/React.createElement(Button, {
    outline: true,
    theme: "secondary",
    size: "md",
    className: "ms-auto",
    onClick: onClickReset
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Tol+/U",
    defaultMessage: [{
      "type": 0,
      "value": "Clear"
    }]
  })) : null)));
};
ColorField.propTypes = propTypes$$;
ColorField.defaultProps = defaultProps$$;
ColorField.withForm = true;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$_ = {};
var defaultProps$_ = {};
var ContainerStyleField = function ContainerStyleField(props) {
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    isList: true
  }, props));
};
ContainerStyleField.propTypes = propTypes$_;
ContainerStyleField.defaultProps = defaultProps$_;

var styles$m = {};

var _excluded$n = ["value", "fields", "name", "className", "onChange"];
var propTypes$Z = {
  value: PropTypes$1.conversation,
  fields: PropTypes$1.formFields,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$Z = {
  value: null,
  fields: null,
  className: null,
  onChange: null
};
var Conversation = function Conversation(_ref) {
  var value = _ref.value,
    fields = _ref.fields,
    name = _ref.name,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$n);
  var _ref2 = value || {},
    _ref2$speakers = _ref2.speakers,
    speakers = _ref2$speakers === void 0 ? null : _ref2$speakers;
  var speakerOptions = (speakers || []).map(function (_ref3, speakerIndex) {
    var id = _ref3.id,
      _ref3$name = _ref3.name,
      speakerName = _ref3$name === void 0 ? null : _ref3$name;
    return {
      value: id,
      label: speakerName !== null ? speakerName : "#".concat(speakerIndex + 1)
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$m.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(FieldContextProvider, {
    context: {
      options: speakerOptions
    }
  }, /*#__PURE__*/React.createElement(Fields, Object.assign({
    name: name,
    value: value,
    fields: fields,
    onChange: onChange
  }, props))));
};
Conversation.propTypes = propTypes$Z;
Conversation.defaultProps = defaultProps$Z;

var styles$l = {"container":"micromag-fields-custom-answer-container","field":"micromag-fields-custom-answer-field","active":"micromag-fields-custom-answer-active"};

var _excluded$m = ["value", "className", "onChange"];
var propTypes$Y = {
  value: PropTypes$1.customAnswer,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$Y = {
  value: null,
  className: null,
  onChange: null
};
var CustomAnswer = function CustomAnswer(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$m);
  var _ref2 = value || {},
    _ref2$active = _ref2.active,
    active = _ref2$active === void 0 ? false : _ref2$active;
  var intl = useIntl();
  var onUpdateValue = useCallback(function (newValue) {
    var _ref3 = value || {},
      _ref3$active = _ref3.active,
      wasActive = _ref3$active === void 0 ? false : _ref3$active;
    var _ref4 = newValue || {},
      _ref4$active = _ref4.active,
      nowActive = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? null : _ref4$label;
    var finalValue = _objectSpread({}, newValue);
    if (!wasActive && nowActive) {
      if (label === null) {
        finalValue.label = {
          body: intl.formatMessage(defineMessage({
            id: "4b5gym",
            defaultMessage: [{
              "type": 0,
              "value": "Screen title"
            }]
          }))
        };
      }
    }
    if (onChange !== null) {
      onChange(finalValue);
    }
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    className: classNames([styles$l.container, _defineProperty(_defineProperty({}, className, className !== null), styles$l.active, active)]),
    fieldClassName: styles$l.field
  }, props, {
    value: value,
    onChange: onUpdateValue
  }));
};
CustomAnswer.propTypes = propTypes$Y;
CustomAnswer.defaultProps = defaultProps$Y;

var propTypes$X = {
  name: PropTypes.string,
  fields: PropTypes$1.formFields,
  value: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  isList: PropTypes.bool,
  gotoFieldForm: PropTypes.func,
  closeFieldForm: PropTypes.func,
  onChange: PropTypes.func
};
var defaultProps$X = {
  name: null,
  fields: [],
  value: null,
  isList: false,
  gotoFieldForm: null,
  closeFieldForm: null,
  onChange: null
};
var ElementField = function ElementField(_ref) {
  var name = _ref.name,
    formFields = _ref.fields,
    value = _ref.value,
    gotoFieldForm = _ref.gotoFieldForm,
    closeFieldForm = _ref.closeFieldForm,
    isList = _ref.isList,
    onChange = _ref.onChange;
  var fields = formFields || [];
  var settingsNames = useMemo(function () {
    return fields ? fields.filter(function (_ref2) {
      var _ref2$setting = _ref2.setting,
        setting = _ref2$setting === void 0 ? false : _ref2$setting;
      return setting;
    }).map(function (it) {
      return it.name;
    }) : [];
  }, [fields]);
  var componentFields = useMemo(function () {
    return fields.filter(function (_ref3) {
      var _ref3$setting = _ref3.setting,
        setting = _ref3$setting === void 0 ? false : _ref3$setting;
      return !setting;
    });
  }, [fields]);
  var componentValue = useMemo(function () {
    if (value === null || settingsNames === null) {
      return value;
    }
    return Object.keys(value).reduce(function (scopedValue, key) {
      return settingsNames.indexOf(key) === -1 ? _objectSpread(_objectSpread({}, scopedValue), {}, _defineProperty({}, key, value[key])) : scopedValue;
    }, null);
  }, [fields, settingsNames, value]);
  var componentOnChange = useCallback(function (newComponentValue) {
    var newValue = _objectSpread(_objectSpread({}, value), newComponentValue);
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, onChange]);
  return /*#__PURE__*/React.createElement(Fields, {
    name: name,
    fields: componentFields,
    value: componentValue,
    gotoFieldForm: gotoFieldForm,
    closeFieldForm: closeFieldForm,
    onChange: componentOnChange,
    isList: isList
  });
};
ElementField.propTypes = propTypes$X;
ElementField.defaultProps = defaultProps$X;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$W = {};
var defaultProps$W = {};
var ElementList = function ElementList(props) {
  return /*#__PURE__*/React.createElement(ElementField, Object.assign({
    isList: true
  }, props));
};
ElementList.propTypes = propTypes$W;
ElementList.defaultProps = defaultProps$W;

var styles$k = {"container":"micromag-fields-fit-container","frame":"micromag-fields-fit-frame","inner":"micromag-fields-fit-inner","button":"micromag-fields-fit-button","shape":"micromag-fields-fit-shape","media":"micromag-fields-fit-media","cover":"micromag-fields-fit-cover","contain":"micromag-fields-fit-contain","fill":"micromag-fields-fit-fill","none":"micromag-fields-fit-none"};

var propTypes$V = {
  values: PropTypes.arrayOf(PropTypes$1.objectFitSize),
  value: PropTypes$1.objectFitSize,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$V = {
  values: ['cover', 'contain', null],
  // TODO, maybe add 'fill', 'scale-down', ?
  value: null,
  className: null,
  onChange: null
};
var ObjectFitSize = function ObjectFitSize(_ref) {
  var values = _ref.values,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Radios, {
    options: values.map(function (val) {
      return {
        value: val,
        label: /*#__PURE__*/React.createElement("div", {
          className: classNames([styles$k.frame, styles$k[val || 'none']])
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$k.shape
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$k.inner
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$k.media
        }))))
      };
    }),
    value: value,
    className: classNames([styles$k.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$k.button,
    onChange: onChange
  });
};
ObjectFitSize.propTypes = propTypes$V;
ObjectFitSize.defaultProps = defaultProps$V;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$U = {
  value: PropTypes$1.fontMedia
};
var defaultProps$U = {
  value: null
};
var FontField = function FontField(props) {
  return /*#__PURE__*/React.createElement(MediaField, Object.assign({
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "Wb5zY4",
      defaultMessage: [{
        "type": 0,
        "value": "Select a font file..."
      }]
    })
  }, props, {
    type: "font"
  }));
};
FontField.propTypes = propTypes$U;
FontField.defaultProps = defaultProps$U;
FontField.withForm = true;

var _excluded$l = ["value", "onChange", "closeForm", "maxFontsVisible", "isForm", "canClear"],
  _excluded2$1 = ["id", "fonts"];
var normalize = function normalize(str) {
  return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
var fontEquals = function fontEquals(fontA, fontB) {
  return fontA === fontB || isObject(fontA) && isObject(fontB) && fontA.type === fontB.type && fontA.name === fontB.name;
};
var propTypes$T = {
  value: PropTypes$1.font,
  isForm: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  canClear: PropTypes.bool,
  maxFontsVisible: PropTypes.number,
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$T = {
  value: null,
  isForm: false,
  isHorizontal: false,
  canClear: true,
  maxFontsVisible: 10,
  className: null,
  onChange: null,
  closeForm: null
};
var FontFamily = function FontFamily(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    closeForm = _ref.closeForm,
    maxFontsVisible = _ref.maxFontsVisible,
    isForm = _ref.isForm,
    canClear = _ref.canClear,
    props = _objectWithoutProperties(_ref, _excluded$l);
  var intl = useIntl();
  var _useFonts = useFonts(),
    systemFonts = _useFonts.systemFonts,
    googleFonts = _useFonts.googleFonts,
    customFonts = _useFonts.customFonts;
  var valueName = value !== null && isObject(value) ? value.name || null : value;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var onSearchChange = useCallback(function (id, newValue) {
    return setSearch(_objectSpread(_objectSpread({}, search), {}, _defineProperty({}, id, newValue)));
  }, [search, setSearch]);
  var fontsGroups = useMemo(function () {
    return [customFonts !== null && customFonts.length > 0 ? {
      id: 'custom',
      title: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "UtcYEP",
        defaultMessage: [{
          "type": 0,
          "value": "Custom fonts"
        }]
      }),
      fonts: customFonts
    } : null, systemFonts !== null && systemFonts.length > 0 ? {
      id: 'system',
      title: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "al5xjv",
        defaultMessage: [{
          "type": 0,
          "value": "Default fonts"
        }]
      }),
      fonts: systemFonts
    } : null, googleFonts !== null && googleFonts.length > 0 ? {
      id: 'google',
      title: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "VDu2FA",
        defaultMessage: [{
          "type": 0,
          "value": "Google Fonts"
        }]
      }),
      fonts: googleFonts
    } : null].filter(function (it) {
      return it !== null;
    }).map(function (_ref2) {
      var id = _ref2.id,
        fonts = _ref2.fonts,
        fontGroup = _objectWithoutProperties(_ref2, _excluded2$1);
      var hasSearch = fonts.length > maxFontsVisible;
      var currentSearch = search[id] || null;
      var searchNormalized = currentSearch !== null ? normalize(currentSearch) : null;
      var addedValueFont = hasSearch && value !== null ? fonts.find(function (font) {
        return fontEquals(font, value);
      }) || null : null;
      var filteredFonts = hasSearch ? fonts.filter(function (font) {
        return (searchNormalized === null || normalize(isObject(font) ? font.name : font).indexOf(searchNormalized) !== -1) && (addedValueFont === null || !fontEquals(addedValueFont, font));
      }).slice(0, maxFontsVisible) : fonts;
      return _objectSpread({
        id: id,
        fonts: addedValueFont !== null ? [addedValueFont].concat(_toConsumableArray(filteredFonts)) : filteredFonts,
        currentSearch: currentSearch,
        hasSearch: hasSearch
      }, fontGroup);
    });
  }, [systemFonts, googleFonts, customFonts, value, search]);
  var fontsToLoad = useMemo(function () {
    return isForm ? fontsGroups.reduce(function (allFonts, _ref3) {
      var fonts = _ref3.fonts;
      return [].concat(_toConsumableArray(allFonts), _toConsumableArray(fonts));
    }, []) : [value].filter(function (it) {
      return it !== null;
    });
  }, [fontsGroups]);
  useLoadedFonts(fontsToLoad);
  var onClickReset = useCallback(function () {
    if (onChange !== null) {
      onChange(null);
    }
    if (closeForm !== null) {
      closeForm();
    }
  }, [onChange, closeForm]);
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    value: value,
    onChange: onChange,
    label: valueName,
    thumbnail: value !== null ? /*#__PURE__*/React.createElement("strong", {
      className: classNames(['d-inline-block']),
      style: {
        fontFamily: getFontFamilyFromFont(value)
      }
    }, "Aa") : null,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "i+3ZrF",
      defaultMessage: [{
        "type": 0,
        "value": "Select a font family..."
      }]
    }),
    isForm: isForm,
    canClear: canClear
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, fontsGroups.map(function (_ref4, index) {
    var id = _ref4.id,
      title = _ref4.title,
      fonts = _ref4.fonts,
      hasSearch = _ref4.hasSearch,
      currentSearch = _ref4.currentSearch;
    return /*#__PURE__*/React.createElement("div", {
      className: index > 0 ? 'mt-4' : null,
      key: "font-".concat(id)
    }, /*#__PURE__*/React.createElement("h6", null, title), /*#__PURE__*/React.createElement("div", {
      className: "list-group"
    }, hasSearch ? /*#__PURE__*/React.createElement("div", {
      className: classNames(['list-group-item', 'px-2', 'py-2'])
    }, /*#__PURE__*/React.createElement("input", {
      type: "search",
      className: "form-control",
      value: currentSearch || '',
      placeholder: intl.formatMessage({
        id: "zh2m/S",
        defaultMessage: [{
          "type": 0,
          "value": "Search fonts..."
        }]
      }),
      onChange: function onChange(e) {
        return onSearchChange(id, e.currentTarget.value);
      }
    })) : null, fonts.map(function (font) {
      var _ref5 = isObject(font) ? font : {
          name: font
        },
        name = _ref5.name;
      return /*#__PURE__*/React.createElement("button", {
        key: "font-".concat(id, "-").concat(name),
        type: "button",
        className: classNames(['list-group-item', 'list-group-item-action', 'px-2', 'py-2', {
          active: valueName === name
        }]),
        onClick: function onClick() {
          onChange(font);
          closeForm();
        }
      }, /*#__PURE__*/React.createElement("strong", {
        className: "me-4",
        style: {
          fontFamily: getFontFamilyFromFont(font)
        }
      }, "Aa"), /*#__PURE__*/React.createElement("span", null, name));
    })));
  })), value !== null ? /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, /*#__PURE__*/React.createElement(Button, {
    outline: true,
    theme: "secondary",
    size: "md",
    className: "ms-auto",
    onClick: onClickReset
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Tol+/U",
    defaultMessage: [{
      "type": 0,
      "value": "Clear"
    }]
  }))) : null);
};
FontFamily.propTypes = propTypes$T;
FontFamily.defaultProps = defaultProps$T;
FontFamily.withForm = true;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$S = {
  value: PropTypes$1.imageMedias
};
var defaultProps$S = {
  value: null
};
var FontsField = function FontsField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "KCDOHI",
      defaultMessage: [{
        "type": 0,
        "value": "No font..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "8sWUOV",
      defaultMessage: [{
        "type": 0,
        "value": "Add an font file"
      }]
    }),
    itemComponent: FontField
  }, props));
};
FontsField.propTypes = propTypes$S;
FontsField.defaultProps = defaultProps$S;

var styles$j = {"container":"micromag-fields-number-container","clearButton":"micromag-fields-number-clearButton","input":"micromag-fields-number-input","arrow":"micromag-fields-number-arrow","arrowIcon":"micromag-fields-number-arrowIcon","dataListItems":"micromag-fields-number-dataListItems","dataListItem":"micromag-fields-number-dataListItem","dataListItemButton":"micromag-fields-number-dataListItemButton","fullWidth":"micromag-fields-number-fullWidth"};

var propTypes$R = {
  name: PropTypes.string,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  floatStep: PropTypes.number,
  "float": PropTypes.bool,
  dataList: PropTypes.arrayOf(PropTypes.number),
  autoComplete: PropTypes.bool,
  fullWidth: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$R = {
  name: null,
  value: null,
  min: null,
  max: null,
  step: 1,
  floatStep: 0.1,
  "float": false,
  dataList: null,
  autoComplete: false,
  fullWidth: false,
  placeholder: null,
  className: null,
  onChange: null
};
var NumberField = function NumberField(_ref) {
  var name = _ref.name,
    value = _ref.value,
    min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    floatStep = _ref.floatStep,
    _float = _ref["float"],
    dataList = _ref.dataList,
    autoComplete = _ref.autoComplete,
    fullWidth = _ref.fullWidth,
    placeholder = _ref.placeholder,
    className = _ref.className,
    onChange = _ref.onChange;
  var parseValue = useCallback(function (newValue) {
    return _float ? parseFloat(newValue) : parseInt(newValue, 10);
  });
  var onInputChange = useCallback(function (e) {
    if (onChange !== null) {
      var val = e.currentTarget.value;
      onChange(val.length ? parseValue(val) : null);
    }
  }, [onChange]);
  var hasDataList = dataList !== null;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dataListActive = _useState2[0],
    setDataListActive = _useState2[1];
  var onInputFocus = useCallback(function () {
    if (hasDataList) {
      setDataListActive(true);
    }
  }, [setDataListActive, hasDataList]);
  var onInputBlur = useCallback(function () {
    if (hasDataList && dataListActive) {
      setDataListActive(false);
    }
  }, [setDataListActive, hasDataList, dataListActive]);
  var onDataListClick = useCallback(function (dataListValue) {
    if (onChange !== null) {
      onChange(parseValue(dataListValue));
      setDataListActive(false);
    }
  }, [onChange, setDataListActive]);
  var onClear = useCallback(function () {
    if (onChange !== null) {
      onChange(null);
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$j.container, _defineProperty({}, className, className !== null), _defineProperty({}, styles$j.fullWidth, fullWidth)])
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    className: classNames([styles$j.input, 'form-control', 'ms-auto']),
    name: name,
    value: value !== null ? value : '',
    min: min,
    max: max,
    step: _float ? floatStep : step,
    autoComplete: autoComplete ? 'on' : 'off',
    onChange: onInputChange,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    placeholder: placeholder
  }), value === null && hasDataList ? /*#__PURE__*/React.createElement("div", {
    className: styles$j.arrow
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: styles$j.arrowIcon,
    icon: faChevronDown
  })) : null, value !== null ? /*#__PURE__*/React.createElement(ClearButton, {
    className: styles$j.clearButton,
    onClick: onClear
  }) : null, hasDataList && dataListActive ? /*#__PURE__*/React.createElement("ul", {
    className: styles$j.dataListItems
  }, dataList.map(function (dataListValue) {
    return /*#__PURE__*/React.createElement("li", {
      key: "data-list-".concat(dataListValue),
      className: styles$j.dataListItem
    }, /*#__PURE__*/React.createElement("button", {
      className: styles$j.dataListItemButton,
      type: "button",
      onTouchStart: function onTouchStart() {
        onDataListClick(dataListValue);
      },
      onMouseDown: function onMouseDown() {
        onDataListClick(dataListValue);
      }
    }, dataListValue));
  })) : null);
};
NumberField.propTypes = propTypes$R;
NumberField.defaultProps = defaultProps$R;

var _excluded$k = ["sizes"];
var propTypes$Q = {
  sizes: PropTypes.arrayOf(PropTypes.number)
};
var defaultProps$Q = {
  sizes: [12, 14, 16, 18, 20, 24, 28, 32, 48]
};
var FontSize = function FontSize(_ref) {
  var sizes = _ref.sizes,
    props = _objectWithoutProperties(_ref, _excluded$k);
  return /*#__PURE__*/React.createElement(NumberField, Object.assign({}, props, {
    dataList: sizes
  }));
};
FontSize.propTypes = propTypes$Q;
FontSize.defaultProps = defaultProps$Q;
FontSize.isHorizontal = true;

var _excluded$j = ["value", "options", "onChange"];
var propTypes$P = {
  value: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.node
  })),
  onChange: PropTypes.func
};
var defaultProps$P = {
  options: [{
    value: 'bold',
    label: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faBold
    })
  }, {
    value: 'italic',
    label: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faItalic
    })
  }, {
    value: 'underline',
    label: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUnderline
    })
  }],
  value: null,
  onChange: null
};
var FontStyles$1 = function FontStyles(_ref) {
  var value = _ref.value,
    options = _ref.options,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$j);
  var styleKeys = useMemo(function () {
    return options.map(function (it) {
      return it.value;
    });
  }, [options]);
  var onInputChange = useCallback(function (newStyleValue) {
    var newValue = _objectSpread(_objectSpread({}, value), styleKeys.reduce(function (valueMap, styleKey) {
      return _objectSpread(_objectSpread({}, valueMap), {}, _defineProperty({}, styleKey, newStyleValue !== null && newStyleValue.indexOf(styleKey) !== -1));
    }, {}));
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, styleKeys, onChange]);
  return /*#__PURE__*/React.createElement(Checkboxes, Object.assign({
    value: value !== null ? Object.keys(value).reduce(function (values, styleKey) {
      return styleKeys.indexOf(styleKey) !== -1 && value[styleKey] === true ? [].concat(_toConsumableArray(values), [styleKey]) : values;
    }, []) : null,
    options: options,
    onChange: onInputChange
  }, props));
};
FontStyles$1.propTypes = propTypes$P;
FontStyles$1.defaultProps = defaultProps$P;

var _excluded$i = ["value", "options", "onChange"];
var propTypes$O = {
  value: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func
};
var defaultProps$O = {
  options: [{
    value: 'capitalize',
    label: /*#__PURE__*/React.createElement("strong", null, "Aa")
  }, {
    value: 'uppercase',
    label: /*#__PURE__*/React.createElement("strong", null, "AA")
  }, {
    value: 'lowercase',
    label: /*#__PURE__*/React.createElement("strong", null, "aa")
  }],
  value: null,
  onChange: null
};
var TextTransform = function TextTransform(_ref) {
  var value = _ref.value,
    options = _ref.options,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$i);
  return /*#__PURE__*/React.createElement(Radios, Object.assign({
    value: value,
    options: options,
    onChange: onChange,
    uncheckable: true
  }, props));
};
TextTransform.propTypes = propTypes$O;
TextTransform.defaultProps = defaultProps$O;
TextTransform.isHorizontal = true;

var _excluded$h = ["value", "transformName", "onChange"];
var propTypes$N = {
  value: PropTypes.shape({}),
  transformName: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$N = {
  transformName: 'transform',
  value: null,
  onChange: null
};
var FontStyleTransform = function FontStyleTransform(_ref) {
  var value = _ref.value,
    transformName = _ref.transformName,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$h);
  var transformValue = value !== null ? value[transformName] || null : null;
  var onTransformChange = useCallback(function (newTransformValue) {
    var newValue = _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, transformName, newTransformValue));
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, transformName, onChange]);
  return /*#__PURE__*/React.createElement(TextTransform, Object.assign({
    value: transformValue,
    onChange: onTransformChange
  }, props));
};
FontStyleTransform.propTypes = propTypes$N;
FontStyleTransform.defaultProps = defaultProps$N;
FontStyleTransform.isHorizontal = true;

var _excluded$g = ["value", "options", "onChange"];
var propTypes$M = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func
};
var defaultProps$M = {
  options: [{
    value: 'left',
    label: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faAlignLeft
    })
  }, {
    value: 'center',
    label: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faAlignCenter
    })
  }, {
    value: 'right',
    label: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faAlignRight
    })
  }],
  value: null,
  onChange: null
};
var TextAlign = function TextAlign(_ref) {
  var value = _ref.value,
    options = _ref.options,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/React.createElement(Radios, Object.assign({
    value: value,
    options: options,
    onChange: onChange,
    uncheckable: true
  }, props));
};
TextAlign.propTypes = propTypes$M;
TextAlign.defaultProps = defaultProps$M;

var styles$i = {"item":"micromag-fields-font-style-with-align-item","button":"micromag-fields-font-style-with-align-button"};

var propTypes$L = {
  value: PropTypes.shape({}),
  fontStyleName: PropTypes.string,
  alignName: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$L = {
  fontStyleName: 'fontStyle',
  alignName: 'align',
  value: null,
  className: null,
  onChange: null
};
var FontStyles = function FontStyles(_ref) {
  var value = _ref.value,
    fontStyleName = _ref.fontStyleName,
    alignName = _ref.alignName,
    className = _ref.className,
    onChange = _ref.onChange;
  var fontStyleValue = value !== null ? value[fontStyleName] || null : null;
  var alignValue = value !== null ? value[alignName] || null : null;
  var onFontStyleChange = useCallback(function (newFontStyleValue) {
    var newValue = _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, fontStyleName, newFontStyleValue));
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, fontStyleValue, fontStyleName, onChange]);
  var onAlignChange = useCallback(function (newAlignValue) {
    var newValue = _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, alignName, newAlignValue));
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, alignName, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', styles$i.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(FontStyles$1, {
    className: styles$i.item,
    buttonClassName: styles$i.button,
    value: fontStyleValue,
    onChange: onFontStyleChange
  }), /*#__PURE__*/React.createElement(TextAlign, {
    className: styles$i.item,
    buttonClassName: styles$i.button,
    value: alignValue,
    onChange: onAlignChange
  }));
};
FontStyles.propTypes = propTypes$L;
FontStyles.defaultProps = defaultProps$L;

var propTypes$K = {
  value: PropTypes.string,
  sizes: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$K = {
  value: null,
  sizes: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  className: null,
  onChange: null
};
var FontWeight = function FontWeight(_ref) {
  var value = _ref.value,
    sizes = _ref.sizes,
    className = _ref.className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(SliderField, {
    value: value,
    min: sizes[0],
    max: sizes[sizes.length - 1],
    marks: sizes,
    marksStep: 100,
    className: classNames([styles$v.container, _defineProperty({}, className, className !== null)]),
    onChange: onChange
  });
};
FontWeight.propTypes = propTypes$K;
FontWeight.defaultProps = defaultProps$K;

var styles$h = {"container":"micromag-fields-geo-position-container","autoComplete":"micromag-fields-geo-position-autoComplete","address":"micromag-fields-geo-position-address","map":"micromag-fields-geo-position-map","pin":"micromag-fields-geo-position-pin","infos":"micromag-fields-geo-position-infos","coords":"micromag-fields-geo-position-coords","coord":"micromag-fields-geo-position-coord"};

var propTypes$J = {
  value: PropTypes$1.geoPosition,
  defaultCenter: PropTypes$1.geoPosition,
  defaultZoom: PropTypes.number,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$J = {
  value: null,
  defaultCenter: {
    lat: 45.5,
    lng: -73.56
  },
  defaultZoom: 10,
  className: null,
  onChange: null
};
var getFixedCoords = function getFixedCoords(_ref) {
  var lat = _ref.lat,
    lng = _ref.lng;
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  return {
    lat: parseFloat(lat.toFixed(precision)),
    lng: parseFloat(lng.toFixed(precision))
  };
};
var GeoPosition = function GeoPosition(_ref2) {
  var value = _ref2.value,
    defaultCenter = _ref2.defaultCenter,
    defaultZoom = _ref2.defaultZoom,
    className = _ref2.className,
    onChange = _ref2.onChange;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    address = _useState2[0],
    setAddress = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mapReady = _useState4[0],
    setMapReady = _useState4[1];
  var _useState5 = useState(defaultZoom),
    _useState6 = _slicedToArray(_useState5, 2),
    zoom = _useState6[0],
    setZoom = _useState6[1];
  var client = useGoogleMapsClient();
  var intl = useIntl();
  var addressInputRef = useRef(null);
  var autoCompleteRef = useRef(null);
  var _useState7 = useState(value),
    _useState8 = _slicedToArray(_useState7, 2),
    finalValue = _useState8[0],
    setFinalValue = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    dragValue = _useState0[0],
    setDragValue = _useState0[1];
  var onValuePropChanged = useCallback(function (newValue) {
    var mergedValue = _objectSpread(_objectSpread({}, value), newValue);
    setFinalValue(mergedValue);
    if (onChange !== null) {
      onChange(mergedValue);
    }
  }, [value, setFinalValue, onChange]);
  var onLatitudeChange = useCallback(function (lat) {
    onValuePropChanged({
      lat: lat
    });
  }, [onValuePropChanged]);
  var onLongitudeChange = useCallback(function (lng) {
    onValuePropChanged({
      lng: lng
    });
  }, [onValuePropChanged]);
  var onMapCenterChanged = useCallback(function (mapCenter) {
    return setFinalValue(getFixedCoords(mapCenter.toJSON()));
  }, [onValuePropChanged, setFinalValue]);
  var onMapDragEnd = useCallback(function (mapCenter) {
    setDragValue(getFixedCoords(mapCenter.toJSON()));
  }, [setDragValue]);
  useEffect(function () {
    if (dragValue !== null) {
      onValuePropChanged(dragValue);
    }
  }, [dragValue]);
  var onMapReady = useCallback(function () {
    setMapReady(true);
  }, [setMapReady]);
  var _ref3 = finalValue || {},
    _ref3$lat = _ref3.lat,
    lat = _ref3$lat === void 0 ? null : _ref3$lat,
    _ref3$lng = _ref3.lng,
    lng = _ref3$lng === void 0 ? null : _ref3$lng;
  var onPlaceChanged = useCallback(function () {
    var place = autoCompleteRef.current.getPlace();
    var _ref4 = place || {},
      _ref4$geometry = _ref4.geometry,
      geometry = _ref4$geometry === void 0 ? null : _ref4$geometry,
      _ref4$name = _ref4.name,
      name = _ref4$name === void 0 ? null : _ref4$name;
    if (geometry !== null) {
      var location = geometry.location;
      onValuePropChanged(getFixedCoords(location.toJSON()));
      setZoom(17);
    } else {
      setZoom(defaultZoom);
    }
    if (name !== null) {
      setAddress(name);
    }
  }, [onValuePropChanged, defaultZoom, setZoom]);
  var onSearchButtonClick = useCallback(function () {
    addressInputRef.current.focus();
  }, []);
  useEffect(function () {
    if (client !== null) {
      if (typeof client.maps.places !== 'undefined') {
        autoCompleteRef.current = new client.maps.places.Autocomplete(addressInputRef.current, {
          origin: defaultCenter
        });
        autoCompleteRef.current.setFields(['geometry', 'name']);
        autoCompleteRef.current.addListener('place_changed', onPlaceChanged);
      } else {
        console.log('Gmaps: Autocomplete requires "places" library'); // eslint-disable-line
      }
    }
  }, [client]);
  useEffect(function () {
    return function () {
      if (client !== null && autoCompleteRef.current !== null) {
        client.maps.event.clearListeners(autoCompleteRef.current, 'place_changed');
      }
    };
  }, [client]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$h.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$h.autoComplete, 'input-group'])
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onSearchButtonClick,
    className: "btn btn-secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSearch
  })), /*#__PURE__*/React.createElement("input", {
    type: "text",
    ref: addressInputRef,
    className: classNames([styles$h.address, 'form-control']),
    value: address,
    placeholder: intl.formatMessage({
      id: "KB7N5E",
      defaultMessage: [{
        "type": 0,
        "value": "Search a place on Google Maps"
      }]
    }),
    autoComplete: "off",
    onChange: function onChange(e) {
      setAddress(e.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$h.map
  }, /*#__PURE__*/React.createElement(Map, {
    center: value || defaultCenter,
    zoom: zoom,
    onCenterChanged: onMapCenterChanged,
    onDragEnd: onMapDragEnd,
    onReady: onMapReady,
    withoutStyle: true,
    zoomControl: true
  }), mapReady ? /*#__PURE__*/React.createElement("img", {
    className: styles$h.pin,
    src: Pin,
    alt: "Pin"
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: styles$h.infos
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "XhgKcw",
    defaultMessage: [{
      "type": 0,
      "value": "Move the map to position the place"
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$h.coords
  }, /*#__PURE__*/React.createElement("label", {
    className: styles$h.coord
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$h.coordLabel
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "zDH24s",
    defaultMessage: [{
      "type": 0,
      "value": "Latitude"
    }]
  }), ":"), /*#__PURE__*/React.createElement(NumberField, {
    "float": true,
    floatStep: 0.001,
    value: lat,
    min: -90,
    max: 90,
    onChange: onLatitudeChange,
    fullWidth: true
  })), /*#__PURE__*/React.createElement("label", {
    className: styles$h.coord
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$h.coordLabel
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "THKV4v",
    defaultMessage: [{
      "type": 0,
      "value": "Longitude"
    }]
  }), ":"), /*#__PURE__*/React.createElement(NumberField, {
    "float": true,
    floatStep: 0.001,
    value: lng,
    min: -180,
    max: 180,
    onChange: onLongitudeChange,
    fullWidth: true
  }))));
};
GeoPosition.propTypes = propTypes$J;
GeoPosition.defaultProps = defaultProps$J;

var styles$g = {"container":"micromag-fields-grid-layout-container","button":"micromag-fields-grid-layout-button","grid":"micromag-fields-grid-layout-grid","column":"micromag-fields-grid-layout-column"};

var propTypes$I = {
  grids: PropTypes.arrayOf(PropTypes$1.gridLayout),
  value: PropTypes.arrayOf(PropTypes.shape({
    rows: PropTypes.number,
    columns: PropTypes.arrayOf(PropTypes.number)
  })),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$I = {
  grids: [],
  value: null,
  className: null,
  onChange: null
};
var GridLayout = function GridLayout(_ref) {
  var grids = _ref.grids,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Radios, {
    options: grids.map(function (layout) {
      return {
        value: layout,
        label: /*#__PURE__*/React.createElement(Grid, {
          layout: layout,
          className: styles$g.grid,
          columnClassName: styles$g.column
        })
      };
    }),
    value: value !== null ? grids.find(function (it) {
      return getGridLayoutName(it) === getGridLayoutName(value);
    }) || null : null,
    className: classNames([styles$g.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$g.button,
    onChange: onChange
  });
};
GridLayout.propTypes = propTypes$I;
GridLayout.defaultProps = defaultProps$I;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$H = {
  value: PropTypes$1.imageMedia
};
var defaultProps$H = {
  value: null
};
var ImageField = function ImageField(props) {
  return /*#__PURE__*/React.createElement(MediaField, Object.assign({
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "B1MeY+",
      defaultMessage: [{
        "type": 0,
        "value": "Select an image..."
      }]
    })
  }, props, {
    type: "image"
  }));
};
ImageField.propTypes = propTypes$H;
ImageField.defaultProps = defaultProps$H;
ImageField.withForm = true;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$G = {
  value: PropTypes$1.imageMedias
};
var defaultProps$G = {
  value: null
};
var ImagesField = function ImagesField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "t+L1J/",
      defaultMessage: [{
        "type": 0,
        "value": "No image..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "V+G2s+",
      defaultMessage: [{
        "type": 0,
        "value": "Add an image"
      }]
    }),
    itemComponent: ImageField
  }, props));
};
ImagesField.propTypes = propTypes$G;
ImagesField.defaultProps = defaultProps$G;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$F = {};
var defaultProps$F = {};
var ImageStyleField = function ImageStyleField(props) {
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    isList: true
  }, props));
};
ImageStyleField.propTypes = propTypes$F;
ImageStyleField.defaultProps = defaultProps$F;

/* eslint-disable react/jsx-props-no-spreading */
// import ImageField from './Image';

var propTypes$E = {
  value: PropTypes$1.imageMedias
};
var defaultProps$E = {
  value: null
};
var ImagesWithCaptionField = function ImagesWithCaptionField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "t+L1J/",
      defaultMessage: [{
        "type": 0,
        "value": "No image..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "V+G2s+",
      defaultMessage: [{
        "type": 0,
        "value": "Add an image"
      }]
    })
  }, props));
};
ImagesWithCaptionField.propTypes = propTypes$E;
ImagesWithCaptionField.defaultProps = defaultProps$E;

var propTypes$D = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errors: PropTypes$1.errors,
  required: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$D = {
  id: null,
  value: null,
  errors: null,
  required: false,
  className: null,
  onChange: null
};
var TextareaField = function TextareaField(_ref) {
  var id = _ref.id,
    value = _ref.value,
    errors = _ref.errors,
    required = _ref.required,
    className = _ref.className,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("textarea", {
    id: id,
    className: classNames(['form-control', _defineProperty({
      'is-invalid': errors !== null && errors.length > 0
    }, className, className !== null)]),
    value: value || '',
    onChange: function onChange(_ref3) {
      var _ref3$currentTarget$v = _ref3.currentTarget.value,
        newValue = _ref3$currentTarget$v === void 0 ? '' : _ref3$currentTarget$v;
      return _onChange !== null ? _onChange(!isEmpty(newValue) ? newValue : null) : null;
    },
    required: required
  });
};
TextareaField.propTypes = propTypes$D;
TextareaField.defaultProps = defaultProps$D;

var _excluded$f = ["value", "onChange", "multiline"];
var propTypes$C = {
  value: PropTypes$1.inputElement,
  multiline: PropTypes.bool,
  onChange: PropTypes.func
};
var defaultProps$C = {
  multiline: false,
  value: null,
  onChange: null
};
var TextElement$1 = function TextElement(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    multiline = _ref.multiline,
    props = _objectWithoutProperties(_ref, _excluded$f);
  var labelValue = value !== null ? value.label || null : null;
  var onLabelChange = useCallback(function (newLabel) {
    var newValue = _objectSpread(_objectSpread({}, value), {}, {
      label: newLabel
    });
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, onChange]);
  return multiline ? /*#__PURE__*/React.createElement(TextareaField, Object.assign({}, props, {
    value: labelValue,
    onChange: onLabelChange
  })) : /*#__PURE__*/React.createElement(TextField$1, Object.assign({}, props, {
    value: labelValue,
    onChange: onLabelChange
  }));
};
TextElement$1.propTypes = propTypes$C;
TextElement$1.defaultProps = defaultProps$C;

var styles$f = {"container":"micromag-fields-input-group-container"};

var propTypes$B = {
  prepend: PropTypes.node,
  children: PropTypes.node,
  append: PropTypes.node,
  size: PropTypes.oneOf([null, 'sm', 'lg']),
  className: PropTypes.string
};
var defaultProps$B = {
  prepend: null,
  children: null,
  append: null,
  size: null,
  className: null
};
var InputGroup = function InputGroup(_ref) {
  var prepend = _ref.prepend,
    children = _ref.children,
    append = _ref.append,
    size = _ref.size,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['input-group', _defineProperty({}, "input-group-".concat(size), size !== null), styles$f.container, _defineProperty({}, className, className !== null)])
  }, isString(prepend) ? /*#__PURE__*/React.createElement("div", {
    className: "input-group-text"
  }, prepend) : prepend, children, isString(append) ? /*#__PURE__*/React.createElement("div", {
    className: "input-group-text"
  }, append) : append);
};
InputGroup.propTypes = propTypes$B;
InputGroup.defaultProps = defaultProps$B;

var styles$e = {"buttonLabel":"micromag-fields-keypad-layout-buttonLabel","keypad":"micromag-fields-keypad-layout-keypad","preview":"micromag-fields-keypad-layout-preview","buttonVisual":"micromag-fields-keypad-layout-buttonVisual"};

var _excluded$e = ["value", "onChange", "closeForm"];
var propTypes$A = {
  value: PropTypes.shape({
    color: PropTypes.string,
    alpha: PropTypes.number
  }),
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$A = {
  value: null,
  className: null,
  onChange: null,
  closeForm: null
};
var KeypadLayout = function KeypadLayout(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
    _ref.closeForm;
    var props = _objectWithoutProperties(_ref, _excluded$e);
  var _ref2 = value || {},
    _ref2$columnAlign = _ref2.columnAlign,
    columnAlign = _ref2$columnAlign === void 0 ? null : _ref2$columnAlign,
    _ref2$columns = _ref2.columns,
    columns = _ref2$columns === void 0 ? null : _ref2$columns,
    _ref2$spacing = _ref2.spacing,
    spacing = _ref2$spacing === void 0 ? null : _ref2$spacing;
  var finalSpacingPreview = Math.max(0, Math.min(4, spacing));
  value !== null ? /*#__PURE__*/React.createElement(Keypad, {
    className: styles$e.keypad,
    align: columnAlign,
    columns: columns,
    spacing: finalSpacingPreview,
    items: [1, 2, 3, 4].map(function (n) {
      return /*#__PURE__*/React.createElement("div", {
        key: n,
        className: classNames([styles$e.preview, {
          // [styles.isPopupEmpty]: isPopupEmpty,
        }])
      }, /*#__PURE__*/React.createElement(PlaceholderImage, {
        className: styles$e.buttonVisual,
        height: 20
      }), /*#__PURE__*/React.createElement(PlaceholderText, {
        lines: 1,
        className: styles$e.buttonLabel
      }));
    })
  }) : null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Fields, Object.assign({
    value: value,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "XR5/Wk",
      defaultMessage: [{
        "type": 0,
        "value": "Edit"
      }]
    }),
    onChange: onChange,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "XR5/Wk",
      defaultMessage: [{
        "type": 0,
        "value": "Edit"
      }]
    })
  }, props)));
};
KeypadLayout.propTypes = propTypes$A;
KeypadLayout.defaultProps = defaultProps$A;

var styles$d = {"previewButton":"micromag-fields-keypad-layout-form-previewButton","previewKeypad":"micromag-fields-keypad-layout-form-previewKeypad","previewKey":"micromag-fields-keypad-layout-form-previewKey","oneColumn":"micromag-fields-keypad-layout-form-oneColumn"};

var _excluded$d = ["value", "onChange", "closeForm"];
function getPreviewItemsByColumns(columns) {
  switch (columns) {
    case 1:
      return [1, 2];
    case 2:
      return [1, 2, 3];
    case 3:
      return [1, 2, 3, 4];
    case 4:
      return [1, 2, 3, 4, 5, 6, 7];
    default:
      return [1, 2, 3];
  }
}
var propTypes$z = {
  value: PropTypes.shape({
    color: PropTypes.string,
    alpha: PropTypes.number
  }),
  isForm: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$z = {
  value: null,
  isForm: false,
  isHorizontal: false,
  className: null,
  onChange: null,
  closeForm: null
};
var KeypadLayoutForm = function KeypadLayoutForm(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
    _ref.closeForm;
    var props = _objectWithoutProperties(_ref, _excluded$d);
  var intl = useIntl();
  var _ref2 = value || {},
    _ref2$columnAlign = _ref2.columnAlign,
    columnAlign = _ref2$columnAlign === void 0 ? null : _ref2$columnAlign,
    _ref2$columns = _ref2.columns,
    columns = _ref2$columns === void 0 ? null : _ref2$columns,
    _ref2$spacing = _ref2.spacing,
    spacing = _ref2$spacing === void 0 ? null : _ref2$spacing;
  var finalSpacingPreview = Math.max(0, Math.min(4, spacing));
  var previewItems = getPreviewItemsByColumns(columns);
  function getAlignIntlLabel(columnAlignValue) {
    switch (columnAlignValue) {
      case 'left':
        return intl.formatMessage({
          id: "D29KoV",
          defaultMessage: [{
            "type": 0,
            "value": "left aligned"
          }]
        });
      case 'middle':
        return intl.formatMessage({
          id: "P9A8cx",
          defaultMessage: [{
            "type": 0,
            "value": "middle aligned"
          }]
        });
      case 'right':
        return intl.formatMessage({
          id: "FKOWH0",
          defaultMessage: [{
            "type": 0,
            "value": "right aligned"
          }]
        });
      default:
        return '';
    }
  }
  var label = /*#__PURE__*/React.createElement("div", {
    className: styles$d.previewLabel
  }, columns, ' ', intl.formatMessage({
    id: "mgjMWG",
    defaultMessage: [{
      "type": 0,
      "value": "columns"
    }]
  }), ' ', ", ", getAlignIntlLabel(columnAlign), ", ", spacing, "px");
  var previewElement = value !== null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Keypad, {
    className: classNames([styles$d.previewKeypad, _defineProperty({}, styles$d.oneColumn, columns === 1)]),
    align: columnAlign,
    columns: columns,
    spacing: finalSpacingPreview,
    items: previewItems.map(function (n) {
      return /*#__PURE__*/React.createElement("div", {
        key: n,
        className: styles$d.previewKey
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$d.previewButton
      }));
    })
  })) : null;
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    isForm: true,
    value: value,
    isHorizontal: false,
    label: label,
    onChange: onChange,
    thumbnail: previewElement
  }, props));
};
KeypadLayoutForm.propTypes = propTypes$z;
KeypadLayoutForm.defaultProps = defaultProps$z;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$y = {};
var defaultProps$y = {};
var MapField = function MapField(props) {
  return /*#__PURE__*/React.createElement(Fields, props);
};
MapField.propTypes = propTypes$y;
MapField.defaultProps = defaultProps$y;

var styles$c = {"container":"micromag-fields-margin-container","icon":"micromag-fields-margin-icon","slider":"micromag-fields-margin-slider"};

var propTypes$x = {
  value: PropTypes.number,
  unit: PropTypes.string,
  direction: PropTypes.oneOf(['top', 'bottom']),
  min: PropTypes.number,
  max: PropTypes.number,
  marksStep: PropTypes.number,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$x = {
  value: null,
  unit: 'pt',
  direction: 'top',
  min: 0,
  max: 20,
  marksStep: 5,
  className: null,
  onChange: null
};
var MarginField = function MarginField(_ref) {
  var value = _ref.value,
    unit = _ref.unit,
    direction = _ref.direction,
    min = _ref.min,
    max = _ref.max,
    marksStep = _ref.marksStep,
    className = _ref.className,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$c.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: direction === 'top' ? faArrowUp : faArrowDown,
    className: styles$c.icon
  }), /*#__PURE__*/React.createElement(SliderField, {
    value: value,
    min: min,
    max: max,
    marksStep: marksStep,
    marksStyle: {
      top: -2,
      fontSize: 8
    },
    withInput: true,
    unit: unit,
    onChange: function onChange(newValue) {
      return _onChange !== null ? _onChange(newValue !== 0 ? newValue : null) : null;
    },
    className: styles$c.slider
  }));
};
MarginField.propTypes = propTypes$x;
MarginField.defaultProps = defaultProps$x;
MarginField.isHorizontal = true;

var styles$b = {"container":"micromag-fields-marker-container","noValue":"micromag-fields-marker-noValue","value":"micromag-fields-marker-value","panel":"micromag-fields-marker-panel"};

var _excluded$c = ["isForm", "value", "className"];
var propTypes$w = {
  value: PropTypes.shape({
    text: PropTypes.string
  }),
  isForm: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps$w = {
  value: null,
  isForm: false,
  className: null
};
var MarkerField = function MarkerField(_ref) {
  var isForm = _ref.isForm,
    value = _ref.value,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$c);
  var _ref2 = value || {},
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? null : _ref2$title;
  return isForm ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$b.panel, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Fields, Object.assign({}, props, {
    value: value
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$b.container, _defineProperty({}, className, className !== null)])
  }, title !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles$b.value
  }, title.body)) : /*#__PURE__*/React.createElement("span", {
    className: styles$b.noValue
  }, "Entrez les infos..."));
};
MarkerField.propTypes = propTypes$w;
MarkerField.defaultProps = defaultProps$w;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$v = {};
var defaultProps$v = {};
var MarkersField = function MarkersField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "3E57H7",
      defaultMessage: [{
        "type": 0,
        "value": "No marker..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "qKQCxc",
      defaultMessage: [{
        "type": 0,
        "value": "Add a marker"
      }]
    }),
    itemComponent: MarkerField
  }, props));
};
MarkersField.propTypes = propTypes$v;
MarkersField.defaultProps = defaultProps$v;

var styles$a = {"container":"micromag-fields-media-thumbnail-container","radios":"micromag-fields-media-thumbnail-radios","thumbnail":"micromag-fields-media-thumbnail-thumbnail","button":"micromag-fields-media-thumbnail-button"};

var _excluded$b = ["value", "onChange", "className", "isForm"];
var propTypes$u = {
  value: PropTypes.oneOf([PropTypes.string, PropTypes$1.imageMedia]),
  isForm: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string
};
var defaultProps$u = {
  value: null,
  isForm: false,
  onChange: null,
  className: null
};
function MediaThumbnail(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className,
    isForm = _ref.isForm,
    props = _objectWithoutProperties(_ref, _excluded$b);
  var _ref2 = useFieldsValue() || {},
    _ref2$media = _ref2.media,
    media = _ref2$media === void 0 ? null : _ref2$media;
  var options = useMemo(function () {
    if (media === null) {
      return null;
    }
    var _media$files = media.files,
      files = _media$files === void 0 ? null : _media$files;
    return files !== null ? Object.keys(files).filter(function (key) {
      var _files$key$handle = files[key].handle,
        handle = _files$key$handle === void 0 ? null : _files$key$handle;
      return handle !== null && handle.match(/^thumbnail/) !== null;
    }).map(function (key) {
      var _files$key = files[key],
        handle = _files$key.handle,
        url = _files$key.url;
      return {
        value: handle,
        label: /*#__PURE__*/React.createElement("img", {
          src: url,
          alt: handle,
          className: styles$a.thumbnail
        })
      };
    }) : null;
  }, [media]);
  return isForm ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$a.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(ImageField, Object.assign({}, props, {
    isForm: true,
    value: isObject(value) ? value : null,
    onChange: onChange
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$a.container, _defineProperty({}, className, className !== null)])
  }, options !== null ? /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(Radios, Object.assign({
    value: !isObject(value) ? value : null,
    options: options || [],
    onChange: onChange,
    className: styles$a.radios,
    buttonClassName: styles$a.button
  }, props))) : null, /*#__PURE__*/React.createElement(FieldRow, Object.assign({}, props, {
    withForm: true
  }), /*#__PURE__*/React.createElement(ImageField, Object.assign({
    value: isObject(value) ? value : null,
    onChange: onChange
  }, props))));
}
MediaThumbnail.propTypes = propTypes$u;
MediaThumbnail.defaultProps = defaultProps$u;

var _excluded$a = ["type", "value", "fields", "noValueLabel", "withoutThumbnail", "onChange", "closeForm"];
var propTypes$t = {
  type: PropTypes.oneOfType([PropTypes$1.mediaTypes, PropTypes.arrayOf(PropTypes$1.mediaTypes)]),
  value: PropTypes$1.media,
  fields: PropTypes$1.formFields,
  noValueLabel: PropTypes$1.label,
  withoutThumbnail: PropTypes.bool,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$t = {
  type: null,
  value: null,
  fields: null,
  noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "EoVdMy",
    defaultMessage: [{
      "type": 0,
      "value": "Edit content..."
    }]
  }),
  withoutThumbnail: false,
  onChange: null,
  closeForm: null
};
var MessageField = function MessageField(_ref) {
  _ref.type;
    var value = _ref.value,
    fields = _ref.fields,
    noValueLabel = _ref.noValueLabel;
    _ref.withoutThumbnail;
    var onChange = _ref.onChange;
    _ref.closeForm;
    var props = _objectWithoutProperties(_ref, _excluded$a);
  var context = useFieldContext();
  var _ref2 = context || {},
    options = _ref2.options;
  var label = value !== null ? value.name || getFileName(value.url) || null : null;
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    value: value,
    onChange: onChange,
    noValueLabel: noValueLabel,
    label: label,
    thumbnailPath: "thumbnail_url",
    fields: fields.map(function (field) {
      return field.name === 'speaker' ? _objectSpread(_objectSpread({}, field), {}, {
        options: options
      }) : field;
    })
  }, props));
};
MessageField.propTypes = propTypes$t;
MessageField.defaultProps = defaultProps$t;
MessageField.withForm = true;

var _excluded$9 = ["icon", "iconRotation", "isHorizontal", "className"];
var fontAwesomeIconType = PropTypes.shape({
  icon: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array])),
  iconName: PropTypes.string,
  prefix: PropTypes.string
});
var propTypes$s = {
  icon: PropTypes.oneOfType([PropTypes.node, fontAwesomeIconType]),
  iconRotation: PropTypes.number,
  isHorizontal: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps$s = {
  icon: null,
  iconRotation: 0,
  isHorizontal: false,
  className: null
};
var NumberWithIcon = function NumberWithIcon(_ref) {
  var icon = _ref.icon,
    iconRotation = _ref.iconRotation,
    isHorizontal = _ref.isHorizontal,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', 'align-items-center', _defineProperty({
      'justify-content-end': isHorizontal
    }, className, className !== null)])
  }, /*#__PURE__*/React.createElement("span", {
    className: "me-2",
    style: iconRotation !== 0 ? {
      transform: "rotate(".concat(iconRotation, "deg)")
    } : null
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon
  })), /*#__PURE__*/React.createElement(NumberField, props));
};
NumberWithIcon.propTypes = propTypes$s;
NumberWithIcon.defaultProps = defaultProps$s;
NumberWithIcon.isHorizontal = true;

var styles$9 = {"spacing":"micromag-fields-padding-spacing"};

var _excluded$8 = ["value", "className", "onChange"];
var propTypes$r = {
  value: PropTypes.number,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$r = {
  value: null,
  className: null,
  onChange: null
};
var Spacing = function Spacing(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement(InputGroup, {
    className: className,
    append: "px"
  }, /*#__PURE__*/React.createElement(NumberField, Object.assign({
    value: value,
    min: 0,
    max: 20,
    onChange: onChange
  }, props)));
};
Spacing.propTypes = propTypes$r;
Spacing.defaultProps = defaultProps$r;

var _excluded$7 = ["value", "onChange", "closeForm"];
var propTypes$q = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    top: PropTypes.string,
    left: PropTypes.string,
    bottom: PropTypes.string,
    right: PropTypes.string
  })]),
  isForm: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$q = {
  value: null,
  isForm: false,
  isHorizontal: false,
  className: null,
  onChange: null,
  closeForm: null
};
var PaddingField = function PaddingField(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    closeForm = _ref.closeForm,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var intl = useIntl();
  var _ref2 = isObject(value) ? value : {
      top: value,
      left: value,
      bottom: value,
      right: value
    },
    _ref2$top = _ref2.top,
    top = _ref2$top === void 0 ? null : _ref2$top,
    _ref2$left = _ref2.left,
    left = _ref2$left === void 0 ? null : _ref2$left,
    _ref2$right = _ref2.right,
    right = _ref2$right === void 0 ? null : _ref2$right,
    _ref2$bottom = _ref2.bottom,
    bottom = _ref2$bottom === void 0 ? null : _ref2$bottom;
  var defaultValue = isObject(value) ? null : value;
  var previewElement = value !== null ? /*#__PURE__*/React.createElement("span", null, isObject(value) ? "".concat(top || 0, "px ").concat(left || 0, "px ").concat(bottom || 0, "px ").concat(right || 0, "px") : "".concat(value, "px")) : null;
  var onClickReset = useCallback(function () {
    if (onChange !== null) {
      onChange(null);
    }
  }, [onChange, closeForm]);
  var onSpacingChange = useCallback(function (newValue) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (direction !== null) {
      onChange(_objectSpread(_objectSpread({}, isObject(value) ? value : null), {}, _defineProperty({}, direction, newValue)));
    } else {
      onChange(newValue);
    }
  }, [value, onChange]);
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    value: value,
    onChange: onChange,
    label: null,
    thumbnail: previewElement,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "fbiNiR",
      defaultMessage: [{
        "type": 0,
        "value": "Select a size..."
      }]
    })
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "p-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 align-content-center justify-content-center my-2"
  }, /*#__PURE__*/React.createElement(Spacing, {
    className: styles$9.spacing,
    value: defaultValue || top,
    onChange: function onChange(val) {
      return onSpacingChange(val, 'top');
    },
    placeholder: intl.formatMessage({
      id: "n9LoBJ",
      defaultMessage: [{
        "type": 0,
        "value": "Top"
      }]
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 align-content-center justify-content-between my-2"
  }, /*#__PURE__*/React.createElement(Spacing, {
    className: styles$9.spacing,
    value: defaultValue || left,
    onChange: function onChange(val) {
      return onSpacingChange(val, 'left');
    },
    placeholder: intl.formatMessage({
      id: "GPqjnH",
      defaultMessage: [{
        "type": 0,
        "value": "Left"
      }]
    })
  }), /*#__PURE__*/React.createElement(Spacing, {
    className: styles$9.spacing,
    value: defaultValue || right,
    onChange: function onChange(val) {
      return onSpacingChange(val, 'right');
    },
    placeholder: intl.formatMessage({
      id: "kf/5Tw",
      defaultMessage: [{
        "type": 0,
        "value": "Right"
      }]
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 align-content-center justify-content-center my-2"
  }, /*#__PURE__*/React.createElement(Spacing, {
    className: styles$9.spacing,
    value: defaultValue || bottom,
    onChange: function onChange(val) {
      return onSpacingChange(val, 'bottom');
    },
    placeholder: intl.formatMessage({
      id: "PFNMAQ",
      defaultMessage: [{
        "type": 0,
        "value": "Bottom"
      }]
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex mt-4"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "light",
    size: "sm",
    onClick: closeForm
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "dj/p/q",
    defaultMessage: [{
      "type": 0,
      "value": "Close"
    }]
  })), value !== null ? /*#__PURE__*/React.createElement(Button, {
    outline: true,
    theme: "secondary",
    size: "sm",
    className: "ms-auto",
    onClick: onClickReset
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Tol+/U",
    defaultMessage: [{
      "type": 0,
      "value": "Clear"
    }]
  })) : null)));
};
PaddingField.propTypes = propTypes$q;
PaddingField.defaultProps = defaultProps$q;
PaddingField.withForm = true;

var styles$8 = {"container":"micromag-fields-position-container","button":"micromag-fields-position-button","rotateLeft":"micromag-fields-position-rotateLeft","rotateRight":"micromag-fields-position-rotateRight"};

var propTypes$p = {
  name: PropTypes.string,
  value: PropTypes.string,
  axisOptions: PropTypes.arrayOf(PropTypes.string),
  crossOptions: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$p = {
  name: null,
  value: null,
  axisOptions: ['top', 'center', 'bottom'],
  crossOptions: ['left', 'center', 'right'],
  className: null,
  buttonClassName: null,
  onChange: null
};
var Icon = function Icon(_ref) {
  var label = _ref.label;
  switch (label) {
    case 'top-left':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowUp,
        className: styles$8.rotateLeft
      });
    case 'top-center':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowUp,
        className: styles$8.icon
      });
    case 'top-right':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowUp,
        className: styles$8.rotateRight
      });
    case 'center-left':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowLeft,
        className: styles$8.icon
      });
    case 'center-center':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faDotCircle,
        className: styles$8.icon
      });
    case 'center-right':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowRight,
        className: styles$8.icon
      });
    case 'bottom-left':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowDown,
        className: styles$8.rotateRight
      });
    case 'bottom-center':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowDown,
        className: styles$8.icon
      });
    case 'bottom-right':
      return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faArrowDown,
        className: styles$8.rotateLeft
      });
  }
  return null;
};
Icon.propTypes = {
  label: PropTypes.string.isRequired
};
var Position = function Position(_ref2) {
  var name = _ref2.name,
    value = _ref2.value,
    vertical = _ref2.axisOptions,
    horizontal = _ref2.crossOptions,
    className = _ref2.className,
    buttonClassName = _ref2.buttonClassName,
    _onChange = _ref2.onChange;
  var axisOptions = useMemo(function () {
    return getSelectOptions(vertical);
  }, [vertical]);
  var crossOptions = useMemo(function () {
    return getSelectOptions(horizontal);
  }, [horizontal]);
  var _ref3 = value || {},
    _ref3$axisAlign = _ref3.axisAlign,
    axisAlign = _ref3$axisAlign === void 0 ? null : _ref3$axisAlign,
    _ref3$crossAlign = _ref3.crossAlign,
    crossAlign = _ref3$crossAlign === void 0 ? null : _ref3$crossAlign;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['btn-group', 'btn-group-toggle', styles$8.container, _defineProperty({}, className, className !== null)]),
    "data-toggle": "buttons"
  }, axisOptions.map(function (_ref5) {
    var axisOption = _ref5.value,
      axisLabel = _ref5.label;
    return crossOptions.map(function (_ref6) {
      var crossOption = _ref6.value,
        crossLabel = _ref6.label;
      return /*#__PURE__*/React.createElement("label", {
        key: "radio-".concat(axisOption, "-").concat(crossOption),
        className: classNames(['btn', 'btn-outline-secondary', _defineProperty(_defineProperty(_defineProperty({}, styles$8.button, true), "active", axisOption === axisAlign && crossOption === crossAlign), buttonClassName, buttonClassName !== null)])
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        name: name,
        autoComplete: "off",
        value: "".concat(axisOption, "-").concat(crossOption),
        onChange: function onChange(e) {
          if (_onChange !== null) {
            _onChange(e.currentTarget.checked ? {
              axisAlign: axisOption,
              crossAlign: crossOption
            } : value);
          }
        },
        checked: axisOption === axisAlign && crossOption === crossAlign
      }), ' ', /*#__PURE__*/React.createElement(Icon, {
        label: "".concat(axisLabel, "-").concat(crossLabel)
      }));
    });
  }));
};
Position.propTypes = propTypes$p;
Position.defaultProps = defaultProps$p;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$o = {};
var defaultProps$o = {};
var QuestionField = function QuestionField(props) {
  return /*#__PURE__*/React.createElement(Fields, Object.assign({
    isList: true
  }, props));
};
QuestionField.propTypes = propTypes$o;
QuestionField.defaultProps = defaultProps$o;

var styles$7 = {"container":"micromag-fields-layout-container","button":"micromag-fields-layout-button","layout":"micromag-fields-layout-layout","screen":"micromag-fields-layout-screen"};

var _excluded$6 = ["value", "screenState", "className", "onChange"];
var propTypes$n = {
  value: PropTypes.string,
  screenState: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$n = {
  value: null,
  screenState: null,
  className: null,
  onChange: null
};
var ScreenLayoutField = function ScreenLayoutField(_ref) {
  var value = _ref.value,
    screenState = _ref.screenState,
    className = _ref.className,
    onChange = _ref.onChange;
    _objectWithoutProperties(_ref, _excluded$6);
  var _useScreenDefinition = useScreenDefinition(),
    id = _useScreenDefinition.id,
    _useScreenDefinition$ = _useScreenDefinition.layouts,
    layouts = _useScreenDefinition$ === void 0 ? [] : _useScreenDefinition$;
  return /*#__PURE__*/React.createElement(Radios, {
    options: layouts.map(function (layout) {
      return {
        value: layout,
        label: /*#__PURE__*/React.createElement("div", {
          className: styles$7.layout
        }, /*#__PURE__*/React.createElement(ScreenPlaceholder, {
          screen: {
            type: id,
            layout: layout
          },
          screenState: screenState,
          withSize: true,
          className: styles$7.screen
        }))
      };
    }),
    value: value || (layouts ? layouts[0] : null),
    className: classNames([styles$7.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$7.button,
    onChange: onChange
  });
};
ScreenLayoutField.propTypes = propTypes$n;
ScreenLayoutField.defaultProps = defaultProps$n;

var styles$6 = {"lightCaret":"micromag-fields-select-lightCaret"};

var propTypes$m = {
  value: PropTypes.string,
  options: PropTypes$1.selectOptions,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$m = {
  value: null,
  options: [],
  disabled: false,
  className: null,
  onChange: null
};
var SelectField = function SelectField(_ref) {
  var value = _ref.value,
    options = _ref.options,
    disabled = _ref.disabled,
    className = _ref.className,
    _onChange = _ref.onChange;
  var finalOptions = useMemo(function () {
    return getSelectOptions(options);
  }, [options]);
  return /*#__PURE__*/React.createElement("select", {
    className: classNames([styles$6.container, 'form-select', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$6.lightCaret, !disabled), 'bg-dark', !disabled), 'text-light', !disabled), 'text-dark', disabled), className, className !== null)]),
    value: value || '',
    disabled: disabled,
    onChange: function onChange(e) {
      return _onChange !== null ? _onChange(e.currentTarget.value !== '' ? e.currentTarget.value : null) : null;
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "--"), finalOptions.map(function (_ref3) {
    var optionValue = _ref3.value,
      optionLabel = _ref3.label;
    return /*#__PURE__*/React.createElement("option", {
      key: "select-".concat(optionValue),
      value: optionValue
    }, optionLabel);
  }));
};
SelectField.propTypes = propTypes$m;
SelectField.defaultProps = defaultProps$m;

var selectTheme = function selectTheme(theme) {
  return _objectSpread(_objectSpread({}, theme), {}, {
    colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
      // Color overrides
      primary: 'hsl(0, 0%, 90%)',
      primary75: 'hsl(0, 0%, 75%)',
      primary50: 'hsl(0, 0%, 50%)',
      primary25: 'hsl(0, 0%, 25%)',
      danger: '#DE350B',
      dangerLight: '#FFBDAD',
      neutral0: 'hsl(0, 0%, 10%)',
      neutral5: 'hsl(0, 0%, 20%)',
      neutral10: 'hsl(0, 0%, 30%)',
      neutral20: 'hsl(0, 0%, 40%)',
      neutral30: 'hsl(0, 0%, 50%)',
      neutral40: 'hsl(0, 0%, 60%)',
      neutral50: 'hsl(0, 0%, 70%)',
      neutral60: 'hsl(0, 0%, 80%)',
      neutral70: 'hsl(0, 0%, 90%)',
      neutral80: 'hsl(0, 0%, 95%)',
      neutral90: 'hsl(0, 0%, 100%)'
    })
    // Other options
    // borderRadius: 4
    // baseUnit: 4,
    // controlHeight: 38
    // menuGutter: baseUnit * 2
  });
};

var _excluded$5 = ["name", "value", "options", "withoutReset", "disabled", "className", "onChange"],
  _excluded2 = ["label"];
var propTypes$l = {
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes$1.selectOptions,
  withoutReset: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$l = {
  name: null,
  value: null,
  options: [],
  withoutReset: false,
  disabled: false,
  className: null,
  onChange: null
};
var SelectAdvancedField = function SelectAdvancedField(_ref) {
  var name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    withoutReset = _ref.withoutReset,
    disabled = _ref.disabled,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var finalOptions = useMemo(function () {
    return getSelectOptions(options);
  }, [options]);
  var intl = useIntl();
  var translatedOptions = useMemo(function () {
    return finalOptions.map(function (_ref2) {
      var label = _ref2.label,
        option = _objectWithoutProperties(_ref2, _excluded2);
      return _objectSpread(_objectSpread({}, option), {}, {
        label: _typeof(label) === 'object' ? intl.formatMessage(label) : label
      });
    });
  });
  var onChangeOption = useCallback(function (newValue) {
    if (onChange !== null) {
      onChange(newValue !== null && newValue.value ? newValue.value : null);
    }
  }, [onChange]);
  var optionValue = useMemo(function () {
    return translatedOptions.find(function (opt) {
      return opt.value !== null ? isEqual(value, opt.value) : false;
    });
  }, [value, options]);
  return /*#__PURE__*/React.createElement(Select, Object.assign({
    className: classNames([_defineProperty({}, className, className !== null)]),
    isClearable: !withoutReset
  }, props, {
    id: name,
    name: name,
    value: optionValue || value || null,
    options: translatedOptions,
    disabled: disabled,
    onChange: onChangeOption,
    theme: selectTheme
  }));
};
SelectAdvancedField.propTypes = propTypes$l;
SelectAdvancedField.defaultProps = defaultProps$l;

var styles$5 = {"container":"micromag-fields-shadow-angle-container","button":"micromag-fields-shadow-angle-button","type":"micromag-fields-shadow-angle-type","icon":"micromag-fields-shadow-angle-icon"};

var propTypes$k = {
  types: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$k = {
  types: [45, 90, -45, -90],
  value: null,
  className: null,
  onChange: null
};
var ShadowAngle = function ShadowAngle(_ref) {
  var types = _ref.types,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  var onShadowAngleChange = function onShadowAngleChange(newVal) {
    var v = newVal === value ? null : newVal;
    onChange(v);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-inline-flex', 'ms-auto', 'me-auto'])
  }, /*#__PURE__*/React.createElement(Radios, {
    options: types.map(function (type) {
      var _getShadowCoords = getShadowCoords(type, 5),
        x = _getShadowCoords.x,
        y = _getShadowCoords.y;
      return {
        value: type,
        label: /*#__PURE__*/React.createElement("div", {
          className: styles$5.type
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$5.icon,
          style: {
            border: "2px solid currentColor",
            position: 'relative',
            boxShadow: "".concat(x, "px ").concat(y, "px 0 0 currentColor")
          }
        }))
      };
    }),
    value: value || null,
    className: classNames([styles$5.container, _defineProperty({}, className, className !== null)]),
    buttonClassName: styles$5.button,
    onChange: onShadowAngleChange
  })));
};
ShadowAngle.propTypes = propTypes$k;
ShadowAngle.defaultProps = defaultProps$k;

var _excluded$4 = ["value", "isForm", "className"];
var propTypes$j = {
  value: PropTypes.shape({
    text: PropTypes.string,
    image: PropTypes$1.imageMedia
  }),
  isForm: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps$j = {
  value: null,
  isForm: false,
  className: null
};
var SlideField = function SlideField(_ref) {
  var value = _ref.value,
    isForm = _ref.isForm,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var _ref2 = value || {},
    _ref2$text = _ref2.text,
    text = _ref2$text === void 0 ? null : _ref2$text;
  return isForm ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$B.panel, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Fields, Object.assign({
    className: classNames([{
      'p-2': isForm,
      className: className !== null
    }])
  }, props, {
    value: value
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$B.container, _defineProperty({}, className, className !== null)])
  }, text !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles$B.value
  }, text)) : /*#__PURE__*/React.createElement("span", {
    className: styles$B.noValue
  }, "Entrez les infos..."));
};
SlideField.propTypes = propTypes$j;
SlideField.defaultProps = defaultProps$j;

/* eslint-disable react/no-array-index-key, react/button-has-type, react/jsx-props-no-spreading */
var propTypes$i = {
  unit: PropTypes.string,
  withInput: PropTypes.bool
};
var defaultProps$i = {
  unit: '%',
  withInput: true
};
var SliderPixelField$1 = function SliderPixelField(props) {
  return /*#__PURE__*/React.createElement(SliderField, props);
};
SliderPixelField$1.propTypes = propTypes$i;
SliderPixelField$1.defaultProps = defaultProps$i;

/* eslint-disable react/no-array-index-key, react/button-has-type, react/jsx-props-no-spreading */
var propTypes$h = {
  unit: PropTypes.string,
  withInput: PropTypes.bool
};
var defaultProps$h = {
  unit: 'px',
  withInput: true
};
var SliderPixelField = function SliderPixelField(props) {
  return /*#__PURE__*/React.createElement(SliderField, props);
};
SliderPixelField.propTypes = propTypes$h;
SliderPixelField.defaultProps = defaultProps$h;

/* eslint-disable react/no-array-index-key, react/button-has-type, react/jsx-props-no-spreading */
var propTypes$g = {
  unit: PropTypes.string,
  withInput: PropTypes.bool
};
var defaultProps$g = {
  unit: 'pt',
  withInput: true
};
var SliderPointField = function SliderPointField(props) {
  return /*#__PURE__*/React.createElement(SliderField, props);
};
SliderPointField.propTypes = propTypes$g;
SliderPointField.defaultProps = defaultProps$g;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$f = {};
var defaultProps$f = {};
var SlidesField = function SlidesField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "OdcEna",
      defaultMessage: [{
        "type": 0,
        "value": "No slide..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "tAYwqp",
      defaultMessage: [{
        "type": 0,
        "value": "Add a slide"
      }]
    }),
    itemComponent: SlideField
  }, props));
};
SlidesField.propTypes = propTypes$f;
SlidesField.defaultProps = defaultProps$f;

var styles$4 = {"container":"micromag-fields-static-field-container","icon":"micromag-fields-static-field-icon"};

var propTypes$e = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  name: PropTypes.string,
  className: PropTypes.string
};
var defaultProps$e = {
  value: null,
  name: null,
  className: null
};
var StaticField = function StaticField(_ref) {
  var value = _ref.value,
    name = _ref.name,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$4.container, _defineProperty({}, className, className !== null)])
  }, name === 'user' ? /*#__PURE__*/React.createElement("div", {
    className: styles$4.icon
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: styles$4.field
  }, value !== null ? value : null));
};
StaticField.propTypes = propTypes$e;
StaticField.defaultProps = defaultProps$e;

/* eslint-disable react/no-array-index-key, react/button-has-type, react/jsx-props-no-spreading */
var propTypes$d = {
  options: PropTypes.arrayOf(PropTypes.string),
  isForm: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$d = {
  options: ['_blank', 'self'],
  isForm: false,
  value: null,
  className: null,
  onChange: null
};
var TargetField = function TargetField(_ref) {
  var options = _ref.options,
    value = _ref.value,
    isForm = _ref.isForm,
    className = _ref.className,
    onChange = _ref.onChange;
  return isForm ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectField, {
    options: options,
    value: value,
    className: className,
    onChange: onChange
  })) : /*#__PURE__*/React.createElement("div", null, value);
};
TargetField.propTypes = propTypes$d;
TargetField.defaultProps = defaultProps$d;
TargetField.withForm = true;

/**
 * Locale loader
 */
var packageCache = null;
var useCKEditor = function useCKEditor() {
  var _useState = useState(packageCache),
    _useState2 = _slicedToArray(_useState, 2),
    loadedPackage = _useState2[0],
    setLoadedPackage = _useState2[1];
  useEffect(function () {
    var canceled = false;
    if (loadedPackage !== null) {
      return function () {
        canceled = true;
      };
    }
    import('@micromag/ckeditor/build').then(function (_ref) {
      var defaultExport = _ref["default"];
      packageCache = defaultExport;
      if (!canceled) {
        setLoadedPackage(packageCache);
      }
    });
    return function () {
      canceled = true;
    };
  }, [loadedPackage, setLoadedPackage]);
  return loadedPackage || {};
};

var styles$3 = {"container":"micromag-fields-text-editor-container","size-sm":"micromag-fields-text-editor-size-sm","size-lg":"micromag-fields-text-editor-size-lg"};

var propTypes$c = {
  value: PropTypes.string,
  size: PropTypes$1.formControlSize,
  className: PropTypes.string,
  onChange: PropTypes.func,
  inline: PropTypes.bool,
  withHighlightColors: PropTypes.bool,
  withFullEditor: PropTypes.bool,
  withoutLink: PropTypes.bool,
  textStyle: PropTypes.shape({}),
  editorConfig: PropTypes.shape({}),
  onFocus: PropTypes.func,
  disabled: PropTypes.bool
};
var defaultProps$c = {
  value: null,
  size: null,
  className: null,
  onChange: null,
  inline: false,
  withHighlightColors: false,
  withFullEditor: false,
  withoutLink: false,
  textStyle: null,
  editorConfig: {
    toolbar: ['bold', 'italic', 'superscript', 'highlight', '|', 'link', 'blockquote'],
    link: {
      addTargetToExternalLinks: true
    }
  },
  onFocus: null,
  disabled: false
};
var TextEditorField = function TextEditorField(_ref) {
  var value = _ref.value,
    size = _ref.size,
    className = _ref.className,
    textStyle = _ref.textStyle,
    editorConfig = _ref.editorConfig,
    inline = _ref.inline,
    withHighlightColors = _ref.withHighlightColors,
    withFullEditor = _ref.withFullEditor,
    withoutLink = _ref.withoutLink,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    disabled = _ref.disabled;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var _ref2 = textStyle || {},
    _ref2$highlight = _ref2.highlight,
    highlightStyle = _ref2$highlight === void 0 ? null : _ref2$highlight,
    _ref2$link = _ref2.link,
    linkStyle = _ref2$link === void 0 ? null : _ref2$link;
  var _useCKEditor = useCKEditor(),
    _useCKEditor$Editor = _useCKEditor.Editor,
    Editor = _useCKEditor$Editor === void 0 ? null : _useCKEditor$Editor,
    _useCKEditor$InlineEd = _useCKEditor.InlineEditor,
    InlineEditor = _useCKEditor$InlineEd === void 0 ? null : _useCKEditor$InlineEd,
    _useCKEditor$defaultP = _useCKEditor.defaultPlugins,
    defaultPlugins = _useCKEditor$defaultP === void 0 ? [] : _useCKEditor$defaultP,
    _useCKEditor$fullPlug = _useCKEditor.fullPlugins,
    fullPlugins = _useCKEditor$fullPlug === void 0 ? [] : _useCKEditor$fullPlug,
    _useCKEditor$inlinePl = _useCKEditor.inlinePlugins,
    inlinePlugins = _useCKEditor$inlinePl === void 0 ? [] : _useCKEditor$inlinePl;
  var getColors = useGetColors();
  var colors = useMemo(function () {
    return (withHighlightColors ? getColors() : null) || [];
  }, [withHighlightColors, getColors]);
  var defaultEditorConfig = useMemo(function () {
    if (withoutLink) {
      var _ref3 = editorConfig || {},
        _ref3$toolbar = _ref3.toolbar,
        items = _ref3$toolbar === void 0 ? null : _ref3$toolbar;
      return _objectSpread(_objectSpread({}, editorConfig), {}, {
        toolbar: (items || []).filter(function (it) {
          return it !== 'link' && it !== '|';
        })
      });
    }
    return editorConfig;
  }, [editorConfig, withoutLink]);
  var uniqueId = useId();
  var id = "editor-".concat(uniqueId);
  var finalEditorConfig = useMemo(function () {
    return _objectSpread(_objectSpread({
      extraPlugins: [].concat(_toConsumableArray(defaultPlugins), _toConsumableArray(inline ? inlinePlugins : []), _toConsumableArray(withFullEditor ? fullPlugins : [])).filter(function (it) {
        return it !== null;
      }),
      highlight: {
        options: [{
          model: 'marker',
          title: 'Marker',
          type: 'marker'
        }].concat(_toConsumableArray(colors.map(function (color, index) {
          return {
            model: "marker_".concat(index),
            type: 'marker',
            color: getColorAsString(color)
          };
        })))
      },
      toolbar: {
        items: ['undo', 'redo', '|', 'heading', '|', 'bold', 'italic', 'superscript', '|', 'link', 'uploadImage', 'insertTable', 'mediaEmbed', '|', 'bulletedList', 'numberedList', 'outdent', 'indent']
      },
      language: locale
    }, defaultEditorConfig), {}, {
      mediaEmbed: {
        previewsInData: true
      }
    });
  }, [defaultEditorConfig, inline, locale, withFullEditor, defaultPlugins, inlinePlugins, fullPlugins]);
  var onEditorReady = useCallback(function () {}, []);
  var onEditorChange = useCallback(function (event, editor) {
    var data = editor.getData();
    if (onChange !== null) {
      onChange(data);
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: classNames([styles$3.container, _defineProperty(_defineProperty({}, styles$3["size-".concat(size)], size !== null), className, className !== null)])
  }, Editor !== null ? /*#__PURE__*/React.createElement(CKEditor, {
    editor: !withFullEditor ? InlineEditor : Editor,
    config: finalEditorConfig,
    data: value || '',
    onReady: onEditorReady,
    onChange: onEditorChange,
    onFocus: onFocus,
    disabled: disabled
  }) : null, linkStyle !== null ? /*#__PURE__*/React.createElement(LinkStyle, {
    selector: "#".concat(CSS.escape(id), " .ck-content"),
    style: getStyleFromLink(linkStyle)
  }) : null, highlightStyle !== null ? /*#__PURE__*/React.createElement(HighlightStyle, {
    selector: "#".concat(CSS.escape(id), " .ck-content"),
    style: getStyleFromHighlight(highlightStyle)
  }) : null);
};
TextEditorField.propTypes = propTypes$c;
TextEditorField.defaultProps = defaultProps$c;

var _excluded$3 = ["value", "onChange", "inline", "textOnly", "onFocus", "disabled"];
var propTypes$b = {
  value: PropTypes$1.textElement,
  inline: PropTypes.bool,
  textOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool
};
var defaultProps$b = {
  inline: false,
  textOnly: false,
  value: null,
  onChange: null,
  onFocus: null,
  disabled: false
};
var TextElement = function TextElement(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    inline = _ref.inline,
    textOnly = _ref.textOnly,
    onFocus = _ref.onFocus,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var bodyValue = value !== null ? value.body || null : null;
  var textStyleValue = value !== null ? value.textStyle || null : null;
  var onBodyChange = useCallback(function (newBody) {
    var newValue = _objectSpread(_objectSpread({}, value), {}, {
      body: newBody
    });
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, onChange]);
  if (textOnly) {
    return inline ? /*#__PURE__*/React.createElement(TextField$1, Object.assign({}, props, {
      value: bodyValue,
      onChange: onBodyChange,
      onFocus: onFocus,
      disabled: disabled
    })) : /*#__PURE__*/React.createElement(TextareaField, Object.assign({}, props, {
      value: bodyValue,
      onChange: onBodyChange,
      onFocus: onFocus,
      disabled: disabled
    }));
  }
  return /*#__PURE__*/React.createElement(TextEditorField, Object.assign({}, props, {
    inline: inline,
    textStyle: textStyleValue,
    value: bodyValue,
    onChange: onBodyChange,
    onFocus: onFocus,
    disabled: disabled
  }));
};
TextElement.propTypes = propTypes$b;
TextElement.defaultProps = defaultProps$b;

var styles$2 = {"previewButton":"micromag-fields-text-modal-previewButton","dialog":"micromag-fields-text-modal-dialog","editor":"micromag-fields-text-modal-editor","dialogBody":"micromag-fields-text-modal-dialogBody","preview":"micromag-fields-text-modal-preview"};

var _excluded$2 = ["title", "value", "editorConfig", "inline", "withHighlightColors", "className", "onRequestClose", "onChange"];
var propTypes$a = {
  title: PropTypes.string,
  value: PropTypes.shape({
    body: PropTypes.string
  }),
  editorConfig: PropTypes.shape({}),
  inline: PropTypes.bool,
  withHighlightColors: PropTypes.bool,
  onChange: PropTypes.func,
  onRequestClose: PropTypes.func,
  className: PropTypes.string
};
var defaultProps$a = {
  title: null,
  value: null,
  editorConfig: null,
  inline: false,
  withHighlightColors: false,
  onChange: null,
  onRequestClose: null,
  className: null
};
var TextModal = function TextModal(_ref) {
  var title = _ref.title,
    value = _ref.value,
    editorConfig = _ref.editorConfig,
    inline = _ref.inline,
    withHighlightColors = _ref.withHighlightColors,
    className = _ref.className,
    onRequestClose = _ref.onRequestClose,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var _useUppyConfig = useUppyConfig(),
    xhr = _useUppyConfig.xhr;
  var _ref2 = xhr || {},
    _ref2$endpoint = _ref2.endpoint,
    xhrEndpoint = _ref2$endpoint === void 0 ? null : _ref2$endpoint;
  var previewEditorConfig = useMemo(function () {
    return {
      extraPlugins: [],
      highlight: {
        options: []
      },
      language: locale
    };
  }, [editorConfig, inline, locale]);
  var finalEditorConfig = useMemo(function () {
    return {
      toolbar: ['heading2', 'heading3', 'paragraph', '|', 'bold', 'italic', '|', 'link', 'blockQuote', 'bulletedList', 'numberedList', 'uploadImage'
      // 'mediaEmbed',
      ],
      link: {
        addTargetToExternalLinks: true
      },
      simpleUpload: {
        uploadUrl: xhrEndpoint || null,
        withCredentials: true,
        headers: _objectSpread({}, getCSRFHeaders())
      }
    };
  }, [editorConfig, inline, locale]);
  var bodyValue = value !== null && typeof value.body !== 'undefined' ? value.body || null : null;
  var onBodyChange = useCallback(function (newBody) {
    var newValue = _objectSpread(_objectSpread({}, value), {}, {
      body: newBody
    });
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, onChange]);
  var onOpen = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setModalOpen(true);
  }, [setModalOpen]);
  var onClose = useCallback(function (e) {
    setModalOpen(false);
    if (onRequestClose !== null) {
      onRequestClose(e);
    }
  }, [setModalOpen, onRequestClose]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles$2.previewButton,
    onClick: onOpen
  }, /*#__PURE__*/React.createElement(TextElement, {
    className: styles$2.preview,
    inline: true,
    value: value,
    disabled: true,
    editorConfig: previewEditorConfig
  })), modalOpen ? /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement(ModalDialog, {
    title: title || /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "/0hgRs",
      defaultMessage: [{
        "type": 0,
        "value": "Edit text"
      }]
    }),
    className: classNames([styles$2.dialog, _defineProperty({}, className, className)]),
    bodyClassName: styles$2.dialogBody,
    onClose: onClose,
    footer: /*#__PURE__*/React.createElement("div", {
      className: "p-2"
    }, /*#__PURE__*/React.createElement(Button, {
      className: styles$2.close,
      theme: "primary",
      onClick: onClose
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "dj/p/q",
      defaultMessage: [{
        "type": 0,
        "value": "Close"
      }]
    })))
  }, /*#__PURE__*/React.createElement(TextEditorField, Object.assign({}, props, {
    value: bodyValue,
    onChange: onBodyChange,
    className: styles$2.editor,
    inline: inline,
    withHighlightColors: withHighlightColors,
    withFullEditor: true,
    editorConfig: finalEditorConfig
  })))) : null);
};
TextModal.propTypes = propTypes$a;
TextModal.defaultProps = defaultProps$a;

var _excluded$1 = ["value", "fields", "sections", "onChange", "closeForm"];
var propTypes$9 = {
  value: PropTypes.shape({
    color: PropTypes.string,
    alpha: PropTypes.number
  }),
  fields: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })),
  isForm: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  sections: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  onChange: PropTypes.func,
  closeForm: PropTypes.func
};
var defaultProps$9 = {
  value: null,
  fields: [],
  isForm: false,
  isHorizontal: false,
  sections: null,
  className: null,
  onChange: null,
  closeForm: null
};
var TextStyleForm = function TextStyleForm(_ref) {
  var value = _ref.value,
    fields = _ref.fields,
    sections = _ref.sections,
    onChange = _ref.onChange;
    _ref.closeForm;
    var props = _objectWithoutProperties(_ref, _excluded$1);
  var textStyle = getStyleFromText(value);
  var _ref2 = textStyle || {},
    _ref2$fontFamily = _ref2.fontFamily,
    fontFamily = _ref2$fontFamily === void 0 ? null : _ref2$fontFamily;
  var fontLabel = fontFamily !== null ? fontFamily.replace(/['"]+/g, '') : null;
  var previewElement = value !== null ? /*#__PURE__*/React.createElement("strong", {
    className: "d-inline-block",
    style: {
      fontFamily: getFontFamilyFromFont(value)
    }
  }, "Aa") : null;
  var finalFields = sections !== null ? fields.filter(function (_ref3) {
    var name = _ref3.name;
    return sections.indexOf(name) !== -1;
  }) : fields;
  return /*#__PURE__*/React.createElement(FieldWithForm, Object.assign({
    isForm: true,
    fields: finalFields,
    value: value,
    label: fontLabel,
    onChange: onChange,
    thumbnail: previewElement,
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "wChc+A",
      defaultMessage: [{
        "type": 0,
        "value": "Edit style..."
      }]
    })
  }, props));
};
TextStyleForm.propTypes = propTypes$9;
TextStyleForm.defaultProps = defaultProps$9;
TextStyleForm.withForm = true;

var styles$1 = {"container":"micromag-fields-toggle-container"};

var propTypes$8 = {
  value: PropTypes.bool,
  defaultValue: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$8 = {
  value: null,
  defaultValue: null,
  className: null,
  onChange: null
};
var ToggleField = function ToggleField(_ref) {
  var value = _ref.value,
    defaultValue = _ref.defaultValue,
    className = _ref.className,
    onChange = _ref.onChange;
  var finalValue = value === null && (defaultValue === true || defaultValue === 'true') ? true : value;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles$1.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Switch, {
    checked: finalValue !== null ? finalValue : false,
    onChange: onChange
  }));
};
ToggleField.propTypes = propTypes$8;
ToggleField.defaultProps = defaultProps$8;
ToggleField.isHorizontal = true;

var styles = {"container":"micromag-fields-tokens-container"};

var propTypes$7 = {
  value: PropTypes.array,
  // eslint-disable-line
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
  loadOptions: PropTypes.func,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  getNewOptionData: PropTypes.func,
  className: PropTypes.string
};
var defaultProps$7 = {
  value: null,
  options: [],
  loadOptions: null,
  getOptionLabel: undefined,
  getOptionValue: undefined,
  getNewOptionData: undefined,
  onChange: null,
  className: null
};
var Tokens = function Tokens(_ref) {
  var value = _ref.value,
    options = _ref.options,
    loadOptions = _ref.loadOptions,
    getOptionLabel = _ref.getOptionLabel,
    getOptionValue = _ref.getOptionValue,
    getNewOptionData = _ref.getNewOptionData,
    onChange = _ref.onChange,
    className = _ref.className;
  var filterOptions = useCallback(function (inputValue) {
    return new Promise(function (resolve) {
      var filtered = options.filter(function (it) {
        return it.label.toLowerCase().includes(inputValue.toLowerCase());
      });
      resolve(filtered);
    });
  }, [options]);
  var onTokenChange = useCallback(function (newValue) {
    return onChange !== null ? onChange(newValue) : null;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(AsyncCreatableSelect, {
    isMulti: true,
    loadOptions: loadOptions || filterOptions,
    defaultOptions: options,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    getNewOptionData: getNewOptionData,
    components: {
      DropdownIndicator: function DropdownIndicator() {
        return null;
      },
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    },
    onChange: onTokenChange,
    value: value,
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "uSpItE",
      defaultMessage: [{
        "type": 0,
        "value": "Add tags..."
      }]
    }),
    theme: selectTheme
  }));
};
Tokens.propTypes = propTypes$7;
Tokens.defaultProps = defaultProps$7;

var _excluded = ["value", "options", "onChange"];
var propTypes$6 = {
  value: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.node
  })),
  onChange: PropTypes.func
};
var defaultProps$6 = {
  options: [{
    value: true,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "me-1",
      icon: faCheck
    }), /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "j00v1T",
      defaultMessage: [{
        "type": 0,
        "value": "True"
      }]
    }))
  }, {
    value: false,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "me-1",
      icon: faTimes
    }), /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "A/Vr8P",
      defaultMessage: [{
        "type": 0,
        "value": "False"
      }]
    }))
  }, {
    value: null,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "me-1",
      icon: faCircle
    }), /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "2LbLWQ",
      defaultMessage: [{
        "type": 0,
        "value": "None"
      }]
    }))
  }],
  value: null,
  onChange: null
};
var TrueFalse = function TrueFalse(_ref) {
  var value = _ref.value,
    options = _ref.options,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var onInputChange = useCallback(function (newValue) {
    if (onChange !== null) {
      onChange(newValue);
    }
  }, [value, onChange]);
  return /*#__PURE__*/React.createElement(Radios, Object.assign({
    value: value,
    options: options,
    onChange: onInputChange,
    asRadios: true
  }, props));
};
TrueFalse.propTypes = propTypes$6;
TrueFalse.defaultProps = defaultProps$6;

var getScheme = function getScheme(url, schemesPattern) {
  var match = url !== null ? url.match(schemesPattern) : null;
  return match !== null && match[1].length !== url.length ? match[1].toLowerCase() : null;
};
var removeScheme = function removeScheme(url, schemesPattern) {
  return url !== null ? url.replace(schemesPattern, '') : null;
};
var withScheme = function withScheme(url, prefix, schemesPattern) {
  return url !== null && !url.match(schemesPattern) ? "".concat(prefix).concat(url) : url;
};
var propTypes$5 = {
  value: PropTypes.string,
  schemes: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps$5 = {
  value: null,
  schemes: ['https://', 'http://'],
  className: null,
  onChange: null
};
var UrlField = function UrlField(_ref) {
  var schemes = _ref.schemes,
    value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange;
  var empty = isEmpty(value);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  useEffect(function () {
    setOpen(false);
  }, [value]);
  var schemesPattern = useMemo(function () {
    return new RegExp("^(".concat(schemes.join('|'), ")"), 'i');
  }, [schemes]);
  var scheme = useMemo(function () {
    return getScheme(value, schemesPattern) || schemes[0];
  }, [value, schemes, schemesPattern]);
  var valueWithoutScheme = useMemo(function () {
    return removeScheme(value, schemesPattern);
  }, [value, schemesPattern]);
  var onFieldChange = useCallback(function (newValue) {
    var valueWithScheme = !isEmpty(newValue) ? withScheme(newValue, scheme, schemesPattern) : null;
    if (onChange !== null) {
      onChange(valueWithScheme);
    }
  }, [onChange, scheme, schemesPattern]);
  var onClickOpen = useCallback(function () {
    setOpen(!open);
  }, [open, setOpen]);
  var onClickScheme = useCallback(function (sch) {
    setOpen(false);
    var newValueWithScheme = !isEmpty(value) ? withScheme(valueWithoutScheme, sch, schemesPattern) : null;
    if (onChange !== null) {
      onChange(newValueWithScheme);
    }
  }, [open, setOpen, schemesPattern, valueWithoutScheme, onChange]);
  var prepend = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: classNames(['btn', 'btn-outline-dark', 'text-light', 'fw-normal', {
      show: open,
      disabled: empty,
      'dropdown-toggle': !empty
    }]),
    type: "button",
    "aria-expanded": open ? 'false' : 'true',
    onClick: !empty ? onClickOpen : null
  }, scheme), /*#__PURE__*/React.createElement("ul", {
    className: classNames(['dropdown-menu', {
      show: open
    }])
  }, schemes.map(function (sch) {
    return /*#__PURE__*/React.createElement("li", {
      key: "scheme-".concat(sch)
    }, /*#__PURE__*/React.createElement("button", {
      className: classNames(['dropdown-item', {
        active: sch === scheme
      }]),
      type: "button",
      onClick: function onClick() {
        return onClickScheme(sch);
      }
    }, sch));
  })));
  return /*#__PURE__*/React.createElement(InputGroup, {
    prepend: prepend,
    className: className
  }, /*#__PURE__*/React.createElement(TextField$1, {
    value: valueWithoutScheme,
    onChange: onFieldChange
  }));
};
UrlField.propTypes = propTypes$5;
UrlField.defaultProps = defaultProps$5;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$4 = {
  value: PropTypes$1.videoMedia
};
var defaultProps$4 = {
  value: null
};
var VideoField = function VideoField(props) {
  return /*#__PURE__*/React.createElement(MediaField, Object.assign({
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "DWEzCv",
      defaultMessage: [{
        "type": 0,
        "value": "Select a video..."
      }]
    })
  }, props, {
    type: "video"
  }));
};
VideoField.propTypes = propTypes$4;
VideoField.defaultProps = defaultProps$4;
VideoField.withForm = true;

/* eslint-disable react/jsx-props-no-spreading */
var visualTypes = ['video', 'image'];
var propTypes$3 = {
  value: PropTypes$1.videoMedia
};
var defaultProps$3 = {
  value: null
};
var VisualField = function VisualField(props) {
  return /*#__PURE__*/React.createElement(MediaField, Object.assign({
    noValueLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "jnww6n",
      defaultMessage: [{
        "type": 0,
        "value": "Select an image..."
      }]
    })
  }, props, {
    type: visualTypes
  }));
};
VisualField.propTypes = propTypes$3;
VisualField.defaultProps = defaultProps$3;
VisualField.withForm = true;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$2 = {
  value: PropTypes$1.imageMedias
};
var defaultProps$2 = {
  value: null
};
var VisualsField = function VisualsField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "t+L1J/",
      defaultMessage: [{
        "type": 0,
        "value": "No image..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "V+G2s+",
      defaultMessage: [{
        "type": 0,
        "value": "Add an image"
      }]
    }),
    itemComponent: VisualField
  }, props));
};
VisualsField.propTypes = propTypes$2;
VisualsField.defaultProps = defaultProps$2;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$1 = {
  value: PropTypes$1.imageMedias
};
var defaultProps$1 = {
  value: null
};
var VisualsWithCaptionField = function VisualsWithCaptionField(props) {
  return /*#__PURE__*/React.createElement(ItemsField, Object.assign({
    noItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "3wiL2y",
      defaultMessage: [{
        "type": 0,
        "value": "No image..."
      }]
    }),
    addItemLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "9n9+yP",
      defaultMessage: [{
        "type": 0,
        "value": "Add an image"
      }]
    })
  }, props));
};
VisualsWithCaptionField.propTypes = propTypes$1;
VisualsWithCaptionField.defaultProps = defaultProps$1;

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AdFormat: AdFormatField,
    AlignHorizontal: AlignHorizontal,
    AlignVertical: AlignVertical,
    Alignment: Alignment,
    Answer: AnswerField,
    Answers: AnswersField,
    Audio: AudioField,
    Autocomplete: AutocompleteField,
    Badge: Badge,
    BorderRadius: BorderRadius,
    BorderStyle: BorderStyle,
    BorderWidth: BorderWidth,
    BoxStyleForm: BoxStyleForm,
    ButtonLayout: ButtonLayout,
    CallToAction: CallToAction,
    CallToActionForm: CallToActionForm,
    CardLayout: CardLayout,
    Checkboxes: Checkboxes,
    ClosedCaptions: ClosedCaptionField,
    Color: ColorField,
    ColorPicker: ColorPickerField,
    ContainerStyle: ContainerStyleField,
    Conversation: Conversation,
    CustomAnswer: CustomAnswer,
    Date: DateField,
    DateElement: DateElement,
    Element: ElementField,
    ElementList: ElementList,
    FieldWithForm: FieldWithForm,
    Fields: Fields,
    Fit: ObjectFitSize,
    Font: FontField,
    FontFamily: FontFamily,
    FontSize: FontSize,
    FontStyle: FontStyles$1,
    FontStyleTransform: FontStyleTransform,
    FontStyleWithAlign: FontStyles,
    FontWeight: FontWeight,
    Fonts: FontsField,
    GeoPosition: GeoPosition,
    GridLayout: GridLayout,
    Image: ImageField,
    ImageStyle: ImageStyleField,
    Images: ImagesField,
    ImagesWithCaption: ImagesWithCaptionField,
    InputElement: TextElement$1,
    InputGroup: InputGroup,
    Items: ItemsField,
    KeypadLayout: KeypadLayout,
    KeypadLayoutForm: KeypadLayoutForm,
    Map: MapField,
    Margin: MarginField,
    Marker: MarkerField,
    Markers: MarkersField,
    Media: MediaField,
    MediaModal: MediaModal,
    MediaThumbnail: MediaThumbnail,
    Message: MessageField,
    Number: NumberField,
    NumberWithIcon: NumberWithIcon,
    Padding: PaddingField,
    Position: Position,
    Question: QuestionField,
    Radios: Radios,
    ScreenLayout: ScreenLayoutField,
    Select: SelectField,
    SelectAdvanced: SelectAdvancedField,
    ShadowAngle: ShadowAngle,
    ShareIncentive: ShareIncentive,
    ShareIncentiveForm: ShareIncentiveForm,
    Slide: SlideField,
    Slider: SliderField,
    SliderPercentage: SliderPixelField$1,
    SliderPixel: SliderPixelField,
    SliderPoint: SliderPointField,
    Slides: SlidesField,
    Spacing: Spacing,
    StaticField: StaticField,
    Target: TargetField,
    Text: TextField$1,
    TextEditor: TextEditorField,
    TextElement: TextElement,
    TextModal: TextModal,
    TextStyleForm: TextStyleForm,
    TextTransform: TextTransform,
    Textarea: TextareaField,
    Toggle: ToggleField,
    ToggleSection: ToggleSection,
    Tokens: Tokens,
    TrueFalse: TrueFalse,
    Url: UrlField,
    Video: VideoField,
    Visual: VisualField,
    Visuals: VisualsField,
    VisualsWithCaption: VisualsWithCaptionField
});

/* eslint-disable react/jsx-props-no-spreading */
var propTypes = {
  children: PropTypes.node.isRequired
};
var defaultProps = {};
var FieldsProvider = function FieldsProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ComponentsProvider, {
    namespace: FIELDS_NAMESPACE,
    components: components
  }, /*#__PURE__*/React.createElement(FieldsProvider$1, {
    manager: manager
  }, children));
};
FieldsProvider.propTypes = propTypes;
FieldsProvider.defaultProps = defaultProps;

export { AdFormatField as AdFormat, AlignHorizontal, AlignVertical, Alignment, AnswerField as Answer, AnswersField as Answers, AudioField as Audio, AutocompleteField as Autocomplete, Badge, BorderRadius, BorderStyle, BorderWidth, BoxStyleForm, ButtonLayout, CallToAction, CallToActionForm, CardLayout, Checkboxes, ClosedCaptionField as ClosedCaptions, ColorField as Color, ColorPickerField as ColorPicker, ContainerStyleField as ContainerStyle, Conversation, CustomAnswer, DateField as Date, DateElement, ElementField as Element, ElementList, FieldWithForm, Fields, FieldsProvider, ObjectFitSize as Fit, FontField as Font, FontFamily, FontSize, FontStyles$1 as FontStyle, FontStyleTransform, FontStyles as FontStyleWithAlign, FontWeight, FontsField as Fonts, GeoPosition, GridLayout, ImageField as Image, ImageStyleField as ImageStyle, ImagesField as Images, ImagesWithCaptionField as ImagesWithCaption, TextElement$1 as InputElement, InputGroup, ItemsField as Items, KeypadLayout, KeypadLayoutForm, MapField as Map, MarginField as Margin, MarkerField as Marker, MarkersField as Markers, MediaField as Media, MediaModal, MediaThumbnail, MessageField as Message, NumberField as Number, NumberWithIcon, PaddingField as Padding, Position, QuestionField as Question, Radios, ScreenLayoutField as ScreenLayout, SelectField as Select, SelectAdvancedField as SelectAdvanced, ShadowAngle, ShareIncentive, ShareIncentiveForm, SlideField as Slide, SliderField as Slider, SliderPixelField$1 as SliderPercentage, SliderPixelField as SliderPixel, SliderPointField as SliderPoint, SlidesField as Slides, Spacing, StaticField, TargetField as Target, TextField$1 as Text, TextEditorField as TextEditor, TextElement, TextModal, TextStyleForm, TextTransform, TextareaField as Textarea, ToggleField as Toggle, ToggleSection, Tokens, TrueFalse, UrlField as Url, VideoField as Video, VisualField as Visual, VisualsField as Visuals, VisualsWithCaptionField as VisualsWithCaption, manager as default, manager };
